// tslint:disable
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: unspecified
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ActivityAuditTrailDto
 */
export interface ActivityAuditTrailDto {
    /**
     * 
     * @type {string}
     * @memberof ActivityAuditTrailDto
     */
    activityId?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityAuditTrailDto
     */
    activityName?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityAuditTrailDto
     */
    assignee?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityAuditTrailDto
     */
    completedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ActivityAuditTrailDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ActivityAuditTrailDto
     */
    processBusinessKey?: string;
}
/**
 * 
 * @export
 * @interface AddNewVersionRequest
 */
export interface AddNewVersionRequest {
    /**
     * 
     * @type {string}
     * @memberof AddNewVersionRequest
     */
    content?: string;
}
/**
 * 
 * @export
 * @interface AddNewVersionResponse
 */
export interface AddNewVersionResponse {
    /**
     * 
     * @type {number}
     * @memberof AddNewVersionResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof AddNewVersionResponse
     */
    versionId?: number;
}
/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    apartment?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    formattedAddress?: string;
    /**
     * 
     * @type {number}
     * @memberof Address
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    postalCode?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof Address
     */
    rawAddress?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    streetAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    updatedBy?: string;
}
/**
 * 
 * @export
 * @interface AddressBorrowerAllowed
 */
export interface AddressBorrowerAllowed {
    /**
     * 
     * @type {string}
     * @memberof AddressBorrowerAllowed
     */
    apartment?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressBorrowerAllowed
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressBorrowerAllowed
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressBorrowerAllowed
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressBorrowerAllowed
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressBorrowerAllowed
     */
    formattedAddress?: string;
    /**
     * 
     * @type {number}
     * @memberof AddressBorrowerAllowed
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AddressBorrowerAllowed
     */
    postalCode?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof AddressBorrowerAllowed
     */
    rawAddress?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof AddressBorrowerAllowed
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressBorrowerAllowed
     */
    streetAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressBorrowerAllowed
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressBorrowerAllowed
     */
    updatedBy?: string;
}
/**
 * 
 * @export
 * @interface AddressBrief
 */
export interface AddressBrief {
    /**
     * 
     * @type {string}
     * @memberof AddressBrief
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressBrief
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressBrief
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressBrief
     */
    updatedBy?: string;
}
/**
 * 
 * @export
 * @interface AddressDto
 */
export interface AddressDto {
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    apartment?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    formattedAddress?: string;
    /**
     * 
     * @type {number}
     * @memberof AddressDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    postalCode?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof AddressDto
     */
    rawAddress?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    streetAddress?: string;
}
/**
 * 
 * @export
 * @interface AddressInbound
 */
export interface AddressInbound {
    /**
     * 
     * @type {string}
     * @memberof AddressInbound
     */
    apartment?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressInbound
     */
    city: string;
    /**
     * ISO 3166-1 Alpha-2 code
     * @type {string}
     * @memberof AddressInbound
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof AddressInbound
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressInbound
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressInbound
     */
    streetAddress: string;
}
/**
 * 
 * @export
 * @interface Agent
 */
export interface Agent {
    /**
     * 
     * @type {Address}
     * @memberof Agent
     */
    address?: Address;
    /**
     * 
     * @type {BankAccount}
     * @memberof Agent
     */
    bankAccount?: BankAccount;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof Agent
     */
    contactDetails?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    email: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof Agent
     */
    extensions?: { [key: string]: object; };
    /**
     * 
     * @type {number}
     * @memberof Agent
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    legalName: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof Agent
     */
    logo?: Array<any>;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    taxNumber: string;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    website?: string;
}
/**
 * 
 * @export
 * @interface AgentBorrowerAllowed
 */
export interface AgentBorrowerAllowed {
    /**
     * 
     * @type {AddressBorrowerAllowed}
     * @memberof AgentBorrowerAllowed
     */
    address?: AddressBorrowerAllowed;
    /**
     * 
     * @type {BankAccountBorrowerAllowed}
     * @memberof AgentBorrowerAllowed
     */
    bankAccount?: BankAccountBorrowerAllowed;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof AgentBorrowerAllowed
     */
    contactDetails?: { [key: string]: object; };
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof AgentBorrowerAllowed
     */
    extensions?: { [key: string]: object; };
    /**
     * 
     * @type {Array<FileBorrowerAllowed>}
     * @memberof AgentBorrowerAllowed
     */
    logo?: Array<FileBorrowerAllowed>;
    /**
     * 
     * @type {string}
     * @memberof AgentBorrowerAllowed
     */
    taxNumber: string;
    /**
     * 
     * @type {string}
     * @memberof AgentBorrowerAllowed
     */
    website?: string;
}
/**
 * 
 * @export
 * @interface AgentBrief
 */
export interface AgentBrief {
    /**
     * 
     * @type {AddressBrief}
     * @memberof AgentBrief
     */
    address?: AddressBrief;
    /**
     * 
     * @type {BankAccountBrief}
     * @memberof AgentBrief
     */
    bankAccount?: BankAccountBrief;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof AgentBrief
     */
    contactDetails?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof AgentBrief
     */
    email: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof AgentBrief
     */
    extensions?: { [key: string]: object; };
    /**
     * 
     * @type {number}
     * @memberof AgentBrief
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentBrief
     */
    legalName: string;
    /**
     * 
     * @type {Array<FileBrief>}
     * @memberof AgentBrief
     */
    logo?: Array<FileBrief>;
    /**
     * 
     * @type {string}
     * @memberof AgentBrief
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof AgentBrief
     */
    taxNumber: string;
    /**
     * 
     * @type {string}
     * @memberof AgentBrief
     */
    website?: string;
}
/**
 * 
 * @export
 * @interface AgentDto
 */
export interface AgentDto {
    /**
     * 
     * @type {AddressDto}
     * @memberof AgentDto
     */
    address?: AddressDto;
    /**
     * 
     * @type {BankAccountDto}
     * @memberof AgentDto
     */
    bankAccount?: BankAccountDto;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof AgentDto
     */
    contactDetails?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    email?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof AgentDto
     */
    extensions?: { [key: string]: object; };
    /**
     * 
     * @type {number}
     * @memberof AgentDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    legalName?: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof AgentDto
     */
    logo?: Array<any>;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    taxNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    website?: string;
}
/**
 * 
 * @export
 * @interface AgentDtoBrief
 */
export interface AgentDtoBrief {
    /**
     * 
     * @type {object}
     * @memberof AgentDtoBrief
     */
    address?: object;
    /**
     * 
     * @type {object}
     * @memberof AgentDtoBrief
     */
    bankAccount?: object;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof AgentDtoBrief
     */
    contactDetails?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof AgentDtoBrief
     */
    email?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof AgentDtoBrief
     */
    extensions?: { [key: string]: object; };
    /**
     * 
     * @type {number}
     * @memberof AgentDtoBrief
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentDtoBrief
     */
    legalName?: string;
    /**
     * 
     * @type {Array<FileBrief>}
     * @memberof AgentDtoBrief
     */
    logo?: Array<FileBrief>;
    /**
     * 
     * @type {string}
     * @memberof AgentDtoBrief
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDtoBrief
     */
    taxNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDtoBrief
     */
    website?: string;
}
/**
 * 
 * @export
 * @interface AmortisationSchedulePeriod
 */
export interface AmortisationSchedulePeriod {
    /**
     * 
     * @type {string}
     * @memberof AmortisationSchedulePeriod
     */
    endDate?: string;
    /**
     * 
     * @type {number}
     * @memberof AmortisationSchedulePeriod
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof AmortisationSchedulePeriod
     */
    number?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AmortisationSchedulePeriod
     */
    paymentPeriod?: boolean;
}
/**
 * 
 * @export
 * @interface AmortisationScheduleSnapshotDto
 */
export interface AmortisationScheduleSnapshotDto {
    /**
     * 
     * @type {Array<object>}
     * @memberof AmortisationScheduleSnapshotDto
     */
    amortisationSchedulePeriods?: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof AmortisationScheduleSnapshotDto
     */
    date?: string;
    /**
     * 
     * @type {number}
     * @memberof AmortisationScheduleSnapshotDto
     */
    eventId?: number;
    /**
     * 
     * @type {number}
     * @memberof AmortisationScheduleSnapshotDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof AmortisationScheduleSnapshotDto
     */
    loanId?: number;
}
/**
 * 
 * @export
 * @interface AmortisationScheduleSnapshotDtoBorrowerAllowed
 */
export interface AmortisationScheduleSnapshotDtoBorrowerAllowed {
    /**
     * 
     * @type {Array<object>}
     * @memberof AmortisationScheduleSnapshotDtoBorrowerAllowed
     */
    amortisationSchedulePeriods?: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof AmortisationScheduleSnapshotDtoBorrowerAllowed
     */
    date?: string;
    /**
     * 
     * @type {number}
     * @memberof AmortisationScheduleSnapshotDtoBorrowerAllowed
     */
    eventId?: number;
    /**
     * 
     * @type {number}
     * @memberof AmortisationScheduleSnapshotDtoBorrowerAllowed
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof AmortisationScheduleSnapshotDtoBorrowerAllowed
     */
    loanId?: number;
}
/**
 * 
 * @export
 * @interface AmortisationScheduleSnapshotDtoBrief
 */
export interface AmortisationScheduleSnapshotDtoBrief {
    /**
     * 
     * @type {Array<object>}
     * @memberof AmortisationScheduleSnapshotDtoBrief
     */
    amortisationSchedulePeriods?: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof AmortisationScheduleSnapshotDtoBrief
     */
    date?: string;
    /**
     * 
     * @type {number}
     * @memberof AmortisationScheduleSnapshotDtoBrief
     */
    eventId?: number;
    /**
     * 
     * @type {number}
     * @memberof AmortisationScheduleSnapshotDtoBrief
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof AmortisationScheduleSnapshotDtoBrief
     */
    loanId?: number;
}
/**
 * 
 * @export
 * @interface ApplicationForm
 */
export interface ApplicationForm {
    /**
     * 
     * @type {Array<object>}
     * @memberof ApplicationForm
     */
    collateralForm?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof ApplicationForm
     */
    furtherInformationForm?: Array<object>;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationForm
     */
    hasBalanceSheet?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationForm
     */
    hasBankStatement?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationForm
     */
    hasCollateral?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationForm
     */
    hasFinancialStatement?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationForm
     */
    hasFurtherInformation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationForm
     */
    hasPnlStatement?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationForm
     */
    hasPurpose?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationForm
     */
    hasSupportingDocuments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationForm
     */
    hasUtilityBill?: boolean;
}
/**
 * 
 * @export
 * @interface ApplicationFormBorrowerAllowed
 */
export interface ApplicationFormBorrowerAllowed {
    /**
     * 
     * @type {Array<object>}
     * @memberof ApplicationFormBorrowerAllowed
     */
    collateralForm?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof ApplicationFormBorrowerAllowed
     */
    furtherInformationForm?: Array<object>;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationFormBorrowerAllowed
     */
    hasBalanceSheet?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationFormBorrowerAllowed
     */
    hasBankStatement?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationFormBorrowerAllowed
     */
    hasCollateral?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationFormBorrowerAllowed
     */
    hasFinancialStatement?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationFormBorrowerAllowed
     */
    hasFurtherInformation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationFormBorrowerAllowed
     */
    hasPnlStatement?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationFormBorrowerAllowed
     */
    hasPurpose?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationFormBorrowerAllowed
     */
    hasUtilityBill?: boolean;
}
/**
 * 
 * @export
 * @interface BankAccount
 */
export interface BankAccount {
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    accountHolderName?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    accountNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    bankTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    branch?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    iban?: string;
    /**
     * 
     * @type {number}
     * @memberof BankAccount
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    routingNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    sortCode?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    updatedBy?: string;
}
/**
 * 
 * @export
 * @interface BankAccountBorrowerAllowed
 */
export interface BankAccountBorrowerAllowed {
    /**
     * 
     * @type {string}
     * @memberof BankAccountBorrowerAllowed
     */
    accountHolderName?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountBorrowerAllowed
     */
    accountNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountBorrowerAllowed
     */
    bankTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountBorrowerAllowed
     */
    branch?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountBorrowerAllowed
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountBorrowerAllowed
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountBorrowerAllowed
     */
    iban?: string;
    /**
     * 
     * @type {number}
     * @memberof BankAccountBorrowerAllowed
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof BankAccountBorrowerAllowed
     */
    routingNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountBorrowerAllowed
     */
    sortCode?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountBorrowerAllowed
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountBorrowerAllowed
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountBorrowerAllowed
     */
    updatedBy?: string;
}
/**
 * 
 * @export
 * @interface BankAccountBrief
 */
export interface BankAccountBrief {
    /**
     * 
     * @type {string}
     * @memberof BankAccountBrief
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountBrief
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountBrief
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountBrief
     */
    updatedBy?: string;
}
/**
 * 
 * @export
 * @interface BankAccountDto
 */
export interface BankAccountDto {
    /**
     * 
     * @type {string}
     * @memberof BankAccountDto
     */
    accountHolderName?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDto
     */
    accountNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDto
     */
    bankTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDto
     */
    branch?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDto
     */
    iban?: string;
    /**
     * 
     * @type {number}
     * @memberof BankAccountDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDto
     */
    routingNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDto
     */
    sortCode?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDto
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface BankAccountDtoBorrowerAllowed
 */
export interface BankAccountDtoBorrowerAllowed {
    /**
     * 
     * @type {string}
     * @memberof BankAccountDtoBorrowerAllowed
     */
    accountHolderName?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDtoBorrowerAllowed
     */
    accountNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDtoBorrowerAllowed
     */
    bankTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDtoBorrowerAllowed
     */
    branch?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDtoBorrowerAllowed
     */
    iban?: string;
    /**
     * 
     * @type {number}
     * @memberof BankAccountDtoBorrowerAllowed
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDtoBorrowerAllowed
     */
    routingNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDtoBorrowerAllowed
     */
    sortCode?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDtoBorrowerAllowed
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface BankAccountInbound
 */
export interface BankAccountInbound {
    /**
     * 
     * @type {string}
     * @memberof BankAccountInbound
     */
    accountNumber: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountInbound
     */
    bankTitle?: string;
}
/**
 * 
 * @export
 * @interface Borrower
 */
export interface Borrower {
    /**
     * 
     * @type {Address}
     * @memberof Borrower
     */
    address?: Address;
    /**
     * 
     * @type {BankAccount}
     * @memberof Borrower
     */
    bankAccount?: BankAccount;
    /**
     * 
     * @type {boolean}
     * @memberof Borrower
     */
    blacklisted: boolean;
    /**
     * 
     * @type {string}
     * @memberof Borrower
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Borrower
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof Borrower
     */
    email?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof Borrower
     */
    extensions?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof Borrower
     */
    fullName?: string;
    /**
     * 
     * @type {number}
     * @memberof Borrower
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Borrower
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof Borrower
     */
    taxNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Borrower
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof Borrower
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Borrower
     */
    updatedBy?: string;
}
/**
 * 
 * @export
 * @interface BorrowerDto
 */
export interface BorrowerDto {
    /**
     * 
     * @type {string}
     * @memberof BorrowerDto
     */
    type: string;
}
/**
 * 
 * @export
 * @interface BorrowerDtoBorrowerAllowed
 */
export interface BorrowerDtoBorrowerAllowed {
    /**
     * 
     * @type {string}
     * @memberof BorrowerDtoBorrowerAllowed
     */
    type: string;
}
/**
 * 
 * @export
 * @interface BorrowerDtoBrief
 */
export interface BorrowerDtoBrief {
    /**
     * 
     * @type {string}
     * @memberof BorrowerDtoBrief
     */
    type: string;
}
/**
 * Borrower details
 * @export
 * @interface BorrowerLoanManagement
 */
export interface BorrowerLoanManagement {
    /**
     * 
     * @type {AddressInbound}
     * @memberof BorrowerLoanManagement
     */
    address: AddressInbound;
    /**
     * 
     * @type {BankAccountInbound}
     * @memberof BorrowerLoanManagement
     */
    bankAccount: BankAccountInbound;
    /**
     * 
     * @type {string}
     * @memberof BorrowerLoanManagement
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerLoanManagement
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerLoanManagement
     */
    taxNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerLoanManagement
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface BorrowerRevisionDto
 */
export interface BorrowerRevisionDto {
    /**
     * 
     * @type {BorrowerDto}
     * @memberof BorrowerRevisionDto
     */
    borrower?: BorrowerDto;
    /**
     * 
     * @type {string}
     * @memberof BorrowerRevisionDto
     */
    revisionDate?: string;
    /**
     * 
     * @type {number}
     * @memberof BorrowerRevisionDto
     */
    revisionNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof BorrowerRevisionDto
     */
    revisionType?: BorrowerRevisionDtoRevisionTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum BorrowerRevisionDtoRevisionTypeEnum {
    UNKNOWN = 'UNKNOWN',
    INSERT = 'INSERT',
    UPDATE = 'UPDATE',
    DELETE = 'DELETE'
}

/**
 * 
 * @export
 * @interface BulkRetryIncidentsResponse
 */
export interface BulkRetryIncidentsResponse {
    /**
     * 
     * @type {number}
     * @memberof BulkRetryIncidentsResponse
     */
    attemptToRetryQty?: number;
}
/**
 * 
 * @export
 * @interface CallResultDto
 */
export interface CallResultDto {
    /**
     * 
     * @type {number}
     * @memberof CallResultDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof CallResultDto
     */
    author?: string;
    /**
     * 
     * @type {string}
     * @memberof CallResultDto
     */
    calledAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CallResultDto
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof CallResultDto
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof CallResultDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CallResultDto
     */
    nextReminderDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CallResultDto
     */
    promiseToPayDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CallResultDto
     */
    result?: string;
}
/**
 * 
 * @export
 * @interface Campaign
 */
export interface Campaign {
    /**
     * 
     * @type {boolean}
     * @memberof Campaign
     */
    active?: boolean;
    /**
     * 
     * @type {Array<Agent>}
     * @memberof Campaign
     */
    agents?: Array<Agent>;
    /**
     * 
     * @type {ApplicationForm}
     * @memberof Campaign
     */
    applicationForm?: ApplicationForm;
    /**
     * 
     * @type {string}
     * @memberof Campaign
     */
    calculationType?: string;
    /**
     * 
     * @type {string}
     * @memberof Campaign
     */
    collectionStrategy: string;
    /**
     * 
     * @type {string}
     * @memberof Campaign
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Campaign
     */
    createdBy?: string;
    /**
     * 
     * @type {number}
     * @memberof Campaign
     */
    daysOverdue?: number;
    /**
     * 
     * @type {string}
     * @memberof Campaign
     */
    disbursementOption: string;
    /**
     * 
     * @type {DocumentTemplate}
     * @memberof Campaign
     */
    documentTemplate?: DocumentTemplate;
    /**
     * 
     * @type {string}
     * @memberof Campaign
     */
    giniMachineScoringModel?: string;
    /**
     * 
     * @type {number}
     * @memberof Campaign
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Campaign
     */
    interestRateType: CampaignInterestRateTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Campaign
     */
    name?: string;
    /**
     * 
     * @type {CampaignParameters}
     * @memberof Campaign
     */
    parameters?: CampaignParameters;
    /**
     * 
     * @type {Array<string>}
     * @memberof Campaign
     */
    paymentFrequency?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof Campaign
     */
    rangeOfDaysForFirstPaymentDate?: number;
    /**
     * 
     * @type {string}
     * @memberof Campaign
     */
    scoringModel?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Campaign
     */
    scoringProviders?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Campaign
     */
    signingOption?: string;
    /**
     * A date-based amount of time in the ISO-8601 calendar system.
     * @type {string}
     * @memberof Campaign
     */
    termPeriodType?: string;
    /**
     * 
     * @type {string}
     * @memberof Campaign
     */
    underwritingDecisionMaking: string;
    /**
     * 
     * @type {string}
     * @memberof Campaign
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Campaign
     */
    updatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof Campaign
     */
    verificationDecisionMaking: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CampaignInterestRateTypeEnum {
    FIXED = 'FIXED',
    FLOATING = 'FLOATING'
}

/**
 * 
 * @export
 * @interface CampaignDto
 */
export interface CampaignDto {
    /**
     * 
     * @type {boolean}
     * @memberof CampaignDto
     */
    active?: boolean;
    /**
     * 
     * @type {Array<Agent>}
     * @memberof CampaignDto
     */
    agents?: Array<Agent>;
    /**
     * 
     * @type {ApplicationForm}
     * @memberof CampaignDto
     */
    applicationForm?: ApplicationForm;
    /**
     * 
     * @type {string}
     * @memberof CampaignDto
     */
    calculationType?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignDto
     */
    collectionStrategy?: string;
    /**
     * 
     * @type {number}
     * @memberof CampaignDto
     */
    daysOverdue?: number;
    /**
     * 
     * @type {string}
     * @memberof CampaignDto
     */
    disbursementOption?: string;
    /**
     * 
     * @type {DocumentTemplateDto}
     * @memberof CampaignDto
     */
    documentTemplate?: DocumentTemplateDto;
    /**
     * 
     * @type {string}
     * @memberof CampaignDto
     */
    giniMachineScoringModel?: string;
    /**
     * 
     * @type {number}
     * @memberof CampaignDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CampaignDto
     */
    interestRateType?: CampaignDtoInterestRateTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CampaignDto
     */
    name?: string;
    /**
     * 
     * @type {CampaignParameters}
     * @memberof CampaignDto
     */
    parameters?: CampaignParameters;
    /**
     * 
     * @type {Array<CampaignDtoPaymentFrequency>}
     * @memberof CampaignDto
     */
    paymentFrequency?: Array<CampaignDtoPaymentFrequency>;
    /**
     * 
     * @type {number}
     * @memberof CampaignDto
     */
    rangeOfDaysForFirstPaymentDate?: number;
    /**
     * 
     * @type {string}
     * @memberof CampaignDto
     */
    scoringModel?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CampaignDto
     */
    scoringProviders?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CampaignDto
     */
    signingOption?: string;
    /**
     * 
     * @type {CampaignDtoPaymentFrequency}
     * @memberof CampaignDto
     */
    termPeriodType?: CampaignDtoPaymentFrequency;
    /**
     * 
     * @type {string}
     * @memberof CampaignDto
     */
    underwritingDecisionMaking?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignDto
     */
    verificationDecisionMaking?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CampaignDtoInterestRateTypeEnum {
    FIXED = 'FIXED',
    FLOATING = 'FLOATING'
}

/**
 * 
 * @export
 * @interface CampaignDtoBorrowerAllowed
 */
export interface CampaignDtoBorrowerAllowed {
    /**
     * 
     * @type {boolean}
     * @memberof CampaignDtoBorrowerAllowed
     */
    active?: boolean;
    /**
     * 
     * @type {Array<AgentBorrowerAllowed>}
     * @memberof CampaignDtoBorrowerAllowed
     */
    agents?: Array<AgentBorrowerAllowed>;
    /**
     * 
     * @type {ApplicationFormBorrowerAllowed}
     * @memberof CampaignDtoBorrowerAllowed
     */
    applicationForm?: ApplicationFormBorrowerAllowed;
    /**
     * 
     * @type {string}
     * @memberof CampaignDtoBorrowerAllowed
     */
    calculationType?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignDtoBorrowerAllowed
     */
    collectionStrategy?: string;
    /**
     * 
     * @type {number}
     * @memberof CampaignDtoBorrowerAllowed
     */
    daysOverdue?: number;
    /**
     * 
     * @type {string}
     * @memberof CampaignDtoBorrowerAllowed
     */
    disbursementOption?: string;
    /**
     * 
     * @type {DocumentTemplateDtoBorrowerAllowed}
     * @memberof CampaignDtoBorrowerAllowed
     */
    documentTemplate?: DocumentTemplateDtoBorrowerAllowed;
    /**
     * 
     * @type {string}
     * @memberof CampaignDtoBorrowerAllowed
     */
    giniMachineScoringModel?: string;
    /**
     * 
     * @type {number}
     * @memberof CampaignDtoBorrowerAllowed
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CampaignDtoBorrowerAllowed
     */
    interestRateType?: CampaignDtoBorrowerAllowedInterestRateTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CampaignDtoBorrowerAllowed
     */
    name?: string;
    /**
     * 
     * @type {CampaignParametersBorrowerAllowed}
     * @memberof CampaignDtoBorrowerAllowed
     */
    parameters?: CampaignParametersBorrowerAllowed;
    /**
     * 
     * @type {Array<CampaignDtoPaymentFrequency>}
     * @memberof CampaignDtoBorrowerAllowed
     */
    paymentFrequency?: Array<CampaignDtoPaymentFrequency>;
    /**
     * 
     * @type {number}
     * @memberof CampaignDtoBorrowerAllowed
     */
    rangeOfDaysForFirstPaymentDate?: number;
    /**
     * 
     * @type {string}
     * @memberof CampaignDtoBorrowerAllowed
     */
    scoringModel?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CampaignDtoBorrowerAllowed
     */
    scoringProviders?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CampaignDtoBorrowerAllowed
     */
    signingOption?: string;
    /**
     * 
     * @type {CampaignDtoPaymentFrequency}
     * @memberof CampaignDtoBorrowerAllowed
     */
    termPeriodType?: CampaignDtoPaymentFrequency;
    /**
     * 
     * @type {string}
     * @memberof CampaignDtoBorrowerAllowed
     */
    underwritingDecisionMaking?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignDtoBorrowerAllowed
     */
    verificationDecisionMaking?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CampaignDtoBorrowerAllowedInterestRateTypeEnum {
    FIXED = 'FIXED',
    FLOATING = 'FLOATING'
}

/**
 * 
 * @export
 * @interface CampaignDtoBrief
 */
export interface CampaignDtoBrief {
    /**
     * 
     * @type {boolean}
     * @memberof CampaignDtoBrief
     */
    active?: boolean;
    /**
     * 
     * @type {Array<AgentBrief>}
     * @memberof CampaignDtoBrief
     */
    agents?: Array<AgentBrief>;
    /**
     * 
     * @type {string}
     * @memberof CampaignDtoBrief
     */
    calculationType?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignDtoBrief
     */
    collectionStrategy?: string;
    /**
     * 
     * @type {number}
     * @memberof CampaignDtoBrief
     */
    daysOverdue?: number;
    /**
     * 
     * @type {string}
     * @memberof CampaignDtoBrief
     */
    disbursementOption?: string;
    /**
     * 
     * @type {DocumentTemplateDtoBrief}
     * @memberof CampaignDtoBrief
     */
    documentTemplate?: DocumentTemplateDtoBrief;
    /**
     * 
     * @type {string}
     * @memberof CampaignDtoBrief
     */
    giniMachineScoringModel?: string;
    /**
     * 
     * @type {number}
     * @memberof CampaignDtoBrief
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CampaignDtoBrief
     */
    name?: string;
    /**
     * 
     * @type {CampaignParametersBrief}
     * @memberof CampaignDtoBrief
     */
    parameters?: CampaignParametersBrief;
    /**
     * 
     * @type {Array<CampaignDtoPaymentFrequency>}
     * @memberof CampaignDtoBrief
     */
    paymentFrequency?: Array<CampaignDtoPaymentFrequency>;
    /**
     * 
     * @type {number}
     * @memberof CampaignDtoBrief
     */
    rangeOfDaysForFirstPaymentDate?: number;
    /**
     * 
     * @type {string}
     * @memberof CampaignDtoBrief
     */
    scoringModel?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CampaignDtoBrief
     */
    scoringProviders?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CampaignDtoBrief
     */
    signingOption?: string;
    /**
     * 
     * @type {CampaignDtoPaymentFrequency}
     * @memberof CampaignDtoBrief
     */
    termPeriodType?: CampaignDtoPaymentFrequency;
    /**
     * 
     * @type {string}
     * @memberof CampaignDtoBrief
     */
    underwritingDecisionMaking?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignDtoBrief
     */
    verificationDecisionMaking?: string;
}
/**
 * 
 * @export
 * @interface CampaignDtoChronology
 */
export interface CampaignDtoChronology {
    /**
     * 
     * @type {string}
     * @memberof CampaignDtoChronology
     */
    calendarType?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignDtoChronology
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignDtoChronology
     */
    isoBased?: boolean;
}
/**
 * 
 * @export
 * @interface CampaignDtoDuration
 */
export interface CampaignDtoDuration {
    /**
     * 
     * @type {number}
     * @memberof CampaignDtoDuration
     */
    nano?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignDtoDuration
     */
    negative?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignDtoDuration
     */
    positive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CampaignDtoDuration
     */
    seconds?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignDtoDuration
     */
    zero?: boolean;
}
/**
 * 
 * @export
 * @interface CampaignDtoPaymentFrequency
 */
export interface CampaignDtoPaymentFrequency {
    /**
     * 
     * @type {CampaignDtoChronology}
     * @memberof CampaignDtoPaymentFrequency
     */
    chronology?: CampaignDtoChronology;
    /**
     * 
     * @type {number}
     * @memberof CampaignDtoPaymentFrequency
     */
    days?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignDtoPaymentFrequency
     */
    months?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignDtoPaymentFrequency
     */
    negative?: boolean;
    /**
     * 
     * @type {Array<CampaignDtoUnits>}
     * @memberof CampaignDtoPaymentFrequency
     */
    units?: Array<CampaignDtoUnits>;
    /**
     * 
     * @type {number}
     * @memberof CampaignDtoPaymentFrequency
     */
    years?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignDtoPaymentFrequency
     */
    zero?: boolean;
}
/**
 * 
 * @export
 * @interface CampaignDtoUnits
 */
export interface CampaignDtoUnits {
    /**
     * 
     * @type {boolean}
     * @memberof CampaignDtoUnits
     */
    dateBased?: boolean;
    /**
     * 
     * @type {CampaignDtoDuration}
     * @memberof CampaignDtoUnits
     */
    duration?: CampaignDtoDuration;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignDtoUnits
     */
    durationEstimated?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignDtoUnits
     */
    timeBased?: boolean;
}
/**
 * 
 * @export
 * @interface CampaignParameters
 */
export interface CampaignParameters {
    /**
     * 
     * @type {number}
     * @memberof CampaignParameters
     */
    amountSelectionStep: number;
    /**
     * A date-based amount of time in the ISO-8601 calendar system.
     * @type {string}
     * @memberof CampaignParameters
     */
    defaultPaymentFrequency?: string;
    /**
     * 
     * @type {number}
     * @memberof CampaignParameters
     */
    interestRatePct: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignParameters
     */
    marginPct?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignParameters
     */
    maxAmount: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignParameters
     */
    maxTerm: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignParameters
     */
    minAmount: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignParameters
     */
    minTerm: number;
    /**
     * 
     * @type {Array<TermOption>}
     * @memberof CampaignParameters
     */
    termOptions?: Array<TermOption>;
    /**
     * 
     * @type {string}
     * @memberof CampaignParameters
     */
    termSelectionMode: string;
}
/**
 * 
 * @export
 * @interface CampaignParametersBorrowerAllowed
 */
export interface CampaignParametersBorrowerAllowed {
    /**
     * 
     * @type {number}
     * @memberof CampaignParametersBorrowerAllowed
     */
    amountSelectionStep?: number;
    /**
     * 
     * @type {CampaignDtoPaymentFrequency}
     * @memberof CampaignParametersBorrowerAllowed
     */
    defaultPaymentFrequency?: CampaignDtoPaymentFrequency;
    /**
     * 
     * @type {Array<TermOptionDtoBorrowerAllowed>}
     * @memberof CampaignParametersBorrowerAllowed
     */
    termOptions?: Array<TermOptionDtoBorrowerAllowed>;
    /**
     * 
     * @type {string}
     * @memberof CampaignParametersBorrowerAllowed
     */
    termSelectionMode?: string;
}
/**
 * 
 * @export
 * @interface CampaignParametersBrief
 */
export interface CampaignParametersBrief {
    /**
     * 
     * @type {number}
     * @memberof CampaignParametersBrief
     */
    amountSelectionStep?: number;
    /**
     * 
     * @type {CampaignDtoPaymentFrequency}
     * @memberof CampaignParametersBrief
     */
    defaultPaymentFrequency?: CampaignDtoPaymentFrequency;
    /**
     * 
     * @type {number}
     * @memberof CampaignParametersBrief
     */
    interestRatePct?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignParametersBrief
     */
    marginPct?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignParametersBrief
     */
    maxAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignParametersBrief
     */
    maxTerm?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignParametersBrief
     */
    minAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CampaignParametersBrief
     */
    minTerm?: number;
    /**
     * 
     * @type {Array<TermOptionDtoBrief>}
     * @memberof CampaignParametersBrief
     */
    termOptions?: Array<TermOptionDtoBrief>;
    /**
     * 
     * @type {string}
     * @memberof CampaignParametersBrief
     */
    termSelectionMode?: string;
}
/**
 * 
 * @export
 * @interface Collateral
 */
export interface Collateral {
    /**
     * 
     * @type {number}
     * @memberof Collateral
     */
    id?: number;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof Collateral
     */
    item?: { [key: string]: object; };
    /**
     * 
     * @type {number}
     * @memberof Collateral
     */
    value?: number;
}
/**
 * 
 * @export
 * @interface CollateralDto
 */
export interface CollateralDto {
    /**
     * 
     * @type {number}
     * @memberof CollateralDto
     */
    id?: number;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof CollateralDto
     */
    item?: { [key: string]: object; };
    /**
     * 
     * @type {number}
     * @memberof CollateralDto
     */
    value?: number;
}
/**
 * 
 * @export
 * @interface CollateralDtoBorrowerAllowed
 */
export interface CollateralDtoBorrowerAllowed {
    /**
     * 
     * @type {number}
     * @memberof CollateralDtoBorrowerAllowed
     */
    id?: number;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof CollateralDtoBorrowerAllowed
     */
    item?: { [key: string]: object; };
    /**
     * 
     * @type {number}
     * @memberof CollateralDtoBorrowerAllowed
     */
    value?: number;
}
/**
 * 
 * @export
 * @interface CollectionDto
 */
export interface CollectionDto {
    /**
     * 
     * @type {Array<CallResultDto>}
     * @memberof CollectionDto
     */
    callResults?: Array<CallResultDto>;
    /**
     * 
     * @type {number}
     * @memberof CollectionDto
     */
    id?: number;
    /**
     * 
     * @type {LoanDto}
     * @memberof CollectionDto
     */
    loan?: LoanDto;
    /**
     * 
     * @type {string}
     * @memberof CollectionDto
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionDto
     */
    promiseToPayDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionDto
     */
    startedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionDto
     */
    status?: string;
}
/**
 * 
 * @export
 * @interface CollectionItemDtoBrief
 */
export interface CollectionItemDtoBrief {
    /**
     * 
     * @type {string}
     * @memberof CollectionItemDtoBrief
     */
    borrowerFullName?: string;
    /**
     * 
     * @type {number}
     * @memberof CollectionItemDtoBrief
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CollectionItemDtoBrief
     */
    number?: string;
    /**
     * 
     * @type {number}
     * @memberof CollectionItemDtoBrief
     */
    outstandingBalance?: number;
    /**
     * 
     * @type {string}
     * @memberof CollectionItemDtoBrief
     */
    startedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionItemDtoBrief
     */
    status?: string;
}
/**
 * 
 * @export
 * @interface CreateAgentRequest
 */
export interface CreateAgentRequest {
    /**
     * 
     * @type {AddressDto}
     * @memberof CreateAgentRequest
     */
    address?: AddressDto;
    /**
     * 
     * @type {BankAccountDto}
     * @memberof CreateAgentRequest
     */
    bankAccount?: BankAccountDto;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof CreateAgentRequest
     */
    contactDetails?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof CreateAgentRequest
     */
    email: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof CreateAgentRequest
     */
    extensions?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof CreateAgentRequest
     */
    legalName: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof CreateAgentRequest
     */
    logo?: Array<any>;
    /**
     * 
     * @type {string}
     * @memberof CreateAgentRequest
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAgentRequest
     */
    taxNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAgentRequest
     */
    website?: string;
}
/**
 * 
 * @export
 * @interface CreateCampaignRequest
 */
export interface CreateCampaignRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CreateCampaignRequest
     */
    active?: boolean;
    /**
     * 
     * @type {Array<Agent>}
     * @memberof CreateCampaignRequest
     */
    agents?: Array<Agent>;
    /**
     * 
     * @type {ApplicationForm}
     * @memberof CreateCampaignRequest
     */
    applicationForm?: ApplicationForm;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignRequest
     */
    calculationType?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignRequest
     */
    collectionStrategy: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCampaignRequest
     */
    daysOverdue?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignRequest
     */
    disbursementOption: string;
    /**
     * 
     * @type {DocumentTemplateDto}
     * @memberof CreateCampaignRequest
     */
    documentTemplate: DocumentTemplateDto;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignRequest
     */
    giniMachineScoringModel?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignRequest
     */
    interestRateType: CreateCampaignRequestInterestRateTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignRequest
     */
    name?: string;
    /**
     * 
     * @type {CampaignParameters}
     * @memberof CreateCampaignRequest
     */
    parameters?: CampaignParameters;
    /**
     * 
     * @type {Array<CampaignDtoPaymentFrequency>}
     * @memberof CreateCampaignRequest
     */
    paymentFrequency?: Array<CampaignDtoPaymentFrequency>;
    /**
     * 
     * @type {number}
     * @memberof CreateCampaignRequest
     */
    rangeOfDaysForFirstPaymentDate?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignRequest
     */
    scoringModel?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCampaignRequest
     */
    scoringProviders?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignRequest
     */
    signingOption?: string;
    /**
     * 
     * @type {CampaignDtoPaymentFrequency}
     * @memberof CreateCampaignRequest
     */
    termPeriodType?: CampaignDtoPaymentFrequency;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignRequest
     */
    underwritingDecisionMaking: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignRequest
     */
    verificationDecisionMaking: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateCampaignRequestInterestRateTypeEnum {
    FIXED = 'FIXED',
    FLOATING = 'FLOATING'
}

/**
 * 
 * @export
 * @interface CreateLeadRequest
 */
export interface CreateLeadRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateLeadRequest
     */
    agentId?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadRequest
     */
    phone: string;
}
/**
 * 
 * @export
 * @interface CreateLoanProductRequest
 */
export interface CreateLoanProductRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CreateLoanProductRequest
     */
    active: boolean;
    /**
     * 
     * @type {CampaignDto}
     * @memberof CreateLoanProductRequest
     */
    campaign: CampaignDto;
    /**
     * 
     * @type {string}
     * @memberof CreateLoanProductRequest
     */
    code: string;
    /**
     * 
     * @type {number}
     * @memberof CreateLoanProductRequest
     */
    defaultInterestRatePct: number;
    /**
     * 
     * @type {string}
     * @memberof CreateLoanProductRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateLoanProductRequest
     */
    earlyRepaymentFeeRatePct: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLoanProductRequest
     */
    establishmentFee?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLoanProductRequest
     */
    graceInterestRatePct: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLoanProductRequest
     */
    gracePeriodDays?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLoanProductRequest
     */
    maxAmount: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLoanProductRequest
     */
    maxInterestRatePct: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLoanProductRequest
     */
    maxMarginPct?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLoanProductRequest
     */
    maxTerm?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLoanProductRequest
     */
    minAmount: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLoanProductRequest
     */
    minInterestRatePct: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLoanProductRequest
     */
    minMarginPct?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLoanProductRequest
     */
    minTerm?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLoanProductRequest
     */
    overduePenalty: number;
    /**
     * 
     * @type {CampaignDtoPaymentFrequency}
     * @memberof CreateLoanProductRequest
     */
    paymentFrequency?: CampaignDtoPaymentFrequency;
    /**
     * 
     * @type {number}
     * @memberof CreateLoanProductRequest
     */
    serviceFeeRatePct?: number;
}
/**
 * 
 * @export
 * @interface Dashboard
 */
export interface Dashboard {
    /**
     * 
     * @type {number}
     * @memberof Dashboard
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Dashboard
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface DashboardsResponse
 */
export interface DashboardsResponse {
    /**
     * 
     * @type {Array<Dashboard>}
     * @memberof DashboardsResponse
     */
    dashboards?: Array<Dashboard>;
}
/**
 * 
 * @export
 * @interface DeploymentRepresentation
 */
export interface DeploymentRepresentation {
    /**
     * 
     * @type {string}
     * @memberof DeploymentRepresentation
     */
    deploymentTime: string;
    /**
     * 
     * @type {string}
     * @memberof DeploymentRepresentation
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DeploymentRepresentation
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DeploymentRepresentation
     */
    source: string;
    /**
     * 
     * @type {string}
     * @memberof DeploymentRepresentation
     */
    tenantId?: string;
}
/**
 * 
 * @export
 * @interface DocumentTemplate
 */
export interface DocumentTemplate {
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplate
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplate
     */
    createdBy?: string;
    /**
     * 
     * @type {any}
     * @memberof DocumentTemplate
     */
    file?: any;
    /**
     * 
     * @type {number}
     * @memberof DocumentTemplate
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplate
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplate
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplate
     */
    updatedBy?: string;
}
/**
 * 
 * @export
 * @interface DocumentTemplateDto
 */
export interface DocumentTemplateDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentTemplateDto
     */
    campaignNames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {FileDto}
     * @memberof DocumentTemplateDto
     */
    file?: FileDto;
    /**
     * 
     * @type {number}
     * @memberof DocumentTemplateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateDto
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface DocumentTemplateDtoBorrowerAllowed
 */
export interface DocumentTemplateDtoBorrowerAllowed {
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentTemplateDtoBorrowerAllowed
     */
    campaignNames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateDtoBorrowerAllowed
     */
    createdAt?: string;
    /**
     * 
     * @type {FileDtoBorrowerAllowed}
     * @memberof DocumentTemplateDtoBorrowerAllowed
     */
    file?: FileDtoBorrowerAllowed;
    /**
     * 
     * @type {number}
     * @memberof DocumentTemplateDtoBorrowerAllowed
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateDtoBorrowerAllowed
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateDtoBorrowerAllowed
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface DocumentTemplateDtoBrief
 */
export interface DocumentTemplateDtoBrief {
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentTemplateDtoBrief
     */
    campaignNames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateDtoBrief
     */
    createdAt?: string;
    /**
     * 
     * @type {FileDtoBrief}
     * @memberof DocumentTemplateDtoBrief
     */
    file?: FileDtoBrief;
    /**
     * 
     * @type {number}
     * @memberof DocumentTemplateDtoBrief
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateDtoBrief
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateDtoBrief
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface EmbedDashboardResponse
 */
export interface EmbedDashboardResponse {
    /**
     * 
     * @type {string}
     * @memberof EmbedDashboardResponse
     */
    url?: string;
}
/**
 * 
 * @export
 * @interface FileBorrowerAllowed
 */
export interface FileBorrowerAllowed {
    /**
     * 
     * @type {boolean}
     * @memberof FileBorrowerAllowed
     */
    attached?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FileBorrowerAllowed
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof FileBorrowerAllowed
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof FileBorrowerAllowed
     */
    originalName?: string;
    /**
     * 
     * @type {string}
     * @memberof FileBorrowerAllowed
     */
    storage?: string;
    /**
     * 
     * @type {string}
     * @memberof FileBorrowerAllowed
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof FileBorrowerAllowed
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof FileBorrowerAllowed
     */
    uuid?: string;
}
/**
 * 
 * @export
 * @interface FileBrief
 */
export interface FileBrief {
    /**
     * 
     * @type {boolean}
     * @memberof FileBrief
     */
    attached?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FileBrief
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof FileBrief
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof FileBrief
     */
    originalName?: string;
    /**
     * 
     * @type {string}
     * @memberof FileBrief
     */
    storage?: string;
    /**
     * 
     * @type {string}
     * @memberof FileBrief
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof FileBrief
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof FileBrief
     */
    uuid?: string;
}
/**
 * 
 * @export
 * @interface FileDto
 */
export interface FileDto {
    /**
     * 
     * @type {number}
     * @memberof FileDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof FileDto
     */
    originalName?: string;
    /**
     * 
     * @type {string}
     * @memberof FileDto
     */
    storage?: string;
    /**
     * 
     * @type {string}
     * @memberof FileDto
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof FileDto
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof FileDto
     */
    uuid?: string;
}
/**
 * 
 * @export
 * @interface FileDtoBorrowerAllowed
 */
export interface FileDtoBorrowerAllowed {
    /**
     * 
     * @type {number}
     * @memberof FileDtoBorrowerAllowed
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof FileDtoBorrowerAllowed
     */
    originalName?: string;
    /**
     * 
     * @type {string}
     * @memberof FileDtoBorrowerAllowed
     */
    storage?: string;
    /**
     * 
     * @type {string}
     * @memberof FileDtoBorrowerAllowed
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof FileDtoBorrowerAllowed
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof FileDtoBorrowerAllowed
     */
    uuid?: string;
}
/**
 * 
 * @export
 * @interface FileDtoBrief
 */
export interface FileDtoBrief {
    /**
     * 
     * @type {number}
     * @memberof FileDtoBrief
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof FileDtoBrief
     */
    originalName?: string;
    /**
     * 
     * @type {string}
     * @memberof FileDtoBrief
     */
    storage?: string;
    /**
     * 
     * @type {string}
     * @memberof FileDtoBrief
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof FileDtoBrief
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof FileDtoBrief
     */
    uuid?: string;
}
/**
 * 
 * @export
 * @interface FileUploadResponse
 */
export interface FileUploadResponse {
    /**
     * 
     * @type {FileDto}
     * @memberof FileUploadResponse
     */
    file?: FileDto;
}
/**
 * 
 * @export
 * @interface FinancialFigures
 */
export interface FinancialFigures {
    /**
     * 
     * @type {number}
     * @memberof FinancialFigures
     */
    ebitda: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFigures
     */
    grossProfit: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFigures
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFigures
     */
    netDebt: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFigures
     */
    netIncome: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFigures
     */
    operatingProfit: number;
    /**
     * 
     * @type {ProfitabilityRatios}
     * @memberof FinancialFigures
     */
    profitabilityRatios?: ProfitabilityRatios;
    /**
     * 
     * @type {number}
     * @memberof FinancialFigures
     */
    revenue: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFigures
     */
    totalAssets: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFigures
     */
    totalLiabilities: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFigures
     */
    totalSales: number;
}
/**
 * 
 * @export
 * @interface FinancialFiguresDto
 */
export interface FinancialFiguresDto {
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDto
     */
    ebitda?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDto
     */
    grossProfit?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDto
     */
    netDebt?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDto
     */
    netIncome?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDto
     */
    operatingProfit?: number;
    /**
     * 
     * @type {ProfitabilityRatiosDto}
     * @memberof FinancialFiguresDto
     */
    profitabilityRatios?: ProfitabilityRatiosDto;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDto
     */
    revenue?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDto
     */
    totalAssets?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDto
     */
    totalLiabilities?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDto
     */
    totalSales?: number;
}
/**
 * 
 * @export
 * @interface FinancialFiguresDtoBorrowerAllowed
 */
export interface FinancialFiguresDtoBorrowerAllowed {
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDtoBorrowerAllowed
     */
    ebitda?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDtoBorrowerAllowed
     */
    grossProfit?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDtoBorrowerAllowed
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDtoBorrowerAllowed
     */
    netDebt?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDtoBorrowerAllowed
     */
    netIncome?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDtoBorrowerAllowed
     */
    operatingProfit?: number;
    /**
     * 
     * @type {ProfitabilityRatiosDtoBorrowerAllowed}
     * @memberof FinancialFiguresDtoBorrowerAllowed
     */
    profitabilityRatios?: ProfitabilityRatiosDtoBorrowerAllowed;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDtoBorrowerAllowed
     */
    revenue?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDtoBorrowerAllowed
     */
    totalAssets?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDtoBorrowerAllowed
     */
    totalLiabilities?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDtoBorrowerAllowed
     */
    totalSales?: number;
}
/**
 * 
 * @export
 * @interface FinancialFiguresDtoBrief
 */
export interface FinancialFiguresDtoBrief {
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDtoBrief
     */
    ebitda?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDtoBrief
     */
    grossProfit?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDtoBrief
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDtoBrief
     */
    netDebt?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDtoBrief
     */
    netIncome?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDtoBrief
     */
    operatingProfit?: number;
    /**
     * 
     * @type {ProfitabilityRatiosDtoBrief}
     * @memberof FinancialFiguresDtoBrief
     */
    profitabilityRatios?: ProfitabilityRatiosDtoBrief;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDtoBrief
     */
    revenue?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDtoBrief
     */
    totalAssets?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDtoBrief
     */
    totalLiabilities?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialFiguresDtoBrief
     */
    totalSales?: number;
}
/**
 * 
 * @export
 * @interface GiniMachineScoringModel
 */
export interface GiniMachineScoringModel {
    /**
     * 
     * @type {string}
     * @memberof GiniMachineScoringModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GiniMachineScoringModel
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface IdDocument
 */
export interface IdDocument {
    /**
     * 
     * @type {Array<any>}
     * @memberof IdDocument
     */
    attachments?: Array<any>;
    /**
     * 
     * @type {string}
     * @memberof IdDocument
     */
    expirationDate: string;
    /**
     * 
     * @type {number}
     * @memberof IdDocument
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IdDocument
     */
    issueDate?: string;
    /**
     * 
     * @type {string}
     * @memberof IdDocument
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof IdDocument
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface IdDocumentDto
 */
export interface IdDocumentDto {
    /**
     * 
     * @type {Array<any>}
     * @memberof IdDocumentDto
     */
    attachments?: Array<any>;
    /**
     * 
     * @type {string}
     * @memberof IdDocumentDto
     */
    expirationDate: string;
    /**
     * 
     * @type {string}
     * @memberof IdDocumentDto
     */
    issueDate?: string;
    /**
     * 
     * @type {string}
     * @memberof IdDocumentDto
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof IdDocumentDto
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface IdDocumentLoanManagement
 */
export interface IdDocumentLoanManagement {
    /**
     * 
     * @type {string}
     * @memberof IdDocumentLoanManagement
     */
    expirationDate: string;
    /**
     * 
     * @type {string}
     * @memberof IdDocumentLoanManagement
     */
    issueDate: string;
    /**
     * 
     * @type {string}
     * @memberof IdDocumentLoanManagement
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof IdDocumentLoanManagement
     */
    type: IdDocumentLoanManagementTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum IdDocumentLoanManagementTypeEnum {
    PASSPORT = 'PASSPORT',
    IDCARD = 'ID_CARD',
    DRIVERLICENSE = 'DRIVER_LICENSE'
}

/**
 * 
 * @export
 * @interface IdDocumentLoanOrigination
 */
export interface IdDocumentLoanOrigination {
    /**
     * 
     * @type {string}
     * @memberof IdDocumentLoanOrigination
     */
    expirationDate: string;
    /**
     * 
     * @type {string}
     * @memberof IdDocumentLoanOrigination
     */
    issueDate: string;
    /**
     * 
     * @type {string}
     * @memberof IdDocumentLoanOrigination
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof IdDocumentLoanOrigination
     */
    type: IdDocumentLoanOriginationTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum IdDocumentLoanOriginationTypeEnum {
    PASSPORT = 'PASSPORT',
    IDCARD = 'ID_CARD',
    DRIVERLICENSE = 'DRIVER_LICENSE'
}

/**
 * 
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
    /**
     * The file content to store
     * @type {any}
     * @memberof InlineObject
     */
    file: any;
}
/**
 * 
 * @export
 * @interface InlineObject1
 */
export interface InlineObject1 {
    /**
     * List of Balance sheet files
     * @type {Array}
     * @memberof InlineObject1
     */
    balanceSheet: Array;
    /**
     * URL for sending a callback with a processed loan application. Callback will not performed if the parameter not provided
     * @type {string}
     * @memberof InlineObject1
     */
    callbackUrl?: string;
    /**
     * List of files of the document identifying the representative of the legal entity
     * @type {Array}
     * @memberof InlineObject1
     */
    idDocument: Array;
    /**
     * List of Profit and loss statement files
     * @type {Array}
     * @memberof InlineObject1
     */
    pnlStatement: Array;
    /**
     * 
     * @type {RequestLegalEntityLoanOrigination}
     * @memberof InlineObject1
     */
    request: RequestLegalEntityLoanOrigination;
}
/**
 * 
 * @export
 * @interface InlineObject2
 */
export interface InlineObject2 {
    /**
     * URL for sending a callback with a processed loan application. Callback will not performed if the parameter not provided
     * @type {string}
     * @memberof InlineObject2
     */
    callbackUrl?: string;
    /**
     * List of the identification document\'s files
     * @type {Array}
     * @memberof InlineObject2
     */
    idDocument: Array;
    /**
     * 
     * @type {RequestPersonLoanOrigination}
     * @memberof InlineObject2
     */
    request: RequestPersonLoanOrigination;
}
/**
 * 
 * @export
 * @interface InlineObject3
 */
export interface InlineObject3 {
    /**
     * List of Balance sheet files
     * @type {Array}
     * @memberof InlineObject3
     */
    balanceSheet: Array;
    /**
     * URL for sending a callback with a processed loan application
     * @type {string}
     * @memberof InlineObject3
     */
    callbackUrl: string;
    /**
     * List of files of the document identifying the representative of the legal entity
     * @type {Array}
     * @memberof InlineObject3
     */
    idDocument: Array;
    /**
     * List of Profit and loss statement files
     * @type {Array}
     * @memberof InlineObject3
     */
    pnlStatement: Array;
    /**
     * 
     * @type {RequestLegalEntityLoanOrigination}
     * @memberof InlineObject3
     */
    request: RequestLegalEntityLoanOrigination;
}
/**
 * 
 * @export
 * @interface InlineObject4
 */
export interface InlineObject4 {
    /**
     * URL for sending a callback with a processed loan application
     * @type {string}
     * @memberof InlineObject4
     */
    callbackUrl: string;
    /**
     * List of the identification document\'s files
     * @type {Array}
     * @memberof InlineObject4
     */
    idDocument: Array;
    /**
     * 
     * @type {RequestPersonLoanOrigination}
     * @memberof InlineObject4
     */
    request: RequestPersonLoanOrigination;
}
/**
 * 
 * @export
 * @interface InterestRateSettingsDto
 */
export interface InterestRateSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof InterestRateSettingsDto
     */
    primeRateEffectiveDate?: string;
    /**
     * 
     * @type {number}
     * @memberof InterestRateSettingsDto
     */
    primeRatePct?: number;
}
/**
 * 
 * @export
 * @interface InterestRateSettingsResponse
 */
export interface InterestRateSettingsResponse {
    /**
     * 
     * @type {InterestRateSettingsDto}
     * @memberof InterestRateSettingsResponse
     */
    interestRateSettings?: InterestRateSettingsDto;
}
/**
 * 
 * @export
 * @interface InternalScoringModelDto
 */
export interface InternalScoringModelDto {
    /**
     * 
     * @type {string}
     * @memberof InternalScoringModelDto
     */
    borrowerType?: string;
    /**
     * 
     * @type {number}
     * @memberof InternalScoringModelDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InternalScoringModelDto
     */
    key?: string;
}
/**
 * 
 * @export
 * @interface KycResults
 */
export interface KycResults {
    /**
     * 
     * @type {string}
     * @memberof KycResults
     */
    createdAt?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof KycResults
     */
    details?: { [key: string]: object; };
    /**
     * 
     * @type {number}
     * @memberof KycResults
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof KycResults
     */
    providerName?: string;
}
/**
 * 
 * @export
 * @interface KycResultsDto
 */
export interface KycResultsDto {
    /**
     * 
     * @type {string}
     * @memberof KycResultsDto
     */
    createdAt?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof KycResultsDto
     */
    details?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof KycResultsDto
     */
    providerName?: string;
}
/**
 * 
 * @export
 * @interface LandingCalculatorSettingsResponse
 */
export interface LandingCalculatorSettingsResponse {
    /**
     * 
     * @type {number}
     * @memberof LandingCalculatorSettingsResponse
     */
    amountSelectionStep?: number;
    /**
     * 
     * @type {number}
     * @memberof LandingCalculatorSettingsResponse
     */
    maxAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof LandingCalculatorSettingsResponse
     */
    maxTerm?: number;
    /**
     * 
     * @type {number}
     * @memberof LandingCalculatorSettingsResponse
     */
    minAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof LandingCalculatorSettingsResponse
     */
    minTerm?: number;
    /**
     * 
     * @type {CampaignDtoPaymentFrequency}
     * @memberof LandingCalculatorSettingsResponse
     */
    periodType?: CampaignDtoPaymentFrequency;
}
/**
 * 
 * @export
 * @interface LandingPageSettingsDto
 */
export interface LandingPageSettingsDto {
    /**
     * 
     * @type {number}
     * @memberof LandingPageSettingsDto
     */
    amountSelectionStep?: number;
    /**
     * 
     * @type {string}
     * @memberof LandingPageSettingsDto
     */
    calculationType?: string;
    /**
     * 
     * @type {number}
     * @memberof LandingPageSettingsDto
     */
    interestRatePct?: number;
    /**
     * 
     * @type {number}
     * @memberof LandingPageSettingsDto
     */
    maxAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof LandingPageSettingsDto
     */
    maxTerm?: number;
    /**
     * 
     * @type {number}
     * @memberof LandingPageSettingsDto
     */
    minAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof LandingPageSettingsDto
     */
    minTerm?: number;
    /**
     * 
     * @type {CampaignDtoPaymentFrequency}
     * @memberof LandingPageSettingsDto
     */
    paymentFrequency?: CampaignDtoPaymentFrequency;
    /**
     * 
     * @type {CampaignDtoPaymentFrequency}
     * @memberof LandingPageSettingsDto
     */
    periodType?: CampaignDtoPaymentFrequency;
}
/**
 * 
 * @export
 * @interface LandingPageSettingsRequest
 */
export interface LandingPageSettingsRequest {
    /**
     * 
     * @type {LandingPageSettingsDto}
     * @memberof LandingPageSettingsRequest
     */
    landingPageSettings?: LandingPageSettingsDto;
}
/**
 * 
 * @export
 * @interface LandingPageSettingsResponse
 */
export interface LandingPageSettingsResponse {
    /**
     * 
     * @type {LandingPageSettingsDto}
     * @memberof LandingPageSettingsResponse
     */
    landingPageSettings?: LandingPageSettingsDto;
}
/**
 * 
 * @export
 * @interface LeadDto
 */
export interface LeadDto {
    /**
     * 
     * @type {number}
     * @memberof LeadDto
     */
    agentId?: number;
    /**
     * 
     * @type {string}
     * @memberof LeadDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadDto
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadDto
     */
    fullName?: string;
    /**
     * 
     * @type {number}
     * @memberof LeadDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof LeadDto
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadDto
     */
    phone?: string;
}
/**
 * 
 * @export
 * @interface LeadDtoBrief
 */
export interface LeadDtoBrief {
    /**
     * 
     * @type {number}
     * @memberof LeadDtoBrief
     */
    agentId?: number;
    /**
     * 
     * @type {string}
     * @memberof LeadDtoBrief
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadDtoBrief
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadDtoBrief
     */
    fullName?: string;
    /**
     * 
     * @type {number}
     * @memberof LeadDtoBrief
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof LeadDtoBrief
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadDtoBrief
     */
    phone?: string;
}
/**
 * 
 * @export
 * @interface LegalEntity
 */
export interface LegalEntity extends Borrower {
    /**
     * 
     * @type {string}
     * @memberof LegalEntity
     */
    corporateType?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof LegalEntity
     */
    financialInformation?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof LegalEntity
     */
    industry?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntity
     */
    legalName?: string;
    /**
     * 
     * @type {number}
     * @memberof LegalEntity
     */
    monthsInOperation?: number;
    /**
     * 
     * @type {string}
     * @memberof LegalEntity
     */
    registrationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntity
     */
    registrationNumber?: string;
    /**
     * 
     * @type {Representative}
     * @memberof LegalEntity
     */
    representative?: Representative;
    /**
     * 
     * @type {string}
     * @memberof LegalEntity
     */
    website?: string;
}
/**
 * 
 * @export
 * @interface LegalEntityAllOf
 */
export interface LegalEntityAllOf {
    /**
     * 
     * @type {string}
     * @memberof LegalEntityAllOf
     */
    corporateType?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof LegalEntityAllOf
     */
    financialInformation?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof LegalEntityAllOf
     */
    industry?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityAllOf
     */
    legalName?: string;
    /**
     * 
     * @type {number}
     * @memberof LegalEntityAllOf
     */
    monthsInOperation?: number;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityAllOf
     */
    registrationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityAllOf
     */
    registrationNumber?: string;
    /**
     * 
     * @type {Representative}
     * @memberof LegalEntityAllOf
     */
    representative?: Representative;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityAllOf
     */
    website?: string;
}
/**
 * 
 * @export
 * @interface LegalEntityLoanManagement
 */
export interface LegalEntityLoanManagement {
    /**
     * 
     * @type {AddressInbound}
     * @memberof LegalEntityLoanManagement
     */
    address: AddressInbound;
    /**
     * 
     * @type {BankAccountInbound}
     * @memberof LegalEntityLoanManagement
     */
    bankAccount: BankAccountInbound;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityLoanManagement
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityLoanManagement
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityLoanManagement
     */
    taxNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityLoanManagement
     */
    type?: string;
    /**
     * Marketing legal entity name
     * @type {string}
     * @memberof LegalEntityLoanManagement
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityLoanManagement
     */
    legalName: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityLoanManagement
     */
    registrationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityLoanManagement
     */
    registrationNumber: string;
}
/**
 * 
 * @export
 * @interface LegalEntityLoanManagementAllOf
 */
export interface LegalEntityLoanManagementAllOf {
    /**
     * Marketing legal entity name
     * @type {string}
     * @memberof LegalEntityLoanManagementAllOf
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityLoanManagementAllOf
     */
    legalName?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityLoanManagementAllOf
     */
    registrationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityLoanManagementAllOf
     */
    registrationNumber?: string;
}
/**
 * Borrower details
 * @export
 * @interface LegalEntityLoanOrigination
 */
export interface LegalEntityLoanOrigination {
    /**
     * 
     * @type {AddressInbound}
     * @memberof LegalEntityLoanOrigination
     */
    address: AddressInbound;
    /**
     * 
     * @type {number}
     * @memberof LegalEntityLoanOrigination
     */
    annualRevenue?: number;
    /**
     * 
     * @type {BankAccountInbound}
     * @memberof LegalEntityLoanOrigination
     */
    bankAccount: BankAccountInbound;
    /**
     * Available values: [ Sole proprietorship, Limited Liability Company (LLC), S-Corp, C-Corp ]
     * @type {string}
     * @memberof LegalEntityLoanOrigination
     */
    corporateType?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityLoanOrigination
     */
    email: string;
    /**
     * Marketing legal entity name
     * @type {string}
     * @memberof LegalEntityLoanOrigination
     */
    fullName: string;
    /**
     * Available values: [ Agriculture; Plantations; Other rural sectors, Basic metal production, Chemical industries, Commerce, Construction, Education, Financial services, Food; Drink; Tobacco, Forestry; Wood; Pulp and paper, Health services, Hotels; Tourism; Catering, Information technology, Mining, Mechanical and electrical engineering, Media; Culture; Graphical, Postal and telecommunications services, Public service, Real estate; Rental; Leasing, Repair and maintenance, Shipping; Ports; Fisheries; Inland waterways, Textiles; Clothing; Leather; Footwear, Transport, Utilities ]
     * @type {string}
     * @memberof LegalEntityLoanOrigination
     */
    industry?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityLoanOrigination
     */
    legalName: string;
    /**
     * 
     * @type {number}
     * @memberof LegalEntityLoanOrigination
     */
    monthsInOperation?: number;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityLoanOrigination
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityLoanOrigination
     */
    registrationDate: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityLoanOrigination
     */
    registrationNumber: string;
    /**
     * 
     * @type {RepresentativeLoanOrigination}
     * @memberof LegalEntityLoanOrigination
     */
    representative: RepresentativeLoanOrigination;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityLoanOrigination
     */
    taxNumber?: string;
}
/**
 * 
 * @export
 * @interface LicenseActivationRequest
 */
export interface LicenseActivationRequest {
    /**
     * 
     * @type {string}
     * @memberof LicenseActivationRequest
     */
    content: string;
}
/**
 * 
 * @export
 * @interface LicenseResponse
 */
export interface LicenseResponse {
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof LicenseResponse
     */
    activeLicenseInfo?: { [key: string]: object; };
}
/**
 * 
 * @export
 * @interface Link
 */
export interface Link {
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    href?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Link
     */
    templated?: boolean;
}
/**
 * 
 * @export
 * @interface LoanAdjustmentsRequestDtoBorrowerAllowed
 */
export interface LoanAdjustmentsRequestDtoBorrowerAllowed {
    /**
     * 
     * @type {FileBorrowerAllowed}
     * @memberof LoanAdjustmentsRequestDtoBorrowerAllowed
     */
    agreement?: FileBorrowerAllowed;
    /**
     * 
     * @type {Array<FileBorrowerAllowed>}
     * @memberof LoanAdjustmentsRequestDtoBorrowerAllowed
     */
    attachments?: Array<FileBorrowerAllowed>;
    /**
     * 
     * @type {string}
     * @memberof LoanAdjustmentsRequestDtoBorrowerAllowed
     */
    closedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanAdjustmentsRequestDtoBorrowerAllowed
     */
    decisionedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanAdjustmentsRequestDtoBorrowerAllowed
     */
    declineReason?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanAdjustmentsRequestDtoBorrowerAllowed
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanAdjustmentsRequestDtoBorrowerAllowed
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanAdjustmentsRequestDtoBorrowerAllowed
     */
    number?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanAdjustmentsRequestDtoBorrowerAllowed
     */
    requestedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanAdjustmentsRequestDtoBorrowerAllowed
     */
    restructuringOption?: LoanAdjustmentsRequestDtoBorrowerAllowedRestructuringOptionEnum;
    /**
     * 
     * @type {string}
     * @memberof LoanAdjustmentsRequestDtoBorrowerAllowed
     */
    status?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum LoanAdjustmentsRequestDtoBorrowerAllowedRestructuringOptionEnum {
    EXTENDMATURITYDATE = 'EXTEND_MATURITY_DATE',
    AMENDINTERESTRATE = 'AMEND_INTEREST_RATE'
}

/**
 * 
 * @export
 * @interface LoanAgreementDto
 */
export interface LoanAgreementDto {
    /**
     * 
     * @type {string}
     * @memberof LoanAgreementDto
     */
    closedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanAgreementDto
     */
    fileUuid?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanAgreementDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanAgreementDto
     */
    restructuringOption?: string;
}
/**
 * 
 * @export
 * @interface LoanApplication
 */
export interface LoanApplication {
    /**
     * 
     * @type {boolean}
     * @memberof LoanApplication
     */
    active?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LoanApplication
     */
    agentId?: number;
    /**
     * 
     * @type {Array<AmortisationSchedulePeriod>}
     * @memberof LoanApplication
     */
    amortisationSchedule?: Array<AmortisationSchedulePeriod>;
    /**
     * 
     * @type {number}
     * @memberof LoanApplication
     */
    amountApproved?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanApplication
     */
    amountRequested: number;
    /**
     * 
     * @type {string}
     * @memberof LoanApplication
     */
    approvedBy?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof LoanApplication
     */
    attachments?: { [key: string]: object; };
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof LoanApplication
     */
    bankAccountVerification?: { [key: string]: object; };
    /**
     * 
     * @type {LegalEntity | Person}
     * @memberof LoanApplication
     */
    borrower?: LegalEntity | Person;
    /**
     * 
     * @type {string}
     * @memberof LoanApplication
     */
    calculationType?: string;
    /**
     * 
     * @type {Campaign}
     * @memberof LoanApplication
     */
    campaign?: Campaign;
    /**
     * 
     * @type {string}
     * @memberof LoanApplication
     */
    cancelCode?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanApplication
     */
    closedAt?: string;
    /**
     * 
     * @type {Collateral}
     * @memberof LoanApplication
     */
    collateral?: Collateral;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof LoanApplication
     */
    complianceInfo?: { [key: string]: object; };
    /**
     * 
     * @type {any}
     * @memberof LoanApplication
     */
    contract?: any;
    /**
     * 
     * @type {string}
     * @memberof LoanApplication
     */
    contractOtpCode?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanApplication
     */
    contractSignedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanApplication
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanApplication
     */
    createdBy?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanApplication
     */
    creditLimit?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanApplication
     */
    declineCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LoanApplication
     */
    declined?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LoanApplication
     */
    declinedBy?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanApplication
     */
    disbursementAmount?: number;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof LoanApplication
     */
    extensions?: { [key: string]: object; };
    /**
     * 
     * @type {FinancialFigures}
     * @memberof LoanApplication
     */
    financialFigures?: FinancialFigures;
    /**
     * 
     * @type {string}
     * @memberof LoanApplication
     */
    firstPaymentDate?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof LoanApplication
     */
    furtherInformation?: { [key: string]: object; };
    /**
     * 
     * @type {number}
     * @memberof LoanApplication
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanApplication
     */
    interestRateApproved?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanApplication
     */
    interestRateApprovedPct?: number;
    /**
     * 
     * @type {LoanProduct}
     * @memberof LoanApplication
     */
    loanProduct?: LoanProduct;
    /**
     * 
     * @type {number}
     * @memberof LoanApplication
     */
    ltvPct?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanApplication
     */
    number?: string;
    /**
     * A date-based amount of time in the ISO 8601 calendar system.
     * @type {string}
     * @memberof LoanApplication
     */
    paymentFrequency?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanApplication
     */
    requestedAt: string;
    /**
     * 
     * @type {Scoring}
     * @memberof LoanApplication
     */
    scoring?: Scoring;
    /**
     * 
     * @type {number}
     * @memberof LoanApplication
     */
    serviceFee?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanApplication
     */
    status?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LoanApplication
     */
    stopFactors?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof LoanApplication
     */
    termApproved?: number;
    /**
     * A date-based amount of time in the ISO 8601 calendar system.
     * @type {string}
     * @memberof LoanApplication
     */
    termPeriodType?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanApplication
     */
    termRequested: number;
    /**
     * 
     * @type {number}
     * @memberof LoanApplication
     */
    totalToPay?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanApplication
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanApplication
     */
    updatedBy?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanApplication
     */
    usedPrimeRatePct?: number;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof LoanApplication
     */
    validationResult?: { [key: string]: object; };
}
/**
 * 
 * @export
 * @interface LoanApplicationDto
 */
export interface LoanApplicationDto {
    /**
     * 
     * @type {boolean}
     * @memberof LoanApplicationDto
     */
    active?: boolean;
    /**
     * 
     * @type {BorrowerDto}
     * @memberof LoanApplicationDto
     */
    actualBorrower?: BorrowerDto;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDto
     */
    agentId?: number;
    /**
     * 
     * @type {Array<object>}
     * @memberof LoanApplicationDto
     */
    amortisationSchedule?: Array<object>;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDto
     */
    amountApproved?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDto
     */
    amountRequested?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDto
     */
    approvedBy?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof LoanApplicationDto
     */
    attachments?: { [key: string]: object; };
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof LoanApplicationDto
     */
    bankAccountVerification?: { [key: string]: object; };
    /**
     * 
     * @type {BorrowerDto}
     * @memberof LoanApplicationDto
     */
    borrower?: BorrowerDto;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDto
     */
    calculationType?: string;
    /**
     * 
     * @type {CampaignDto}
     * @memberof LoanApplicationDto
     */
    campaign?: CampaignDto;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDto
     */
    cancelCode?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDto
     */
    closedAt?: string;
    /**
     * 
     * @type {CollateralDto}
     * @memberof LoanApplicationDto
     */
    collateral?: CollateralDto;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof LoanApplicationDto
     */
    complianceInfo?: { [key: string]: object; };
    /**
     * 
     * @type {FileDto}
     * @memberof LoanApplicationDto
     */
    contract?: FileDto;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDto
     */
    contractOtpCode?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDto
     */
    contractSignedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDto
     */
    creditLimit?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDto
     */
    declineCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LoanApplicationDto
     */
    declined?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDto
     */
    declinedBy?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDto
     */
    disbursementAmount?: number;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof LoanApplicationDto
     */
    extensions?: { [key: string]: object; };
    /**
     * 
     * @type {FinancialFiguresDto}
     * @memberof LoanApplicationDto
     */
    financialFigures?: FinancialFiguresDto;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDto
     */
    firstPaymentDate?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof LoanApplicationDto
     */
    furtherInformation?: { [key: string]: object; };
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDto
     */
    interestRateApprovedPct?: number;
    /**
     * 
     * @type {LoanProductDto}
     * @memberof LoanApplicationDto
     */
    loanProduct?: LoanProductDto;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDto
     */
    ltvPct?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDto
     */
    number?: string;
    /**
     * 
     * @type {CampaignDtoPaymentFrequency}
     * @memberof LoanApplicationDto
     */
    paymentFrequency?: CampaignDtoPaymentFrequency;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDto
     */
    requestedAt?: string;
    /**
     * 
     * @type {ScoringDto}
     * @memberof LoanApplicationDto
     */
    scoring?: ScoringDto;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDto
     */
    serviceFee?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDto
     */
    status?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LoanApplicationDto
     */
    stopFactors?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDto
     */
    termApproved?: number;
    /**
     * 
     * @type {CampaignDtoPaymentFrequency}
     * @memberof LoanApplicationDto
     */
    termPeriodType?: CampaignDtoPaymentFrequency;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDto
     */
    termRequested?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDto
     */
    totalToPay?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDto
     */
    usedPrimeRatePct?: number;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof LoanApplicationDto
     */
    validationResult?: { [key: string]: object; };
}
/**
 * 
 * @export
 * @interface LoanApplicationDtoBorrowerAllowed
 */
export interface LoanApplicationDtoBorrowerAllowed {
    /**
     * 
     * @type {boolean}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    active?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    agentId?: number;
    /**
     * 
     * @type {Array<object>}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    amortisationSchedule?: Array<object>;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    amountApproved?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    amountRequested?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    approvedBy?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    attachments?: { [key: string]: object; };
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    bankAccountVerification?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    calculationType?: string;
    /**
     * 
     * @type {CampaignDtoBorrowerAllowed}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    campaign?: CampaignDtoBorrowerAllowed;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    cancelCode?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    closedAt?: string;
    /**
     * 
     * @type {CollateralDtoBorrowerAllowed}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    collateral?: CollateralDtoBorrowerAllowed;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    complianceInfo?: { [key: string]: object; };
    /**
     * 
     * @type {FileDtoBorrowerAllowed}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    contract?: FileDtoBorrowerAllowed;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    contractOtpCode?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    contractSignedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    creditLimit?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    declineCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    declined?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    declinedBy?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    disbursementAmount?: number;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    extensions?: { [key: string]: object; };
    /**
     * 
     * @type {FinancialFiguresDtoBorrowerAllowed}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    financialFigures?: FinancialFiguresDtoBorrowerAllowed;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    firstPaymentDate?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    furtherInformation?: { [key: string]: object; };
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    interestRateApprovedPct?: number;
    /**
     * 
     * @type {LoanProductDtoBorrowerAllowed}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    loanProduct?: LoanProductDtoBorrowerAllowed;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    ltvPct?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    number?: string;
    /**
     * 
     * @type {CampaignDtoPaymentFrequency}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    paymentFrequency?: CampaignDtoPaymentFrequency;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    requestedAt?: string;
    /**
     * 
     * @type {ScoringDtoBorrowerAllowed}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    scoring?: ScoringDtoBorrowerAllowed;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    serviceFee?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    status?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    stopFactors?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    termApproved?: number;
    /**
     * 
     * @type {CampaignDtoPaymentFrequency}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    termPeriodType?: CampaignDtoPaymentFrequency;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    termRequested?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    totalToPay?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    usedPrimeRatePct?: number;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof LoanApplicationDtoBorrowerAllowed
     */
    validationResult?: { [key: string]: object; };
}
/**
 * 
 * @export
 * @interface LoanApplicationDtoBrief
 */
export interface LoanApplicationDtoBrief {
    /**
     * 
     * @type {boolean}
     * @memberof LoanApplicationDtoBrief
     */
    active?: boolean;
    /**
     * 
     * @type {BorrowerDtoBrief}
     * @memberof LoanApplicationDtoBrief
     */
    actualBorrower?: BorrowerDtoBrief;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDtoBrief
     */
    agentId?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDtoBrief
     */
    amountApproved?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDtoBrief
     */
    amountRequested?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDtoBrief
     */
    approvedBy?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof LoanApplicationDtoBrief
     */
    bankAccountVerification?: { [key: string]: object; };
    /**
     * 
     * @type {BorrowerDtoBrief}
     * @memberof LoanApplicationDtoBrief
     */
    borrower?: BorrowerDtoBrief;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDtoBrief
     */
    calculationType?: string;
    /**
     * 
     * @type {CampaignDtoBrief}
     * @memberof LoanApplicationDtoBrief
     */
    campaign?: CampaignDtoBrief;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDtoBrief
     */
    cancelCode?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDtoBrief
     */
    closedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDtoBrief
     */
    contractOtpCode?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDtoBrief
     */
    contractSignedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDtoBrief
     */
    creditLimit?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDtoBrief
     */
    declineCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LoanApplicationDtoBrief
     */
    declined?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDtoBrief
     */
    declinedBy?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof LoanApplicationDtoBrief
     */
    extensions?: { [key: string]: object; };
    /**
     * 
     * @type {FinancialFiguresDtoBrief}
     * @memberof LoanApplicationDtoBrief
     */
    financialFigures?: FinancialFiguresDtoBrief;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDtoBrief
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDtoBrief
     */
    interestRateApprovedPct?: number;
    /**
     * 
     * @type {LoanProductDtoBrief}
     * @memberof LoanApplicationDtoBrief
     */
    loanProduct?: LoanProductDtoBrief;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDtoBrief
     */
    ltvPct?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDtoBrief
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDtoBrief
     */
    requestedAt?: string;
    /**
     * 
     * @type {ScoringDtoBrief}
     * @memberof LoanApplicationDtoBrief
     */
    scoring?: ScoringDtoBrief;
    /**
     * 
     * @type {string}
     * @memberof LoanApplicationDtoBrief
     */
    status?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LoanApplicationDtoBrief
     */
    stopFactors?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDtoBrief
     */
    termApproved?: number;
    /**
     * 
     * @type {CampaignDtoPaymentFrequency}
     * @memberof LoanApplicationDtoBrief
     */
    termPeriodType?: CampaignDtoPaymentFrequency;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDtoBrief
     */
    termRequested?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanApplicationDtoBrief
     */
    totalToPay?: number;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof LoanApplicationDtoBrief
     */
    validationResult?: { [key: string]: object; };
}
/**
 * 
 * @export
 * @interface LoanDto
 */
export interface LoanDto {
    /**
     * 
     * @type {boolean}
     * @memberof LoanDto
     */
    active?: boolean;
    /**
     * 
     * @type {AmortisationScheduleSnapshotDto}
     * @memberof LoanDto
     */
    actualAmortisationScheduleSnapshot?: AmortisationScheduleSnapshotDto;
    /**
     * 
     * @type {LoanSnapshotDto}
     * @memberof LoanDto
     */
    actualSnapshot?: LoanSnapshotDto;
    /**
     * 
     * @type {Array<object>}
     * @memberof LoanDto
     */
    amortisationSchedule?: Array<object>;
    /**
     * 
     * @type {BorrowerDto}
     * @memberof LoanDto
     */
    borrower?: BorrowerDto;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    calculationType?: string;
    /**
     * 
     * @type {BankAccountDto}
     * @memberof LoanDto
     */
    debitedBankAccount?: BankAccountDto;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    endDate?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanDto
     */
    interestRatePct?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    issueDate?: string;
    /**
     * 
     * @type {LoanApplicationDto}
     * @memberof LoanDto
     */
    loanApplication?: LoanApplicationDto;
    /**
     * 
     * @type {LoanProductDto}
     * @memberof LoanDto
     */
    loanProduct?: LoanProductDto;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    maturityDate?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanDto
     */
    nextPaymentAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    nextPaymentDate?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanDto
     */
    term?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanDto
     */
    usedPrimeRatePct?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    writeOffReason?: string;
}
/**
 * 
 * @export
 * @interface LoanDtoBorrowerAllowed
 */
export interface LoanDtoBorrowerAllowed {
    /**
     * 
     * @type {boolean}
     * @memberof LoanDtoBorrowerAllowed
     */
    active?: boolean;
    /**
     * 
     * @type {AmortisationScheduleSnapshotDtoBorrowerAllowed}
     * @memberof LoanDtoBorrowerAllowed
     */
    actualAmortisationScheduleSnapshot?: AmortisationScheduleSnapshotDtoBorrowerAllowed;
    /**
     * 
     * @type {LoanSnapshotDtoBorrowerAllowed}
     * @memberof LoanDtoBorrowerAllowed
     */
    actualSnapshot?: LoanSnapshotDtoBorrowerAllowed;
    /**
     * 
     * @type {Array<object>}
     * @memberof LoanDtoBorrowerAllowed
     */
    amortisationSchedule?: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof LoanDtoBorrowerAllowed
     */
    calculationType?: string;
    /**
     * 
     * @type {BankAccountDtoBorrowerAllowed}
     * @memberof LoanDtoBorrowerAllowed
     */
    debitedBankAccount?: BankAccountDtoBorrowerAllowed;
    /**
     * 
     * @type {string}
     * @memberof LoanDtoBorrowerAllowed
     */
    endDate?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanDtoBorrowerAllowed
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanDtoBorrowerAllowed
     */
    interestRatePct?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanDtoBorrowerAllowed
     */
    issueDate?: string;
    /**
     * 
     * @type {LoanApplicationDtoBorrowerAllowed}
     * @memberof LoanDtoBorrowerAllowed
     */
    loanApplication?: LoanApplicationDtoBorrowerAllowed;
    /**
     * 
     * @type {LoanProductDtoBorrowerAllowed}
     * @memberof LoanDtoBorrowerAllowed
     */
    loanProduct?: LoanProductDtoBorrowerAllowed;
    /**
     * 
     * @type {string}
     * @memberof LoanDtoBorrowerAllowed
     */
    maturityDate?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanDtoBorrowerAllowed
     */
    nextPaymentAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanDtoBorrowerAllowed
     */
    nextPaymentDate?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanDtoBorrowerAllowed
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanDtoBorrowerAllowed
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanDtoBorrowerAllowed
     */
    term?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanDtoBorrowerAllowed
     */
    usedPrimeRatePct?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanDtoBorrowerAllowed
     */
    writeOffReason?: string;
}
/**
 * 
 * @export
 * @interface LoanDtoBrief
 */
export interface LoanDtoBrief {
    /**
     * 
     * @type {boolean}
     * @memberof LoanDtoBrief
     */
    active?: boolean;
    /**
     * 
     * @type {AmortisationScheduleSnapshotDtoBrief}
     * @memberof LoanDtoBrief
     */
    actualAmortisationScheduleSnapshot?: AmortisationScheduleSnapshotDtoBrief;
    /**
     * 
     * @type {LoanSnapshotDtoBrief}
     * @memberof LoanDtoBrief
     */
    actualSnapshot?: LoanSnapshotDtoBrief;
    /**
     * 
     * @type {BorrowerDtoBrief}
     * @memberof LoanDtoBrief
     */
    borrower?: BorrowerDtoBrief;
    /**
     * 
     * @type {object}
     * @memberof LoanDtoBrief
     */
    debitedBankAccount?: object;
    /**
     * 
     * @type {string}
     * @memberof LoanDtoBrief
     */
    endDate?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanDtoBrief
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanDtoBrief
     */
    interestRatePct?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanDtoBrief
     */
    issueDate?: string;
    /**
     * 
     * @type {LoanApplicationDtoBrief}
     * @memberof LoanDtoBrief
     */
    loanApplication?: LoanApplicationDtoBrief;
    /**
     * 
     * @type {LoanProductDtoBrief}
     * @memberof LoanDtoBrief
     */
    loanProduct?: LoanProductDtoBrief;
    /**
     * 
     * @type {string}
     * @memberof LoanDtoBrief
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanDtoBrief
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanDtoBrief
     */
    term?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanDtoBrief
     */
    usedPrimeRatePct?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanDtoBrief
     */
    writeOffReason?: string;
}
/**
 * 
 * @export
 * @interface LoanOperationDto
 */
export interface LoanOperationDto {
    /**
     * 
     * @type {number}
     * @memberof LoanOperationDto
     */
    amount?: number;
    /**
     * 
     * @type {Array<any>}
     * @memberof LoanOperationDto
     */
    attachments?: Array<any>;
    /**
     * 
     * @type {string}
     * @memberof LoanOperationDto
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanOperationDto
     */
    date?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanOperationDto
     */
    id?: number;
    /**
     * 
     * @type {LoanDto}
     * @memberof LoanOperationDto
     */
    loan?: LoanDto;
    /**
     * 
     * @type {LoanSnapshotDto}
     * @memberof LoanOperationDto
     */
    snapshot?: LoanSnapshotDto;
    /**
     * 
     * @type {string}
     * @memberof LoanOperationDto
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface LoanPreconditionsDto
 */
export interface LoanPreconditionsDto {
    /**
     * 
     * @type {number}
     * @memberof LoanPreconditionsDto
     */
    firstPayment?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanPreconditionsDto
     */
    totalInterest?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanPreconditionsDto
     */
    totalToPay?: number;
}
/**
 * 
 * @export
 * @interface LoanPreconditionsResponse
 */
export interface LoanPreconditionsResponse {
    /**
     * 
     * @type {LoanPreconditionsDto}
     * @memberof LoanPreconditionsResponse
     */
    preconditions?: LoanPreconditionsDto;
}
/**
 * 
 * @export
 * @interface LoanProduct
 */
export interface LoanProduct {
    /**
     * 
     * @type {boolean}
     * @memberof LoanProduct
     */
    active: boolean;
    /**
     * 
     * @type {Campaign}
     * @memberof LoanProduct
     */
    campaign: Campaign;
    /**
     * 
     * @type {string}
     * @memberof LoanProduct
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof LoanProduct
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanProduct
     */
    createdBy?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanProduct
     */
    defaultInterestRate?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProduct
     */
    defaultInterestRatePct: number;
    /**
     * 
     * @type {string}
     * @memberof LoanProduct
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanProduct
     */
    earlyRepaymentFeeRate?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProduct
     */
    earlyRepaymentFeeRatePct: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProduct
     */
    establishmentFee?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProduct
     */
    graceInterestRate?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProduct
     */
    graceInterestRatePct: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProduct
     */
    gracePeriodDays: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProduct
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProduct
     */
    maxAmount: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProduct
     */
    maxInterestRatePct: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProduct
     */
    maxMarginPct?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProduct
     */
    maxTerm: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProduct
     */
    minAmount: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProduct
     */
    minInterestRatePct: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProduct
     */
    minMarginPct?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProduct
     */
    minTerm: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProduct
     */
    overduePenalty: number;
    /**
     * A date-based amount of time in the ISO-8601 calendar system.
     * @type {string}
     * @memberof LoanProduct
     */
    paymentFrequency?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanProduct
     */
    serviceFeeRate?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProduct
     */
    serviceFeeRatePct?: number;
    /**
     * A date-based amount of time in the ISO-8601 calendar system.
     * @type {string}
     * @memberof LoanProduct
     */
    termPeriodType: string;
    /**
     * 
     * @type {string}
     * @memberof LoanProduct
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanProduct
     */
    updatedBy?: string;
}
/**
 * 
 * @export
 * @interface LoanProductDto
 */
export interface LoanProductDto {
    /**
     * 
     * @type {boolean}
     * @memberof LoanProductDto
     */
    active?: boolean;
    /**
     * 
     * @type {CampaignDto}
     * @memberof LoanProductDto
     */
    campaign?: CampaignDto;
    /**
     * 
     * @type {string}
     * @memberof LoanProductDto
     */
    code?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDto
     */
    defaultInterestRatePct?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanProductDto
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDto
     */
    earlyRepaymentFeeRatePct?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDto
     */
    establishmentFee?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDto
     */
    graceInterestRatePct?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDto
     */
    gracePeriodDays?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDto
     */
    maxAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDto
     */
    maxInterestRatePct?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDto
     */
    maxMarginPct?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDto
     */
    maxTerm?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDto
     */
    minAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDto
     */
    minInterestRatePct?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDto
     */
    minMarginPct?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDto
     */
    minTerm?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDto
     */
    overduePenalty?: number;
    /**
     * 
     * @type {CampaignDtoPaymentFrequency}
     * @memberof LoanProductDto
     */
    paymentFrequency?: CampaignDtoPaymentFrequency;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDto
     */
    serviceFeeRatePct?: number;
    /**
     * 
     * @type {CampaignDtoPaymentFrequency}
     * @memberof LoanProductDto
     */
    termPeriodType?: CampaignDtoPaymentFrequency;
    /**
     * 
     * @type {string}
     * @memberof LoanProductDto
     */
    updatedBy?: string;
}
/**
 * 
 * @export
 * @interface LoanProductDtoBorrowerAllowed
 */
export interface LoanProductDtoBorrowerAllowed {
    /**
     * 
     * @type {CampaignDtoBorrowerAllowed}
     * @memberof LoanProductDtoBorrowerAllowed
     */
    campaign?: CampaignDtoBorrowerAllowed;
    /**
     * 
     * @type {string}
     * @memberof LoanProductDtoBorrowerAllowed
     */
    code?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDtoBorrowerAllowed
     */
    defaultInterestRatePct?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDtoBorrowerAllowed
     */
    earlyRepaymentFeeRatePct?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDtoBorrowerAllowed
     */
    establishmentFee?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDtoBorrowerAllowed
     */
    graceInterestRatePct?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDtoBorrowerAllowed
     */
    gracePeriodDays?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDtoBorrowerAllowed
     */
    maxAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDtoBorrowerAllowed
     */
    maxInterestRatePct?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDtoBorrowerAllowed
     */
    maxMarginPct?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDtoBorrowerAllowed
     */
    maxTerm?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDtoBorrowerAllowed
     */
    minAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDtoBorrowerAllowed
     */
    minInterestRatePct?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDtoBorrowerAllowed
     */
    minMarginPct?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDtoBorrowerAllowed
     */
    minTerm?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDtoBorrowerAllowed
     */
    overduePenalty?: number;
    /**
     * 
     * @type {CampaignDtoPaymentFrequency}
     * @memberof LoanProductDtoBorrowerAllowed
     */
    paymentFrequency?: CampaignDtoPaymentFrequency;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDtoBorrowerAllowed
     */
    serviceFeeRatePct?: number;
    /**
     * 
     * @type {CampaignDtoPaymentFrequency}
     * @memberof LoanProductDtoBorrowerAllowed
     */
    termPeriodType?: CampaignDtoPaymentFrequency;
    /**
     * 
     * @type {string}
     * @memberof LoanProductDtoBorrowerAllowed
     */
    updatedBy?: string;
}
/**
 * 
 * @export
 * @interface LoanProductDtoBrief
 */
export interface LoanProductDtoBrief {
    /**
     * 
     * @type {boolean}
     * @memberof LoanProductDtoBrief
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LoanProductDtoBrief
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanProductDtoBrief
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDtoBrief
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDtoBrief
     */
    maxAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDtoBrief
     */
    maxInterestRatePct?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDtoBrief
     */
    maxMarginPct?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDtoBrief
     */
    maxTerm?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDtoBrief
     */
    minAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDtoBrief
     */
    minInterestRatePct?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDtoBrief
     */
    minMarginPct?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanProductDtoBrief
     */
    minTerm?: number;
    /**
     * 
     * @type {CampaignDtoPaymentFrequency}
     * @memberof LoanProductDtoBrief
     */
    paymentFrequency?: CampaignDtoPaymentFrequency;
    /**
     * 
     * @type {CampaignDtoPaymentFrequency}
     * @memberof LoanProductDtoBrief
     */
    termPeriodType?: CampaignDtoPaymentFrequency;
    /**
     * 
     * @type {string}
     * @memberof LoanProductDtoBrief
     */
    updatedBy?: string;
}
/**
 * Loan product that the loan applied for
 * @export
 * @interface LoanProductLoanManagement
 */
export interface LoanProductLoanManagement {
    /**
     * Type of calculation on which the amortisation schedule will be calculated.
     * @type {string}
     * @memberof LoanProductLoanManagement
     */
    calculationType: LoanProductLoanManagementCalculationTypeEnum;
    /**
     * Product name.
     * @type {string}
     * @memberof LoanProductLoanManagement
     */
    code: string;
    /**
     * The name of collection strategy
     * @type {string}
     * @memberof LoanProductLoanManagement
     */
    collectionStrategy: LoanProductLoanManagementCollectionStrategyEnum;
    /**
     * Days in overdue before collection starts. Not specified for \'None\' collection strategy
     * @type {number}
     * @memberof LoanProductLoanManagement
     */
    daysOverdue?: number;
    /**
     * Default interest rate measured as a percentage. Used when a loan is overdue
     * @type {number}
     * @memberof LoanProductLoanManagement
     */
    defaultInterestRatePct: number;
    /**
     * Disbursement option on which the disbursement provider will be selected.
     * @type {string}
     * @memberof LoanProductLoanManagement
     */
    disbursementOption: LoanProductLoanManagementDisbursementOptionEnum;
    /**
     * The fee that is charged if the payment is repaid before the scheduled payment date, measured as a percentage.
     * @type {number}
     * @memberof LoanProductLoanManagement
     */
    earlyRepaymentFeeRatePct: number;
    /**
     * The establishment fee that will be charged before the loan is disbursed, measured as an absolute value
     * @type {number}
     * @memberof LoanProductLoanManagement
     */
    establishmentFee: number;
    /**
     * Interest rate during the grace period, measured as a percentage.
     * @type {number}
     * @memberof LoanProductLoanManagement
     */
    graceInterestRatePct: number;
    /**
     * Days in grace period.
     * @type {number}
     * @memberof LoanProductLoanManagement
     */
    gracePeriodDays: number;
    /**
     * The penalty that is charged when a loan becomes overdue.
     * @type {number}
     * @memberof LoanProductLoanManagement
     */
    overduePenalty: number;
    /**
     * Frequency with which the payment will be made. Value is allowed only for \'Annuity instalment\' and \'Linear principal repayment instalment\' calculation types
     * @type {string}
     * @memberof LoanProductLoanManagement
     */
    paymentFrequency?: LoanProductLoanManagementPaymentFrequencyEnum;
    /**
     * The service fee that will be charged before the loan is disbursed, measured as a percentage
     * @type {number}
     * @memberof LoanProductLoanManagement
     */
    serviceFeeRatePct: number;
    /**
     * The unit of measure in which the loan term is set. \'DAYS\' value is allowed only for \'PDL\' calculation type
     * @type {string}
     * @memberof LoanProductLoanManagement
     */
    termPeriodType: LoanProductLoanManagementTermPeriodTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum LoanProductLoanManagementCalculationTypeEnum {
    PDL = 'PDL',
    ANNUITYINSTALLMENT = 'ANNUITY_INSTALLMENT',
    LINEARPRINCIPALREPAYMENT = 'LINEAR_PRINCIPAL_REPAYMENT'
}
/**
    * @export
    * @enum {string}
    */
export enum LoanProductLoanManagementCollectionStrategyEnum {
    NONE = 'NONE',
    DEFAULT = 'DEFAULT'
}
/**
    * @export
    * @enum {string}
    */
export enum LoanProductLoanManagementDisbursementOptionEnum {
    MANUAL = 'MANUAL',
    AUTOMATIC = 'AUTOMATIC'
}
/**
    * @export
    * @enum {string}
    */
export enum LoanProductLoanManagementPaymentFrequencyEnum {
    WEEKLY = 'WEEKLY',
    FORTNIGHTLY = 'FORTNIGHTLY',
    MONTHLY = 'MONTHLY',
    QUARTERLY = 'QUARTERLY'
}
/**
    * @export
    * @enum {string}
    */
export enum LoanProductLoanManagementTermPeriodTypeEnum {
    DAYS = 'DAYS',
    WEEKS = 'WEEKS',
    MONTHS = 'MONTHS',
    YEARS = 'YEARS'
}

/**
 * 
 * @export
 * @interface LoanProductRevisionDto
 */
export interface LoanProductRevisionDto {
    /**
     * 
     * @type {LoanProductDto}
     * @memberof LoanProductRevisionDto
     */
    entity?: LoanProductDto;
    /**
     * 
     * @type {string}
     * @memberof LoanProductRevisionDto
     */
    revisionInstant?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanProductRevisionDto
     */
    revisionNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanProductRevisionDto
     */
    revisionType?: LoanProductRevisionDtoRevisionTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum LoanProductRevisionDtoRevisionTypeEnum {
    UNKNOWN = 'UNKNOWN',
    INSERT = 'INSERT',
    UPDATE = 'UPDATE',
    DELETE = 'DELETE'
}

/**
 * 
 * @export
 * @interface LoanSnapshotDto
 */
export interface LoanSnapshotDto {
    /**
     * 
     * @type {string}
     * @memberof LoanSnapshotDto
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanSnapshotDto
     */
    date?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDto
     */
    daysInOverdue?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDto
     */
    defaultInterestBalance?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDto
     */
    earlyRepaymentFee?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDto
     */
    fullRepaymentAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDto
     */
    interestBalance?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDto
     */
    interestOverdue?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDto
     */
    nextPaymentAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDto
     */
    outstandingBalance?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDto
     */
    outstandingLtvPct?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDto
     */
    overdueAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanSnapshotDto
     */
    overdueDate?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDto
     */
    penalties?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDto
     */
    principalBalance?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDto
     */
    principalOverdue?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDto
     */
    technicalAccount?: number;
}
/**
 * 
 * @export
 * @interface LoanSnapshotDtoBorrowerAllowed
 */
export interface LoanSnapshotDtoBorrowerAllowed {
    /**
     * 
     * @type {string}
     * @memberof LoanSnapshotDtoBorrowerAllowed
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanSnapshotDtoBorrowerAllowed
     */
    date?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBorrowerAllowed
     */
    daysInOverdue?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBorrowerAllowed
     */
    defaultInterestBalance?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBorrowerAllowed
     */
    earlyRepaymentFee?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBorrowerAllowed
     */
    fullRepaymentAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBorrowerAllowed
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBorrowerAllowed
     */
    interestBalance?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBorrowerAllowed
     */
    interestOverdue?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBorrowerAllowed
     */
    nextPaymentAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBorrowerAllowed
     */
    outstandingBalance?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBorrowerAllowed
     */
    outstandingLtvPct?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBorrowerAllowed
     */
    overdueAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanSnapshotDtoBorrowerAllowed
     */
    overdueDate?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBorrowerAllowed
     */
    penalties?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBorrowerAllowed
     */
    principalBalance?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBorrowerAllowed
     */
    principalOverdue?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBorrowerAllowed
     */
    technicalAccount?: number;
}
/**
 * 
 * @export
 * @interface LoanSnapshotDtoBrief
 */
export interface LoanSnapshotDtoBrief {
    /**
     * 
     * @type {string}
     * @memberof LoanSnapshotDtoBrief
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanSnapshotDtoBrief
     */
    date?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBrief
     */
    daysInOverdue?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBrief
     */
    defaultInterestBalance?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBrief
     */
    earlyRepaymentFee?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBrief
     */
    fullRepaymentAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBrief
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBrief
     */
    interestBalance?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBrief
     */
    interestOverdue?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBrief
     */
    nextPaymentAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBrief
     */
    outstandingBalance?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBrief
     */
    outstandingLtvPct?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBrief
     */
    overdueAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanSnapshotDtoBrief
     */
    overdueDate?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBrief
     */
    penalties?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBrief
     */
    principalBalance?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBrief
     */
    principalOverdue?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanSnapshotDtoBrief
     */
    technicalAccount?: number;
}
/**
 * 
 * @export
 * @interface ModelFile
 */
export interface ModelFile {
    /**
     * 
     * @type {boolean}
     * @memberof ModelFile
     */
    attached?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ModelFile
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    originalName?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    storage?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    uuid?: string;
}
/**
 * 
 * @export
 * @interface NotificationTemplateDto
 */
export interface NotificationTemplateDto {
    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateDto
     */
    body?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateDto
     */
    channel?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateDto
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateDto
     */
    event?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateDto
     */
    eventCode?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateDto
     */
    eventReason?: string;
    /**
     * 
     * @type {number}
     * @memberof NotificationTemplateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateDto
     */
    localization?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateDto
     */
    signature?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateDto
     */
    subject?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateDto
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateDto
     */
    updatedBy?: string;
}
/**
 * 
 * @export
 * @interface NotificationTemplateRequest
 */
export interface NotificationTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateRequest
     */
    body: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateRequest
     */
    channel: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateRequest
     */
    event: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateRequest
     */
    eventCode: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateRequest
     */
    eventReason: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateRequest
     */
    localization: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateRequest
     */
    signature: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationTemplateRequest
     */
    subject?: string;
}
/**
 * 
 * @export
 * @interface PageActivityAuditTrailDto
 */
export interface PageActivityAuditTrailDto {
    /**
     * 
     * @type {Array<ActivityAuditTrailDto>}
     * @memberof PageActivityAuditTrailDto
     */
    content?: Array<ActivityAuditTrailDto>;
    /**
     * 
     * @type {boolean}
     * @memberof PageActivityAuditTrailDto
     */
    empty?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageActivityAuditTrailDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageActivityAuditTrailDto
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageActivityAuditTrailDto
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof PageActivityAuditTrailDto
     */
    numberOfElements?: number;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageActivityAuditTrailDto
     */
    pageable?: PageableObject;
    /**
     * 
     * @type {number}
     * @memberof PageActivityAuditTrailDto
     */
    size?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageActivityAuditTrailDto
     */
    sort?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageActivityAuditTrailDto
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageActivityAuditTrailDto
     */
    totalPages?: number;
}
/**
 * 
 * @export
 * @interface PageAgentDtoBrief
 */
export interface PageAgentDtoBrief {
    /**
     * 
     * @type {Array<AgentDtoBrief>}
     * @memberof PageAgentDtoBrief
     */
    content?: Array<AgentDtoBrief>;
    /**
     * 
     * @type {boolean}
     * @memberof PageAgentDtoBrief
     */
    empty?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageAgentDtoBrief
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageAgentDtoBrief
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageAgentDtoBrief
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof PageAgentDtoBrief
     */
    numberOfElements?: number;
    /**
     * 
     * @type {PageableObjectBrief}
     * @memberof PageAgentDtoBrief
     */
    pageable?: PageableObjectBrief;
    /**
     * 
     * @type {number}
     * @memberof PageAgentDtoBrief
     */
    size?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageAgentDtoBrief
     */
    sort?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageAgentDtoBrief
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageAgentDtoBrief
     */
    totalPages?: number;
}
/**
 * 
 * @export
 * @interface PageBorrowerDtoBrief
 */
export interface PageBorrowerDtoBrief {
    /**
     * 
     * @type {Array<BorrowerDtoBrief>}
     * @memberof PageBorrowerDtoBrief
     */
    content?: Array<BorrowerDtoBrief>;
    /**
     * 
     * @type {boolean}
     * @memberof PageBorrowerDtoBrief
     */
    empty?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageBorrowerDtoBrief
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageBorrowerDtoBrief
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageBorrowerDtoBrief
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof PageBorrowerDtoBrief
     */
    numberOfElements?: number;
    /**
     * 
     * @type {PageableObjectBrief}
     * @memberof PageBorrowerDtoBrief
     */
    pageable?: PageableObjectBrief;
    /**
     * 
     * @type {number}
     * @memberof PageBorrowerDtoBrief
     */
    size?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageBorrowerDtoBrief
     */
    sort?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageBorrowerDtoBrief
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageBorrowerDtoBrief
     */
    totalPages?: number;
}
/**
 * 
 * @export
 * @interface PageBorrowerRevisionDto
 */
export interface PageBorrowerRevisionDto {
    /**
     * 
     * @type {Array<BorrowerRevisionDto>}
     * @memberof PageBorrowerRevisionDto
     */
    content?: Array<BorrowerRevisionDto>;
    /**
     * 
     * @type {boolean}
     * @memberof PageBorrowerRevisionDto
     */
    empty?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageBorrowerRevisionDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageBorrowerRevisionDto
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageBorrowerRevisionDto
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof PageBorrowerRevisionDto
     */
    numberOfElements?: number;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageBorrowerRevisionDto
     */
    pageable?: PageableObject;
    /**
     * 
     * @type {number}
     * @memberof PageBorrowerRevisionDto
     */
    size?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageBorrowerRevisionDto
     */
    sort?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageBorrowerRevisionDto
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageBorrowerRevisionDto
     */
    totalPages?: number;
}
/**
 * 
 * @export
 * @interface PageCampaignDtoBrief
 */
export interface PageCampaignDtoBrief {
    /**
     * 
     * @type {Array<CampaignDtoBrief>}
     * @memberof PageCampaignDtoBrief
     */
    content?: Array<CampaignDtoBrief>;
    /**
     * 
     * @type {boolean}
     * @memberof PageCampaignDtoBrief
     */
    empty?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageCampaignDtoBrief
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageCampaignDtoBrief
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageCampaignDtoBrief
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof PageCampaignDtoBrief
     */
    numberOfElements?: number;
    /**
     * 
     * @type {PageableObjectBrief}
     * @memberof PageCampaignDtoBrief
     */
    pageable?: PageableObjectBrief;
    /**
     * 
     * @type {number}
     * @memberof PageCampaignDtoBrief
     */
    size?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageCampaignDtoBrief
     */
    sort?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageCampaignDtoBrief
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageCampaignDtoBrief
     */
    totalPages?: number;
}
/**
 * 
 * @export
 * @interface PageCollectionItemDtoBrief
 */
export interface PageCollectionItemDtoBrief {
    /**
     * 
     * @type {Array<CollectionItemDtoBrief>}
     * @memberof PageCollectionItemDtoBrief
     */
    content?: Array<CollectionItemDtoBrief>;
    /**
     * 
     * @type {boolean}
     * @memberof PageCollectionItemDtoBrief
     */
    empty?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageCollectionItemDtoBrief
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageCollectionItemDtoBrief
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageCollectionItemDtoBrief
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof PageCollectionItemDtoBrief
     */
    numberOfElements?: number;
    /**
     * 
     * @type {PageableObjectBrief}
     * @memberof PageCollectionItemDtoBrief
     */
    pageable?: PageableObjectBrief;
    /**
     * 
     * @type {number}
     * @memberof PageCollectionItemDtoBrief
     */
    size?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageCollectionItemDtoBrief
     */
    sort?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageCollectionItemDtoBrief
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageCollectionItemDtoBrief
     */
    totalPages?: number;
}
/**
 * 
 * @export
 * @interface PageDocumentTemplateDto
 */
export interface PageDocumentTemplateDto {
    /**
     * 
     * @type {Array<DocumentTemplateDto>}
     * @memberof PageDocumentTemplateDto
     */
    content?: Array<DocumentTemplateDto>;
    /**
     * 
     * @type {boolean}
     * @memberof PageDocumentTemplateDto
     */
    empty?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageDocumentTemplateDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageDocumentTemplateDto
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageDocumentTemplateDto
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof PageDocumentTemplateDto
     */
    numberOfElements?: number;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageDocumentTemplateDto
     */
    pageable?: PageableObject;
    /**
     * 
     * @type {number}
     * @memberof PageDocumentTemplateDto
     */
    size?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageDocumentTemplateDto
     */
    sort?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageDocumentTemplateDto
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageDocumentTemplateDto
     */
    totalPages?: number;
}
/**
 * 
 * @export
 * @interface PageLeadDtoBrief
 */
export interface PageLeadDtoBrief {
    /**
     * 
     * @type {Array<LeadDtoBrief>}
     * @memberof PageLeadDtoBrief
     */
    content?: Array<LeadDtoBrief>;
    /**
     * 
     * @type {boolean}
     * @memberof PageLeadDtoBrief
     */
    empty?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageLeadDtoBrief
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageLeadDtoBrief
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageLeadDtoBrief
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof PageLeadDtoBrief
     */
    numberOfElements?: number;
    /**
     * 
     * @type {PageableObjectBrief}
     * @memberof PageLeadDtoBrief
     */
    pageable?: PageableObjectBrief;
    /**
     * 
     * @type {number}
     * @memberof PageLeadDtoBrief
     */
    size?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageLeadDtoBrief
     */
    sort?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageLeadDtoBrief
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageLeadDtoBrief
     */
    totalPages?: number;
}
/**
 * 
 * @export
 * @interface PageLoanAdjustmentsRequestDtoBorrowerAllowed
 */
export interface PageLoanAdjustmentsRequestDtoBorrowerAllowed {
    /**
     * 
     * @type {Array<LoanAdjustmentsRequestDtoBorrowerAllowed>}
     * @memberof PageLoanAdjustmentsRequestDtoBorrowerAllowed
     */
    content?: Array<LoanAdjustmentsRequestDtoBorrowerAllowed>;
    /**
     * 
     * @type {boolean}
     * @memberof PageLoanAdjustmentsRequestDtoBorrowerAllowed
     */
    empty?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageLoanAdjustmentsRequestDtoBorrowerAllowed
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageLoanAdjustmentsRequestDtoBorrowerAllowed
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageLoanAdjustmentsRequestDtoBorrowerAllowed
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof PageLoanAdjustmentsRequestDtoBorrowerAllowed
     */
    numberOfElements?: number;
    /**
     * 
     * @type {PageableObjectBorrowerAllowed}
     * @memberof PageLoanAdjustmentsRequestDtoBorrowerAllowed
     */
    pageable?: PageableObjectBorrowerAllowed;
    /**
     * 
     * @type {number}
     * @memberof PageLoanAdjustmentsRequestDtoBorrowerAllowed
     */
    size?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageLoanAdjustmentsRequestDtoBorrowerAllowed
     */
    sort?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageLoanAdjustmentsRequestDtoBorrowerAllowed
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageLoanAdjustmentsRequestDtoBorrowerAllowed
     */
    totalPages?: number;
}
/**
 * 
 * @export
 * @interface PageLoanApplicationDtoBorrowerAllowed
 */
export interface PageLoanApplicationDtoBorrowerAllowed {
    /**
     * 
     * @type {Array<LoanApplicationDtoBorrowerAllowed>}
     * @memberof PageLoanApplicationDtoBorrowerAllowed
     */
    content?: Array<LoanApplicationDtoBorrowerAllowed>;
    /**
     * 
     * @type {boolean}
     * @memberof PageLoanApplicationDtoBorrowerAllowed
     */
    empty?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageLoanApplicationDtoBorrowerAllowed
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageLoanApplicationDtoBorrowerAllowed
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageLoanApplicationDtoBorrowerAllowed
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof PageLoanApplicationDtoBorrowerAllowed
     */
    numberOfElements?: number;
    /**
     * 
     * @type {PageableObjectBorrowerAllowed}
     * @memberof PageLoanApplicationDtoBorrowerAllowed
     */
    pageable?: PageableObjectBorrowerAllowed;
    /**
     * 
     * @type {number}
     * @memberof PageLoanApplicationDtoBorrowerAllowed
     */
    size?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageLoanApplicationDtoBorrowerAllowed
     */
    sort?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageLoanApplicationDtoBorrowerAllowed
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageLoanApplicationDtoBorrowerAllowed
     */
    totalPages?: number;
}
/**
 * 
 * @export
 * @interface PageLoanApplicationDtoBrief
 */
export interface PageLoanApplicationDtoBrief {
    /**
     * 
     * @type {Array<LoanApplicationDtoBrief>}
     * @memberof PageLoanApplicationDtoBrief
     */
    content?: Array<LoanApplicationDtoBrief>;
    /**
     * 
     * @type {boolean}
     * @memberof PageLoanApplicationDtoBrief
     */
    empty?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageLoanApplicationDtoBrief
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageLoanApplicationDtoBrief
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageLoanApplicationDtoBrief
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof PageLoanApplicationDtoBrief
     */
    numberOfElements?: number;
    /**
     * 
     * @type {PageableObjectBrief}
     * @memberof PageLoanApplicationDtoBrief
     */
    pageable?: PageableObjectBrief;
    /**
     * 
     * @type {number}
     * @memberof PageLoanApplicationDtoBrief
     */
    size?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageLoanApplicationDtoBrief
     */
    sort?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageLoanApplicationDtoBrief
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageLoanApplicationDtoBrief
     */
    totalPages?: number;
}
/**
 * 
 * @export
 * @interface PageLoanDtoBorrowerAllowed
 */
export interface PageLoanDtoBorrowerAllowed {
    /**
     * 
     * @type {Array<LoanDtoBorrowerAllowed>}
     * @memberof PageLoanDtoBorrowerAllowed
     */
    content?: Array<LoanDtoBorrowerAllowed>;
    /**
     * 
     * @type {boolean}
     * @memberof PageLoanDtoBorrowerAllowed
     */
    empty?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageLoanDtoBorrowerAllowed
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageLoanDtoBorrowerAllowed
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageLoanDtoBorrowerAllowed
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof PageLoanDtoBorrowerAllowed
     */
    numberOfElements?: number;
    /**
     * 
     * @type {PageableObjectBorrowerAllowed}
     * @memberof PageLoanDtoBorrowerAllowed
     */
    pageable?: PageableObjectBorrowerAllowed;
    /**
     * 
     * @type {number}
     * @memberof PageLoanDtoBorrowerAllowed
     */
    size?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageLoanDtoBorrowerAllowed
     */
    sort?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageLoanDtoBorrowerAllowed
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageLoanDtoBorrowerAllowed
     */
    totalPages?: number;
}
/**
 * 
 * @export
 * @interface PageLoanDtoBrief
 */
export interface PageLoanDtoBrief {
    /**
     * 
     * @type {Array<LoanDtoBrief>}
     * @memberof PageLoanDtoBrief
     */
    content?: Array<LoanDtoBrief>;
    /**
     * 
     * @type {boolean}
     * @memberof PageLoanDtoBrief
     */
    empty?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageLoanDtoBrief
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageLoanDtoBrief
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageLoanDtoBrief
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof PageLoanDtoBrief
     */
    numberOfElements?: number;
    /**
     * 
     * @type {PageableObjectBrief}
     * @memberof PageLoanDtoBrief
     */
    pageable?: PageableObjectBrief;
    /**
     * 
     * @type {number}
     * @memberof PageLoanDtoBrief
     */
    size?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageLoanDtoBrief
     */
    sort?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageLoanDtoBrief
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageLoanDtoBrief
     */
    totalPages?: number;
}
/**
 * 
 * @export
 * @interface PageLoanOperationDto
 */
export interface PageLoanOperationDto {
    /**
     * 
     * @type {Array<LoanOperationDto>}
     * @memberof PageLoanOperationDto
     */
    content?: Array<LoanOperationDto>;
    /**
     * 
     * @type {boolean}
     * @memberof PageLoanOperationDto
     */
    empty?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageLoanOperationDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageLoanOperationDto
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageLoanOperationDto
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof PageLoanOperationDto
     */
    numberOfElements?: number;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageLoanOperationDto
     */
    pageable?: PageableObject;
    /**
     * 
     * @type {number}
     * @memberof PageLoanOperationDto
     */
    size?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageLoanOperationDto
     */
    sort?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageLoanOperationDto
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageLoanOperationDto
     */
    totalPages?: number;
}
/**
 * 
 * @export
 * @interface PageLoanProductDto
 */
export interface PageLoanProductDto {
    /**
     * 
     * @type {Array<LoanProductDto>}
     * @memberof PageLoanProductDto
     */
    content?: Array<LoanProductDto>;
    /**
     * 
     * @type {boolean}
     * @memberof PageLoanProductDto
     */
    empty?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageLoanProductDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageLoanProductDto
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageLoanProductDto
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof PageLoanProductDto
     */
    numberOfElements?: number;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageLoanProductDto
     */
    pageable?: PageableObject;
    /**
     * 
     * @type {number}
     * @memberof PageLoanProductDto
     */
    size?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageLoanProductDto
     */
    sort?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageLoanProductDto
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageLoanProductDto
     */
    totalPages?: number;
}
/**
 * 
 * @export
 * @interface PageLoanProductRevisionDto
 */
export interface PageLoanProductRevisionDto {
    /**
     * 
     * @type {Array<LoanProductRevisionDto>}
     * @memberof PageLoanProductRevisionDto
     */
    content?: Array<LoanProductRevisionDto>;
    /**
     * 
     * @type {boolean}
     * @memberof PageLoanProductRevisionDto
     */
    empty?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageLoanProductRevisionDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageLoanProductRevisionDto
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageLoanProductRevisionDto
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof PageLoanProductRevisionDto
     */
    numberOfElements?: number;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageLoanProductRevisionDto
     */
    pageable?: PageableObject;
    /**
     * 
     * @type {number}
     * @memberof PageLoanProductRevisionDto
     */
    size?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageLoanProductRevisionDto
     */
    sort?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageLoanProductRevisionDto
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageLoanProductRevisionDto
     */
    totalPages?: number;
}
/**
 * 
 * @export
 * @interface PageNotificationTemplateDto
 */
export interface PageNotificationTemplateDto {
    /**
     * 
     * @type {Array<NotificationTemplateDto>}
     * @memberof PageNotificationTemplateDto
     */
    content?: Array<NotificationTemplateDto>;
    /**
     * 
     * @type {boolean}
     * @memberof PageNotificationTemplateDto
     */
    empty?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageNotificationTemplateDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageNotificationTemplateDto
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageNotificationTemplateDto
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof PageNotificationTemplateDto
     */
    numberOfElements?: number;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageNotificationTemplateDto
     */
    pageable?: PageableObject;
    /**
     * 
     * @type {number}
     * @memberof PageNotificationTemplateDto
     */
    size?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageNotificationTemplateDto
     */
    sort?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageNotificationTemplateDto
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageNotificationTemplateDto
     */
    totalPages?: number;
}
/**
 * 
 * @export
 * @interface PageScoringModelVersionSettingsDto
 */
export interface PageScoringModelVersionSettingsDto {
    /**
     * 
     * @type {Array<ScoringModelVersionSettingsDto>}
     * @memberof PageScoringModelVersionSettingsDto
     */
    content?: Array<ScoringModelVersionSettingsDto>;
    /**
     * 
     * @type {boolean}
     * @memberof PageScoringModelVersionSettingsDto
     */
    empty?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageScoringModelVersionSettingsDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageScoringModelVersionSettingsDto
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageScoringModelVersionSettingsDto
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof PageScoringModelVersionSettingsDto
     */
    numberOfElements?: number;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageScoringModelVersionSettingsDto
     */
    pageable?: PageableObject;
    /**
     * 
     * @type {number}
     * @memberof PageScoringModelVersionSettingsDto
     */
    size?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageScoringModelVersionSettingsDto
     */
    sort?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageScoringModelVersionSettingsDto
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageScoringModelVersionSettingsDto
     */
    totalPages?: number;
}
/**
 * 
 * @export
 * @interface PageTaskRepresentation
 */
export interface PageTaskRepresentation {
    /**
     * 
     * @type {Array<TaskRepresentation>}
     * @memberof PageTaskRepresentation
     */
    content?: Array<TaskRepresentation>;
    /**
     * 
     * @type {boolean}
     * @memberof PageTaskRepresentation
     */
    empty?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageTaskRepresentation
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageTaskRepresentation
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageTaskRepresentation
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof PageTaskRepresentation
     */
    numberOfElements?: number;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageTaskRepresentation
     */
    pageable?: PageableObject;
    /**
     * 
     * @type {number}
     * @memberof PageTaskRepresentation
     */
    size?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageTaskRepresentation
     */
    sort?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageTaskRepresentation
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageTaskRepresentation
     */
    totalPages?: number;
}
/**
 * 
 * @export
 * @interface PageTransactionDtoBorrowerAllowed
 */
export interface PageTransactionDtoBorrowerAllowed {
    /**
     * 
     * @type {Array<TransactionDtoBorrowerAllowed>}
     * @memberof PageTransactionDtoBorrowerAllowed
     */
    content?: Array<TransactionDtoBorrowerAllowed>;
    /**
     * 
     * @type {boolean}
     * @memberof PageTransactionDtoBorrowerAllowed
     */
    empty?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageTransactionDtoBorrowerAllowed
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageTransactionDtoBorrowerAllowed
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageTransactionDtoBorrowerAllowed
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof PageTransactionDtoBorrowerAllowed
     */
    numberOfElements?: number;
    /**
     * 
     * @type {PageableObjectBorrowerAllowed}
     * @memberof PageTransactionDtoBorrowerAllowed
     */
    pageable?: PageableObjectBorrowerAllowed;
    /**
     * 
     * @type {number}
     * @memberof PageTransactionDtoBorrowerAllowed
     */
    size?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageTransactionDtoBorrowerAllowed
     */
    sort?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageTransactionDtoBorrowerAllowed
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageTransactionDtoBorrowerAllowed
     */
    totalPages?: number;
}
/**
 * 
 * @export
 * @interface PageTransactionDtoBrief
 */
export interface PageTransactionDtoBrief {
    /**
     * 
     * @type {Array<TransactionDtoBrief>}
     * @memberof PageTransactionDtoBrief
     */
    content?: Array<TransactionDtoBrief>;
    /**
     * 
     * @type {boolean}
     * @memberof PageTransactionDtoBrief
     */
    empty?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageTransactionDtoBrief
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageTransactionDtoBrief
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageTransactionDtoBrief
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof PageTransactionDtoBrief
     */
    numberOfElements?: number;
    /**
     * 
     * @type {PageableObjectBrief}
     * @memberof PageTransactionDtoBrief
     */
    pageable?: PageableObjectBrief;
    /**
     * 
     * @type {number}
     * @memberof PageTransactionDtoBrief
     */
    size?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageTransactionDtoBrief
     */
    sort?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageTransactionDtoBrief
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageTransactionDtoBrief
     */
    totalPages?: number;
}
/**
 * 
 * @export
 * @interface PageUser
 */
export interface PageUser {
    /**
     * 
     * @type {Array<User>}
     * @memberof PageUser
     */
    content?: Array<User>;
    /**
     * 
     * @type {boolean}
     * @memberof PageUser
     */
    empty?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageUser
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageUser
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageUser
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof PageUser
     */
    numberOfElements?: number;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageUser
     */
    pageable?: PageableObject;
    /**
     * 
     * @type {number}
     * @memberof PageUser
     */
    size?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageUser
     */
    sort?: Array<SortObject>;
    /**
     * 
     * @type {number}
     * @memberof PageUser
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageUser
     */
    totalPages?: number;
}
/**
 * 
 * @export
 * @interface PageableObject
 */
export interface PageableObject {
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    offset?: number;
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    pageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    pageSize?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageableObject
     */
    paged?: boolean;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageableObject
     */
    sort?: Array<SortObject>;
    /**
     * 
     * @type {boolean}
     * @memberof PageableObject
     */
    unpaged?: boolean;
}
/**
 * 
 * @export
 * @interface PageableObjectBorrowerAllowed
 */
export interface PageableObjectBorrowerAllowed {
    /**
     * 
     * @type {number}
     * @memberof PageableObjectBorrowerAllowed
     */
    offset?: number;
    /**
     * 
     * @type {number}
     * @memberof PageableObjectBorrowerAllowed
     */
    pageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof PageableObjectBorrowerAllowed
     */
    pageSize?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageableObjectBorrowerAllowed
     */
    paged?: boolean;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageableObjectBorrowerAllowed
     */
    sort?: Array<SortObject>;
    /**
     * 
     * @type {boolean}
     * @memberof PageableObjectBorrowerAllowed
     */
    unpaged?: boolean;
}
/**
 * 
 * @export
 * @interface PageableObjectBrief
 */
export interface PageableObjectBrief {
    /**
     * 
     * @type {number}
     * @memberof PageableObjectBrief
     */
    offset?: number;
    /**
     * 
     * @type {number}
     * @memberof PageableObjectBrief
     */
    pageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof PageableObjectBrief
     */
    pageSize?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageableObjectBrief
     */
    paged?: boolean;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageableObjectBrief
     */
    sort?: Array<SortObject>;
    /**
     * 
     * @type {boolean}
     * @memberof PageableObjectBrief
     */
    unpaged?: boolean;
}
/**
 * 
 * @export
 * @interface Person
 */
export interface Person extends Borrower {
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    birthDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    citizenship?: string;
    /**
     * 
     * @type {number}
     * @memberof Person
     */
    currentAge?: number;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof Person
     */
    details?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    gender?: string;
    /**
     * 
     * @type {IdDocument}
     * @memberof Person
     */
    idDocument?: IdDocument;
    /**
     * 
     * @type {KycResults}
     * @memberof Person
     */
    kycResults?: KycResults;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    middleName?: string;
    /**
     * 
     * @type {number}
     * @memberof Person
     */
    numberOfDependents?: number;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface PersonAllOf
 */
export interface PersonAllOf {
    /**
     * 
     * @type {string}
     * @memberof PersonAllOf
     */
    birthDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonAllOf
     */
    citizenship?: string;
    /**
     * 
     * @type {number}
     * @memberof PersonAllOf
     */
    currentAge?: number;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof PersonAllOf
     */
    details?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof PersonAllOf
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonAllOf
     */
    gender?: string;
    /**
     * 
     * @type {IdDocument}
     * @memberof PersonAllOf
     */
    idDocument?: IdDocument;
    /**
     * 
     * @type {KycResults}
     * @memberof PersonAllOf
     */
    kycResults?: KycResults;
    /**
     * 
     * @type {string}
     * @memberof PersonAllOf
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonAllOf
     */
    middleName?: string;
    /**
     * 
     * @type {number}
     * @memberof PersonAllOf
     */
    numberOfDependents?: number;
    /**
     * 
     * @type {string}
     * @memberof PersonAllOf
     */
    title?: string;
}
/**
 * 
 * @export
 * @interface PersonLoanManagement
 */
export interface PersonLoanManagement {
    /**
     * 
     * @type {AddressInbound}
     * @memberof PersonLoanManagement
     */
    address: AddressInbound;
    /**
     * 
     * @type {BankAccountInbound}
     * @memberof PersonLoanManagement
     */
    bankAccount: BankAccountInbound;
    /**
     * 
     * @type {string}
     * @memberof PersonLoanManagement
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof PersonLoanManagement
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof PersonLoanManagement
     */
    taxNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonLoanManagement
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonLoanManagement
     */
    birthDate: string;
    /**
     * ISO 3166-1 Alpha-3 code. Available values: [ AFG, ALB, DZA, ASM, AND, AGO, AIA, ATA, ATG, ARG, ARM, ABW, AUS, AUT, AZE, BHS, BHR, BGD, BRB, BLR, BEL, BLZ, BEN, BMU, BTN, BOL, BES, BIH, BWA, BVT, BRA, IOT, BRN, BGR, BFA, BDI, CPV, KHM, CMR, CAN, CYM, CAF, TCD, CHL, CHN, CXR, CCK, COL, COM, COD, COG, COK, CRI, HRV, CUB, CUW, CYP, CZE, CIV, DNK, DJI, DMA, DOM, ECU, EGY, SLV, GNQ, ERI, EST, SWZ, ETH, FLK, FRO, FJI, FIN, FRA, GUF, PYF, ATF, GAB, GMB, GEO, DEU, GHA, GIB, GRC, GRL, GRD, GLP, GUM, GTM, GGY, GIN, GNB, GUY, HTI, HMD, VAT, HND, HKG, HUN, ISL, IND, IDN, IRN, IRQ, IRL, IMN, ISR, ITA, JAM, JPN, JEY, JOR, KAZ, KEN, KIR, PRK, KOR, KWT, KGZ, LAO, LVA, LBN, LSO, LBR, LBY, LIE, LTU, LUX, MAC, MDG, MWI, MYS, MDV, MLI, MLT, MHL, MTQ, MRT, MUS, MYT, MEX, FSM, MDA, MCO, MNG, MNE, MSR, MAR, MOZ, MMR, NAM, NRU, NPL, NLD, NCL, NZL, NIC, NER, NGA, NIU, NFK, MNP, NOR, OMN, PAK, PLW, PSE, PAN, PNG, PRY, PER, PHL, PCN, POL, PRT, PRI, QAT, MKD, ROU, RUS, RWA, REU, BLM, SHN, KNA, LCA, MAF, SPM, VCT, WSM, SMR, STP, SAU, SEN, SRB, SYC, SLE, SGP, SXM, SVK, SVN, SLB, SOM, ZAF, SGS, SSD, ESP, LKA, SDN, SUR, SJM, SWE, CHE, SYR, TWN, TJK, TZA, THA, TLS, TGO, TKL, TON, TTO, TUN, TUR, TKM, TCA, TUV, UGA, UKR, ARE, GBR, UMI, USA, URY, UZB, VUT, VEN, VNM, VGB, VIR, WLF, ESH, YEM, ZMB, ZWE, ALA ]
     * @type {string}
     * @memberof PersonLoanManagement
     */
    citizenship?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonLoanManagement
     */
    firstName: string;
    /**
     * 
     * @type {IdDocumentLoanManagement}
     * @memberof PersonLoanManagement
     */
    idDocument: IdDocumentLoanManagement;
    /**
     * 
     * @type {string}
     * @memberof PersonLoanManagement
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PersonLoanManagement
     */
    middleName?: string;
}
/**
 * 
 * @export
 * @interface PersonLoanManagementAllOf
 */
export interface PersonLoanManagementAllOf {
    /**
     * 
     * @type {string}
     * @memberof PersonLoanManagementAllOf
     */
    birthDate?: string;
    /**
     * ISO 3166-1 Alpha-3 code. Available values: [ AFG, ALB, DZA, ASM, AND, AGO, AIA, ATA, ATG, ARG, ARM, ABW, AUS, AUT, AZE, BHS, BHR, BGD, BRB, BLR, BEL, BLZ, BEN, BMU, BTN, BOL, BES, BIH, BWA, BVT, BRA, IOT, BRN, BGR, BFA, BDI, CPV, KHM, CMR, CAN, CYM, CAF, TCD, CHL, CHN, CXR, CCK, COL, COM, COD, COG, COK, CRI, HRV, CUB, CUW, CYP, CZE, CIV, DNK, DJI, DMA, DOM, ECU, EGY, SLV, GNQ, ERI, EST, SWZ, ETH, FLK, FRO, FJI, FIN, FRA, GUF, PYF, ATF, GAB, GMB, GEO, DEU, GHA, GIB, GRC, GRL, GRD, GLP, GUM, GTM, GGY, GIN, GNB, GUY, HTI, HMD, VAT, HND, HKG, HUN, ISL, IND, IDN, IRN, IRQ, IRL, IMN, ISR, ITA, JAM, JPN, JEY, JOR, KAZ, KEN, KIR, PRK, KOR, KWT, KGZ, LAO, LVA, LBN, LSO, LBR, LBY, LIE, LTU, LUX, MAC, MDG, MWI, MYS, MDV, MLI, MLT, MHL, MTQ, MRT, MUS, MYT, MEX, FSM, MDA, MCO, MNG, MNE, MSR, MAR, MOZ, MMR, NAM, NRU, NPL, NLD, NCL, NZL, NIC, NER, NGA, NIU, NFK, MNP, NOR, OMN, PAK, PLW, PSE, PAN, PNG, PRY, PER, PHL, PCN, POL, PRT, PRI, QAT, MKD, ROU, RUS, RWA, REU, BLM, SHN, KNA, LCA, MAF, SPM, VCT, WSM, SMR, STP, SAU, SEN, SRB, SYC, SLE, SGP, SXM, SVK, SVN, SLB, SOM, ZAF, SGS, SSD, ESP, LKA, SDN, SUR, SJM, SWE, CHE, SYR, TWN, TJK, TZA, THA, TLS, TGO, TKL, TON, TTO, TUN, TUR, TKM, TCA, TUV, UGA, UKR, ARE, GBR, UMI, USA, URY, UZB, VUT, VEN, VNM, VGB, VIR, WLF, ESH, YEM, ZMB, ZWE, ALA ]
     * @type {string}
     * @memberof PersonLoanManagementAllOf
     */
    citizenship?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonLoanManagementAllOf
     */
    firstName?: string;
    /**
     * 
     * @type {IdDocumentLoanManagement}
     * @memberof PersonLoanManagementAllOf
     */
    idDocument?: IdDocumentLoanManagement;
    /**
     * 
     * @type {string}
     * @memberof PersonLoanManagementAllOf
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonLoanManagementAllOf
     */
    middleName?: string;
}
/**
 * Borrower details
 * @export
 * @interface PersonLoanOrigination
 */
export interface PersonLoanOrigination {
    /**
     * 
     * @type {AddressInbound}
     * @memberof PersonLoanOrigination
     */
    address: AddressInbound;
    /**
     * 
     * @type {BankAccountInbound}
     * @memberof PersonLoanOrigination
     */
    bankAccount: BankAccountInbound;
    /**
     * 
     * @type {string}
     * @memberof PersonLoanOrigination
     */
    birthDate: string;
    /**
     * ISO 3166-1 Alpha-3 code. Available values: [ AFG, ALB, DZA, ASM, AND, AGO, AIA, ATA, ATG, ARG, ARM, ABW, AUS, AUT, AZE, BHS, BHR, BGD, BRB, BLR, BEL, BLZ, BEN, BMU, BTN, BOL, BES, BIH, BWA, BVT, BRA, IOT, BRN, BGR, BFA, BDI, CPV, KHM, CMR, CAN, CYM, CAF, TCD, CHL, CHN, CXR, CCK, COL, COM, COD, COG, COK, CRI, HRV, CUB, CUW, CYP, CZE, CIV, DNK, DJI, DMA, DOM, ECU, EGY, SLV, GNQ, ERI, EST, SWZ, ETH, FLK, FRO, FJI, FIN, FRA, GUF, PYF, ATF, GAB, GMB, GEO, DEU, GHA, GIB, GRC, GRL, GRD, GLP, GUM, GTM, GGY, GIN, GNB, GUY, HTI, HMD, VAT, HND, HKG, HUN, ISL, IND, IDN, IRN, IRQ, IRL, IMN, ISR, ITA, JAM, JPN, JEY, JOR, KAZ, KEN, KIR, PRK, KOR, KWT, KGZ, LAO, LVA, LBN, LSO, LBR, LBY, LIE, LTU, LUX, MAC, MDG, MWI, MYS, MDV, MLI, MLT, MHL, MTQ, MRT, MUS, MYT, MEX, FSM, MDA, MCO, MNG, MNE, MSR, MAR, MOZ, MMR, NAM, NRU, NPL, NLD, NCL, NZL, NIC, NER, NGA, NIU, NFK, MNP, NOR, OMN, PAK, PLW, PSE, PAN, PNG, PRY, PER, PHL, PCN, POL, PRT, PRI, QAT, MKD, ROU, RUS, RWA, REU, BLM, SHN, KNA, LCA, MAF, SPM, VCT, WSM, SMR, STP, SAU, SEN, SRB, SYC, SLE, SGP, SXM, SVK, SVN, SLB, SOM, ZAF, SGS, SSD, ESP, LKA, SDN, SUR, SJM, SWE, CHE, SYR, TWN, TJK, TZA, THA, TLS, TGO, TKL, TON, TTO, TUN, TUR, TKM, TCA, TUV, UGA, UKR, ARE, GBR, UMI, USA, URY, UZB, VUT, VEN, VNM, VGB, VIR, WLF, ESH, YEM, ZMB, ZWE, ALA ]
     * @type {string}
     * @memberof PersonLoanOrigination
     */
    citizenship?: string;
    /**
     * Available values: [ No formal education, Elementary school completed, High school graduate, Bachelor\'s degree, Master\'s degree, Doctorate degree ]
     * @type {string}
     * @memberof PersonLoanOrigination
     */
    education?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonLoanOrigination
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof PersonLoanOrigination
     */
    firstName: string;
    /**
     * 
     * @type {IdDocumentLoanOrigination}
     * @memberof PersonLoanOrigination
     */
    idDocument: IdDocumentLoanOrigination;
    /**
     * Available values: [ Agriculture; Plantations; Other rural sectors, Basic metal production, Chemical industries, Commerce, Construction, Education, Financial services, Food; Drink; Tobacco, Forestry; Wood; Pulp and paper, Health services, Hotels; Tourism; Catering, Information technology, Mining, Mechanical and electrical engineering, Media; Culture; Graphical, Postal and telecommunications services, Public service, Real estate; Rental; Leasing, Repair and maintenance, Shipping; Ports; Fisheries; Inland waterways, Textiles; Clothing; Leather; Footwear, Transport, Utilities ]
     * @type {string}
     * @memberof PersonLoanOrigination
     */
    industry?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonLoanOrigination
     */
    lastName: string;
    /**
     * Available values: [ < 6 months, 6 - 12 months, 1 - 2 years, 2 - 4 years, > 4 years ]
     * @type {string}
     * @memberof PersonLoanOrigination
     */
    lengthOfEmployment?: string;
    /**
     * Available values: [ Married, Widowed, Separated, Divorced, Single ]
     * @type {string}
     * @memberof PersonLoanOrigination
     */
    maritalStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonLoanOrigination
     */
    middleName?: string;
    /**
     * 
     * @type {number}
     * @memberof PersonLoanOrigination
     */
    monthlyIncome?: number;
    /**
     * 
     * @type {string}
     * @memberof PersonLoanOrigination
     */
    phone: string;
    /**
     * Borrower\'s current job position. Available values: [ Trainee, Regular employee, Middle level manager, Senior level manager, Owner, Retired, Non-employed ]
     * @type {string}
     * @memberof PersonLoanOrigination
     */
    position?: string;
    /**
     * Flag indicating whether the borrower has a property
     * @type {boolean}
     * @memberof PersonLoanOrigination
     */
    property?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PersonLoanOrigination
     */
    taxNumber?: string;
    /**
     * Flag indicating whether the borrower has a vehicle
     * @type {boolean}
     * @memberof PersonLoanOrigination
     */
    vehicle?: boolean;
}
/**
 * 
 * @export
 * @interface ProcessDefinitionRepresentation
 */
export interface ProcessDefinitionRepresentation {
    /**
     * 
     * @type {string}
     * @memberof ProcessDefinitionRepresentation
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcessDefinitionRepresentation
     */
    deploymentId: string;
    /**
     * 
     * @type {string}
     * @memberof ProcessDefinitionRepresentation
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcessDefinitionRepresentation
     */
    diagram: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ProcessDefinitionRepresentation
     */
    extensions?: { [key: string]: object; };
    /**
     * 
     * @type {number}
     * @memberof ProcessDefinitionRepresentation
     */
    historyTimeToLive?: number;
    /**
     * 
     * @type {string}
     * @memberof ProcessDefinitionRepresentation
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProcessDefinitionRepresentation
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof ProcessDefinitionRepresentation
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProcessDefinitionRepresentation
     */
    resource?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcessDefinitionRepresentation
     */
    startFormKey?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProcessDefinitionRepresentation
     */
    startableInTasklist?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProcessDefinitionRepresentation
     */
    suspended: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProcessDefinitionRepresentation
     */
    tenantId?: string;
    /**
     * 
     * @type {number}
     * @memberof ProcessDefinitionRepresentation
     */
    version?: number;
    /**
     * 
     * @type {string}
     * @memberof ProcessDefinitionRepresentation
     */
    versionTag?: string;
}
/**
 * 
 * @export
 * @interface ProfitabilityRatios
 */
export interface ProfitabilityRatios {
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatios
     */
    ebitdaMargin: number;
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatios
     */
    grossProfitMargin: number;
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatios
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatios
     */
    netDebtToEbitda: number;
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatios
     */
    netProfitMargin: number;
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatios
     */
    netWorthToTotalAssets: number;
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatios
     */
    operatingProfitMargin: number;
}
/**
 * 
 * @export
 * @interface ProfitabilityRatiosDto
 */
export interface ProfitabilityRatiosDto {
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatiosDto
     */
    ebitdaMargin?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatiosDto
     */
    grossProfitMargin?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatiosDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatiosDto
     */
    netDebtToEbitda?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatiosDto
     */
    netProfitMargin?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatiosDto
     */
    netWorthToTotalAssets?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatiosDto
     */
    operatingProfitMargin?: number;
}
/**
 * 
 * @export
 * @interface ProfitabilityRatiosDtoBorrowerAllowed
 */
export interface ProfitabilityRatiosDtoBorrowerAllowed {
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatiosDtoBorrowerAllowed
     */
    ebitdaMargin?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatiosDtoBorrowerAllowed
     */
    grossProfitMargin?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatiosDtoBorrowerAllowed
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatiosDtoBorrowerAllowed
     */
    netDebtToEbitda?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatiosDtoBorrowerAllowed
     */
    netProfitMargin?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatiosDtoBorrowerAllowed
     */
    netWorthToTotalAssets?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatiosDtoBorrowerAllowed
     */
    operatingProfitMargin?: number;
}
/**
 * 
 * @export
 * @interface ProfitabilityRatiosDtoBrief
 */
export interface ProfitabilityRatiosDtoBrief {
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatiosDtoBrief
     */
    ebitdaMargin?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatiosDtoBrief
     */
    grossProfitMargin?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatiosDtoBrief
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatiosDtoBrief
     */
    netDebtToEbitda?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatiosDtoBrief
     */
    netProfitMargin?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatiosDtoBrief
     */
    netWorthToTotalAssets?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfitabilityRatiosDtoBrief
     */
    operatingProfitMargin?: number;
}
/**
 * 
 * @export
 * @interface Representative
 */
export interface Representative {
    /**
     * 
     * @type {number}
     * @memberof Representative
     */
    id?: number;
    /**
     * 
     * @type {Person}
     * @memberof Representative
     */
    person: Person;
    /**
     * 
     * @type {string}
     * @memberof Representative
     */
    position: string;
}
/**
 * 
 * @export
 * @interface RepresentativeDto
 */
export interface RepresentativeDto {
    /**
     * 
     * @type {number}
     * @memberof RepresentativeDto
     */
    id?: number;
    /**
     * 
     * @type {UpdatePersonRequest}
     * @memberof RepresentativeDto
     */
    person: UpdatePersonRequest;
    /**
     * 
     * @type {string}
     * @memberof RepresentativeDto
     */
    position: string;
}
/**
 * A person representing the legal entity
 * @export
 * @interface RepresentativeLoanOrigination
 */
export interface RepresentativeLoanOrigination {
    /**
     * 
     * @type {string}
     * @memberof RepresentativeLoanOrigination
     */
    birthDate: string;
    /**
     * 
     * @type {string}
     * @memberof RepresentativeLoanOrigination
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof RepresentativeLoanOrigination
     */
    firstName: string;
    /**
     * 
     * @type {IdDocumentLoanOrigination}
     * @memberof RepresentativeLoanOrigination
     */
    idDocument: IdDocumentLoanOrigination;
    /**
     * 
     * @type {string}
     * @memberof RepresentativeLoanOrigination
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof RepresentativeLoanOrigination
     */
    middleName?: string;
    /**
     * Representative\'s current job position
     * @type {string}
     * @memberof RepresentativeLoanOrigination
     */
    position: string;
}
/**
 * The loan application is used to make a decision on originating a loan
 * @export
 * @interface RequestLegalEntityLoanOrigination
 */
export interface RequestLegalEntityLoanOrigination {
    /**
     * The amount for which the loan is requested
     * @type {number}
     * @memberof RequestLegalEntityLoanOrigination
     */
    amountRequested: number;
    /**
     * 
     * @type {LegalEntityLoanOrigination}
     * @memberof RequestLegalEntityLoanOrigination
     */
    borrower: LegalEntityLoanOrigination;
    /**
     * Code of the campaign (product group) that exists in the system for which the loan application is applied
     * @type {number}
     * @memberof RequestLegalEntityLoanOrigination
     */
    campaignId: number;
    /**
     * Required for campaigns with collateral
     * @type {number}
     * @memberof RequestLegalEntityLoanOrigination
     */
    collateralValue?: number;
    /**
     * Date when payment(s) has to be performed. Value is allowed only for \'Annuity instalment\' and \'Linear principal repayment instalment\' calculation types
     * @type {string}
     * @memberof RequestLegalEntityLoanOrigination
     */
    firstPaymentDate?: string;
    /**
     * The desired repayment period for which the loan is requested
     * @type {string}
     * @memberof RequestLegalEntityLoanOrigination
     */
    paymentFrequency?: RequestLegalEntityLoanOriginationPaymentFrequencyEnum;
    /**
     * Date and time when the application has been applied
     * @type {string}
     * @memberof RequestLegalEntityLoanOrigination
     */
    requestedAt: string;
    /**
     * The term for which the loan is requested
     * @type {number}
     * @memberof RequestLegalEntityLoanOrigination
     */
    termRequested: number;
}

/**
    * @export
    * @enum {string}
    */
export enum RequestLegalEntityLoanOriginationPaymentFrequencyEnum {
    WEEKLY = 'WEEKLY',
    FORTNIGHTLY = 'FORTNIGHTLY',
    MONTHLY = 'MONTHLY',
    QUARTERLY = 'QUARTERLY'
}

/**
 * The loan application is used to create a loan
 * @export
 * @interface RequestLoanManagement
 */
export interface RequestLoanManagement {
    /**
     * Loan amount to disburse
     * @type {number}
     * @memberof RequestLoanManagement
     */
    amountApproved: number;
    /**
     * 
     * @type {LegalEntityLoanManagement | PersonLoanManagement}
     * @memberof RequestLoanManagement
     */
    borrower: LegalEntityLoanManagement | PersonLoanManagement;
    /**
     * Date when payment(s) has to be performed. Value is allowed only for \'Annuity instalment\' and \'Linear principal repayment instalment\' calculation types
     * @type {string}
     * @memberof RequestLoanManagement
     */
    firstPaymentDate?: string;
    /**
     * Interest rate measured as a percentage
     * @type {number}
     * @memberof RequestLoanManagement
     */
    interestRateApprovedPct: number;
    /**
     * Interest rate type that the loan applied for
     * @type {string}
     * @memberof RequestLoanManagement
     */
    interestRateType: RequestLoanManagementInterestRateTypeEnum;
    /**
     * Date when the loan has been issued
     * @type {string}
     * @memberof RequestLoanManagement
     */
    loanIssueDate?: string;
    /**
     * 
     * @type {LoanProductLoanManagement}
     * @memberof RequestLoanManagement
     */
    loanProduct: LoanProductLoanManagement;
    /**
     * Unique loan application number
     * @type {string}
     * @memberof RequestLoanManagement
     */
    number: string;
    /**
     * Date and time when the application has been applied
     * @type {string}
     * @memberof RequestLoanManagement
     */
    requestedAt: string;
    /**
     * Approved loan term
     * @type {number}
     * @memberof RequestLoanManagement
     */
    termApproved: number;
    /**
     * Used prime rate measured as a percentage
     * @type {number}
     * @memberof RequestLoanManagement
     */
    usedPrimeRatePct?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum RequestLoanManagementInterestRateTypeEnum {
    FIXED = 'FIXED',
    FLOATING = 'FLOATING'
}

/**
 * The loan application is used to make a decision on originating a loan
 * @export
 * @interface RequestPersonLoanOrigination
 */
export interface RequestPersonLoanOrigination {
    /**
     * The amount for which the loan is requested
     * @type {number}
     * @memberof RequestPersonLoanOrigination
     */
    amountRequested: number;
    /**
     * 
     * @type {PersonLoanOrigination}
     * @memberof RequestPersonLoanOrigination
     */
    borrower: PersonLoanOrigination;
    /**
     * Code of the campaign (product group) that exists in the system for which the loan application is applied
     * @type {number}
     * @memberof RequestPersonLoanOrigination
     */
    campaignId: number;
    /**
     * Required for campaigns with collateral
     * @type {number}
     * @memberof RequestPersonLoanOrigination
     */
    collateralValue?: number;
    /**
     * Date when payment(s) has to be performed. Value is allowed only for \'Annuity instalment\' and \'Linear principal repayment instalment\' calculation types
     * @type {string}
     * @memberof RequestPersonLoanOrigination
     */
    firstPaymentDate?: string;
    /**
     * The desired repayment period for which the loan is requested
     * @type {string}
     * @memberof RequestPersonLoanOrigination
     */
    paymentFrequency?: RequestPersonLoanOriginationPaymentFrequencyEnum;
    /**
     * Date and time when the application has been applied
     * @type {string}
     * @memberof RequestPersonLoanOrigination
     */
    requestedAt: string;
    /**
     * The term for which the loan is requested
     * @type {number}
     * @memberof RequestPersonLoanOrigination
     */
    termRequested: number;
}

/**
    * @export
    * @enum {string}
    */
export enum RequestPersonLoanOriginationPaymentFrequencyEnum {
    WEEKLY = 'WEEKLY',
    FORTNIGHTLY = 'FORTNIGHTLY',
    MONTHLY = 'MONTHLY',
    QUARTERLY = 'QUARTERLY'
}

/**
 * 
 * @export
 * @interface Scoring
 */
export interface Scoring {
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof Scoring
     */
    response?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof Scoring
     */
    resultScore?: string;
}
/**
 * 
 * @export
 * @interface ScoringDto
 */
export interface ScoringDto {
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ScoringDto
     */
    response?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof ScoringDto
     */
    resultScore?: string;
}
/**
 * 
 * @export
 * @interface ScoringDtoBorrowerAllowed
 */
export interface ScoringDtoBorrowerAllowed {
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ScoringDtoBorrowerAllowed
     */
    response?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof ScoringDtoBorrowerAllowed
     */
    resultScore?: string;
}
/**
 * 
 * @export
 * @interface ScoringDtoBrief
 */
export interface ScoringDtoBrief {
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ScoringDtoBrief
     */
    response?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof ScoringDtoBrief
     */
    resultScore?: string;
}
/**
 * 
 * @export
 * @interface ScoringModelSettingsDto
 */
export interface ScoringModelSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof ScoringModelSettingsDto
     */
    decisionDefinitionKey?: string;
    /**
     * 
     * @type {number}
     * @memberof ScoringModelSettingsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ScoringModelSettingsDto
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof ScoringModelSettingsDto
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface ScoringModelSettingsResponse
 */
export interface ScoringModelSettingsResponse {
    /**
     * 
     * @type {Array<ScoringModelSettingsDto>}
     * @memberof ScoringModelSettingsResponse
     */
    scoringModelSettingsList?: Array<ScoringModelSettingsDto>;
}
/**
 * 
 * @export
 * @interface ScoringModelVersionContentResponse
 */
export interface ScoringModelVersionContentResponse {
    /**
     * 
     * @type {string}
     * @memberof ScoringModelVersionContentResponse
     */
    scoringModelVersionContent?: string;
}
/**
 * 
 * @export
 * @interface ScoringModelVersionSettingsDto
 */
export interface ScoringModelVersionSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof ScoringModelVersionSettingsDto
     */
    activeFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof ScoringModelVersionSettingsDto
     */
    activeTo?: string;
    /**
     * 
     * @type {number}
     * @memberof ScoringModelVersionSettingsDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ScoringModelVersionSettingsDto
     */
    scoringModelId?: number;
    /**
     * 
     * @type {string}
     * @memberof ScoringModelVersionSettingsDto
     */
    status?: ScoringModelVersionSettingsDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ScoringModelVersionSettingsDto
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ScoringModelVersionSettingsDto
     */
    updatedBy?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ScoringModelVersionSettingsDtoStatusEnum {
    DRAFT = 'DRAFT',
    APPROVED = 'APPROVED',
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    FAILED = 'FAILED'
}

/**
 * 
 * @export
 * @interface SortObject
 */
export interface SortObject {
    /**
     * 
     * @type {boolean}
     * @memberof SortObject
     */
    ascending?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SortObject
     */
    direction?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SortObject
     */
    ignoreCase?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SortObject
     */
    nullHandling?: string;
    /**
     * 
     * @type {string}
     * @memberof SortObject
     */
    property?: string;
}
/**
 * 
 * @export
 * @interface TaskRepresentation
 */
export interface TaskRepresentation {
    /**
     * 
     * @type {string}
     * @memberof TaskRepresentation
     */
    assignee?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskRepresentation
     */
    caseDefinitionId?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskRepresentation
     */
    caseExecutionId?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskRepresentation
     */
    caseInstanceId?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskRepresentation
     */
    createTime: string;
    /**
     * 
     * @type {string}
     * @memberof TaskRepresentation
     */
    delegationState?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskRepresentation
     */
    deploymentId: string;
    /**
     * 
     * @type {string}
     * @memberof TaskRepresentation
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskRepresentation
     */
    dueDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskRepresentation
     */
    executionId: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof TaskRepresentation
     */
    extensions?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof TaskRepresentation
     */
    followUpDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskRepresentation
     */
    formKey?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskRepresentation
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TaskRepresentation
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskRepresentation
     */
    owner?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskRepresentation
     */
    parentTaskId?: string;
    /**
     * 
     * @type {number}
     * @memberof TaskRepresentation
     */
    priority?: number;
    /**
     * 
     * @type {string}
     * @memberof TaskRepresentation
     */
    processDefinitionId: string;
    /**
     * 
     * @type {string}
     * @memberof TaskRepresentation
     */
    processInstanceId: string;
    /**
     * 
     * @type {boolean}
     * @memberof TaskRepresentation
     */
    suspended: boolean;
    /**
     * 
     * @type {string}
     * @memberof TaskRepresentation
     */
    taskDefinitionKey: string;
    /**
     * 
     * @type {object}
     * @memberof TaskRepresentation
     */
    taskInfo?: object;
    /**
     * 
     * @type {string}
     * @memberof TaskRepresentation
     */
    tenantId?: string;
}
/**
 * 
 * @export
 * @interface TemplateDescription
 */
export interface TemplateDescription {
    /**
     * 
     * @type {string}
     * @memberof TemplateDescription
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateDescription
     */
    path?: string;
}
/**
 * 
 * @export
 * @interface TermOption
 */
export interface TermOption {
    /**
     * 
     * @type {number}
     * @memberof TermOption
     */
    length?: number;
}
/**
 * 
 * @export
 * @interface TermOptionDtoBorrowerAllowed
 */
export interface TermOptionDtoBorrowerAllowed {
    /**
     * 
     * @type {number}
     * @memberof TermOptionDtoBorrowerAllowed
     */
    length?: number;
}
/**
 * 
 * @export
 * @interface TermOptionDtoBrief
 */
export interface TermOptionDtoBrief {
    /**
     * 
     * @type {number}
     * @memberof TermOptionDtoBrief
     */
    length?: number;
}
/**
 * 
 * @export
 * @interface TransactionDto
 */
export interface TransactionDto {
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    accountNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    direction?: TransactionDtoDirectionEnum;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    documentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    externalPaymentService?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    externalTransactionId?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    initiator?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionDto
     */
    loanId?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    method?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionDto
     */
    processed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    processedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDto
     */
    type?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum TransactionDtoDirectionEnum {
    INBOUND = 'INBOUND',
    OUTBOUND = 'OUTBOUND'
}

/**
 * 
 * @export
 * @interface TransactionDtoBorrowerAllowed
 */
export interface TransactionDtoBorrowerAllowed {
    /**
     * 
     * @type {string}
     * @memberof TransactionDtoBorrowerAllowed
     */
    accountNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionDtoBorrowerAllowed
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionDtoBorrowerAllowed
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDtoBorrowerAllowed
     */
    documentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDtoBorrowerAllowed
     */
    errorMessage?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionDtoBorrowerAllowed
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionDtoBorrowerAllowed
     */
    initiator?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionDtoBorrowerAllowed
     */
    loanId?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionDtoBorrowerAllowed
     */
    processedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDtoBorrowerAllowed
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDtoBorrowerAllowed
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface TransactionDtoBrief
 */
export interface TransactionDtoBrief {
    /**
     * 
     * @type {string}
     * @memberof TransactionDtoBrief
     */
    accountNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionDtoBrief
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionDtoBrief
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDtoBrief
     */
    direction?: TransactionDtoBriefDirectionEnum;
    /**
     * 
     * @type {string}
     * @memberof TransactionDtoBrief
     */
    documentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDtoBrief
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDtoBrief
     */
    externalPaymentService?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDtoBrief
     */
    externalTransactionId?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionDtoBrief
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionDtoBrief
     */
    initiator?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionDtoBrief
     */
    loanId?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionDtoBrief
     */
    method?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionDtoBrief
     */
    processed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TransactionDtoBrief
     */
    processedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDtoBrief
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDtoBrief
     */
    type?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum TransactionDtoBriefDirectionEnum {
    INBOUND = 'INBOUND',
    OUTBOUND = 'OUTBOUND'
}

/**
 * 
 * @export
 * @interface UiConfigurations
 */
export interface UiConfigurations {
    /**
     * 
     * @type {string}
     * @memberof UiConfigurations
     */
    appName?: string;
    /**
     * 
     * @type {string}
     * @memberof UiConfigurations
     */
    authClientId?: string;
    /**
     * 
     * @type {string}
     * @memberof UiConfigurations
     */
    authRealm?: string;
    /**
     * 
     * @type {string}
     * @memberof UiConfigurations
     */
    authServerUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof UiConfigurations
     */
    borrowerType?: string;
    /**
     * 
     * @type {string}
     * @memberof UiConfigurations
     */
    defaultLocale?: string;
    /**
     * 
     * @type {string}
     * @memberof UiConfigurations
     */
    defaultProcessKey?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof UiConfigurations
     */
    env?: { [key: string]: string; };
    /**
     * 
     * @type {Array<string>}
     * @memberof UiConfigurations
     */
    supportedLocales?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateAgentRequest
 */
export interface UpdateAgentRequest {
    /**
     * 
     * @type {AddressDto}
     * @memberof UpdateAgentRequest
     */
    address?: AddressDto;
    /**
     * 
     * @type {BankAccountDto}
     * @memberof UpdateAgentRequest
     */
    bankAccount?: BankAccountDto;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof UpdateAgentRequest
     */
    contactDetails?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof UpdateAgentRequest
     */
    email: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof UpdateAgentRequest
     */
    extensions?: { [key: string]: object; };
    /**
     * 
     * @type {number}
     * @memberof UpdateAgentRequest
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateAgentRequest
     */
    legalName: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof UpdateAgentRequest
     */
    logo?: Array<any>;
    /**
     * 
     * @type {string}
     * @memberof UpdateAgentRequest
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAgentRequest
     */
    taxNumber: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAgentRequest
     */
    website?: string;
}
/**
 * 
 * @export
 * @interface UpdateBorrowerRequest
 */
export interface UpdateBorrowerRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateBorrowerRequest
     */
    type: string;
}
/**
 * 
 * @export
 * @interface UpdateCampaignRequest
 */
export interface UpdateCampaignRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCampaignRequest
     */
    active?: boolean;
    /**
     * 
     * @type {Array<Agent>}
     * @memberof UpdateCampaignRequest
     */
    agents?: Array<Agent>;
    /**
     * 
     * @type {ApplicationForm}
     * @memberof UpdateCampaignRequest
     */
    applicationForm?: ApplicationForm;
    /**
     * 
     * @type {string}
     * @memberof UpdateCampaignRequest
     */
    calculationType?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCampaignRequest
     */
    collectionStrategy: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCampaignRequest
     */
    daysOverdue?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCampaignRequest
     */
    disbursementOption: string;
    /**
     * 
     * @type {DocumentTemplateDto}
     * @memberof UpdateCampaignRequest
     */
    documentTemplate: DocumentTemplateDto;
    /**
     * 
     * @type {string}
     * @memberof UpdateCampaignRequest
     */
    giniMachineScoringModel?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCampaignRequest
     */
    interestRateType: UpdateCampaignRequestInterestRateTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateCampaignRequest
     */
    name?: string;
    /**
     * 
     * @type {CampaignParameters}
     * @memberof UpdateCampaignRequest
     */
    parameters?: CampaignParameters;
    /**
     * 
     * @type {Array<CampaignDtoPaymentFrequency>}
     * @memberof UpdateCampaignRequest
     */
    paymentFrequency?: Array<CampaignDtoPaymentFrequency>;
    /**
     * 
     * @type {number}
     * @memberof UpdateCampaignRequest
     */
    rangeOfDaysForFirstPaymentDate?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCampaignRequest
     */
    scoringModel?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateCampaignRequest
     */
    scoringProviders?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateCampaignRequest
     */
    signingOption?: string;
    /**
     * 
     * @type {CampaignDtoPaymentFrequency}
     * @memberof UpdateCampaignRequest
     */
    termPeriodType?: CampaignDtoPaymentFrequency;
    /**
     * 
     * @type {string}
     * @memberof UpdateCampaignRequest
     */
    underwritingDecisionMaking: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCampaignRequest
     */
    verificationDecisionMaking: string;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateCampaignRequestInterestRateTypeEnum {
    FIXED = 'FIXED',
    FLOATING = 'FLOATING'
}

/**
 * 
 * @export
 * @interface UpdateLeadRequest
 */
export interface UpdateLeadRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateLeadRequest
     */
    agentId?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadRequest
     */
    phone: string;
}
/**
 * 
 * @export
 * @interface UpdateLegalEntityRequest
 */
export interface UpdateLegalEntityRequest extends UpdateBorrowerRequest {
    /**
     * 
     * @type {AddressDto}
     * @memberof UpdateLegalEntityRequest
     */
    address?: AddressDto;
    /**
     * 
     * @type {BankAccountDto}
     * @memberof UpdateLegalEntityRequest
     */
    bankAccount?: BankAccountDto;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLegalEntityRequest
     */
    blacklisted: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateLegalEntityRequest
     */
    corporateType?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLegalEntityRequest
     */
    email?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof UpdateLegalEntityRequest
     */
    extensions?: { [key: string]: object; };
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof UpdateLegalEntityRequest
     */
    financialInformation?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof UpdateLegalEntityRequest
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLegalEntityRequest
     */
    industry?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLegalEntityRequest
     */
    legalName?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateLegalEntityRequest
     */
    monthsInOperation?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateLegalEntityRequest
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLegalEntityRequest
     */
    registrationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLegalEntityRequest
     */
    registrationNumber?: string;
    /**
     * 
     * @type {RepresentativeDto}
     * @memberof UpdateLegalEntityRequest
     */
    representative?: RepresentativeDto;
    /**
     * 
     * @type {string}
     * @memberof UpdateLegalEntityRequest
     */
    taxNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLegalEntityRequest
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLegalEntityRequest
     */
    website?: string;
}
/**
 * 
 * @export
 * @interface UpdateLegalEntityRequestAllOf
 */
export interface UpdateLegalEntityRequestAllOf {
    /**
     * 
     * @type {AddressDto}
     * @memberof UpdateLegalEntityRequestAllOf
     */
    address?: AddressDto;
    /**
     * 
     * @type {BankAccountDto}
     * @memberof UpdateLegalEntityRequestAllOf
     */
    bankAccount?: BankAccountDto;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLegalEntityRequestAllOf
     */
    blacklisted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateLegalEntityRequestAllOf
     */
    corporateType?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLegalEntityRequestAllOf
     */
    email?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof UpdateLegalEntityRequestAllOf
     */
    extensions?: { [key: string]: object; };
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof UpdateLegalEntityRequestAllOf
     */
    financialInformation?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof UpdateLegalEntityRequestAllOf
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLegalEntityRequestAllOf
     */
    industry?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLegalEntityRequestAllOf
     */
    legalName?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateLegalEntityRequestAllOf
     */
    monthsInOperation?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateLegalEntityRequestAllOf
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLegalEntityRequestAllOf
     */
    registrationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLegalEntityRequestAllOf
     */
    registrationNumber?: string;
    /**
     * 
     * @type {RepresentativeDto}
     * @memberof UpdateLegalEntityRequestAllOf
     */
    representative?: RepresentativeDto;
    /**
     * 
     * @type {string}
     * @memberof UpdateLegalEntityRequestAllOf
     */
    taxNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLegalEntityRequestAllOf
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLegalEntityRequestAllOf
     */
    website?: string;
}
/**
 * 
 * @export
 * @interface UpdateLoanProductRequest
 */
export interface UpdateLoanProductRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLoanProductRequest
     */
    active: boolean;
    /**
     * 
     * @type {CampaignDto}
     * @memberof UpdateLoanProductRequest
     */
    campaign: CampaignDto;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoanProductRequest
     */
    code: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanProductRequest
     */
    defaultInterestRatePct: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateLoanProductRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanProductRequest
     */
    earlyRepaymentFeeRatePct: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanProductRequest
     */
    establishmentFee?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanProductRequest
     */
    graceInterestRatePct: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanProductRequest
     */
    gracePeriodDays?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanProductRequest
     */
    maxAmount: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanProductRequest
     */
    maxInterestRatePct: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanProductRequest
     */
    maxMarginPct?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanProductRequest
     */
    maxTerm?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanProductRequest
     */
    minAmount: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanProductRequest
     */
    minInterestRatePct: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanProductRequest
     */
    minMarginPct?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanProductRequest
     */
    minTerm?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanProductRequest
     */
    overduePenalty: number;
    /**
     * 
     * @type {CampaignDtoPaymentFrequency}
     * @memberof UpdateLoanProductRequest
     */
    paymentFrequency?: CampaignDtoPaymentFrequency;
    /**
     * 
     * @type {number}
     * @memberof UpdateLoanProductRequest
     */
    serviceFeeRatePct?: number;
}
/**
 * 
 * @export
 * @interface UpdatePersonRequest
 */
export interface UpdatePersonRequest {
    /**
     * 
     * @type {AddressDto}
     * @memberof UpdatePersonRequest
     */
    address?: AddressDto;
    /**
     * 
     * @type {BankAccountDto}
     * @memberof UpdatePersonRequest
     */
    bankAccount?: BankAccountDto;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonRequest
     */
    birthDate?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePersonRequest
     */
    blacklisted: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonRequest
     */
    citizenship?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdatePersonRequest
     */
    currentAge?: number;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof UpdatePersonRequest
     */
    details?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonRequest
     */
    email?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof UpdatePersonRequest
     */
    extensions?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonRequest
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonRequest
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonRequest
     */
    gender?: string;
    /**
     * 
     * @type {IdDocumentDto}
     * @memberof UpdatePersonRequest
     */
    idDocument?: IdDocumentDto;
    /**
     * 
     * @type {KycResultsDto}
     * @memberof UpdatePersonRequest
     */
    kycResults?: KycResultsDto;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonRequest
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonRequest
     */
    middleName?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdatePersonRequest
     */
    numberOfDependents?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonRequest
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonRequest
     */
    taxNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonRequest
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    username?: string;
}
/**
 * 
 * @export
 * @interface UtmParam
 */
export interface UtmParam {
    /**
     * 
     * @type {string}
     * @memberof UtmParam
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UtmParam
     */
    value?: string;
}

/**
 * ActuatorApi - axios parameter creator
 * @export
 */
export const ActuatorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Actuator web endpoint \'env\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        env: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator/env`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actuator web endpoint \'env-toMatch\'
         * @param {string} toMatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        envToMatch: async (toMatch: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'toMatch' is not null or undefined
            if (toMatch === null || toMatch === undefined) {
                throw new RequiredError('toMatch','Required parameter toMatch was null or undefined when calling envToMatch.');
            }
            const localVarPath = `/actuator/env/{toMatch}`
                .replace(`{${"toMatch"}}`, encodeURIComponent(String(toMatch)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actuator web endpoint \'health\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator/health`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actuator web endpoint \'health-path\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthPath: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator/health/**`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actuator web endpoint \'info\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        info: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator/info`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actuator root web endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        links: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actuator web endpoint \'metrics\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metrics: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator/metrics`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actuator web endpoint \'metrics-requiredMetricName\'
         * @param {string} requiredMetricName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metricsRequiredMetricName: async (requiredMetricName: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requiredMetricName' is not null or undefined
            if (requiredMetricName === null || requiredMetricName === undefined) {
                throw new RequiredError('requiredMetricName','Required parameter requiredMetricName was null or undefined when calling metricsRequiredMetricName.');
            }
            const localVarPath = `/actuator/metrics/{requiredMetricName}`
                .replace(`{${"requiredMetricName"}}`, encodeURIComponent(String(requiredMetricName)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actuator web endpoint \'prometheus\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prometheus: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator/prometheus`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActuatorApi - functional programming interface
 * @export
 */
export const ActuatorApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Actuator web endpoint \'env\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async env(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await ActuatorApiAxiosParamCreator(configuration).env(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Actuator web endpoint \'env-toMatch\'
         * @param {string} toMatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async envToMatch(toMatch: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await ActuatorApiAxiosParamCreator(configuration).envToMatch(toMatch, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Actuator web endpoint \'health\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async health(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await ActuatorApiAxiosParamCreator(configuration).health(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Actuator web endpoint \'health-path\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthPath(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await ActuatorApiAxiosParamCreator(configuration).healthPath(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Actuator web endpoint \'info\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async info(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await ActuatorApiAxiosParamCreator(configuration).info(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Actuator root web endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async links(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: { [key: string]: Link; }; }>> {
            const localVarAxiosArgs = await ActuatorApiAxiosParamCreator(configuration).links(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Actuator web endpoint \'metrics\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metrics(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await ActuatorApiAxiosParamCreator(configuration).metrics(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Actuator web endpoint \'metrics-requiredMetricName\'
         * @param {string} requiredMetricName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metricsRequiredMetricName(requiredMetricName: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await ActuatorApiAxiosParamCreator(configuration).metricsRequiredMetricName(requiredMetricName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Actuator web endpoint \'prometheus\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async prometheus(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await ActuatorApiAxiosParamCreator(configuration).prometheus(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ActuatorApi - factory interface
 * @export
 */
export const ActuatorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Actuator web endpoint \'env\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        env(options?: any): AxiosPromise<object> {
            return ActuatorApiFp(configuration).env(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actuator web endpoint \'env-toMatch\'
         * @param {string} toMatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        envToMatch(toMatch: string, options?: any): AxiosPromise<object> {
            return ActuatorApiFp(configuration).envToMatch(toMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actuator web endpoint \'health\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health(options?: any): AxiosPromise<object> {
            return ActuatorApiFp(configuration).health(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actuator web endpoint \'health-path\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthPath(options?: any): AxiosPromise<object> {
            return ActuatorApiFp(configuration).healthPath(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actuator web endpoint \'info\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        info(options?: any): AxiosPromise<object> {
            return ActuatorApiFp(configuration).info(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actuator root web endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        links(options?: any): AxiosPromise<{ [key: string]: { [key: string]: Link; }; }> {
            return ActuatorApiFp(configuration).links(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actuator web endpoint \'metrics\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metrics(options?: any): AxiosPromise<object> {
            return ActuatorApiFp(configuration).metrics(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actuator web endpoint \'metrics-requiredMetricName\'
         * @param {string} requiredMetricName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metricsRequiredMetricName(requiredMetricName: string, options?: any): AxiosPromise<object> {
            return ActuatorApiFp(configuration).metricsRequiredMetricName(requiredMetricName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actuator web endpoint \'prometheus\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prometheus(options?: any): AxiosPromise<object> {
            return ActuatorApiFp(configuration).prometheus(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActuatorApi - object-oriented interface
 * @export
 * @class ActuatorApi
 * @extends {BaseAPI}
 */
export class ActuatorApi extends BaseAPI {
    /**
     * 
     * @summary Actuator web endpoint \'env\'
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActuatorApi
     */
    public env(options?: any) {
        return ActuatorApiFp(this.configuration).env(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actuator web endpoint \'env-toMatch\'
     * @param {string} toMatch 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActuatorApi
     */
    public envToMatch(toMatch: string, options?: any) {
        return ActuatorApiFp(this.configuration).envToMatch(toMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actuator web endpoint \'health\'
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActuatorApi
     */
    public health(options?: any) {
        return ActuatorApiFp(this.configuration).health(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actuator web endpoint \'health-path\'
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActuatorApi
     */
    public healthPath(options?: any) {
        return ActuatorApiFp(this.configuration).healthPath(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actuator web endpoint \'info\'
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActuatorApi
     */
    public info(options?: any) {
        return ActuatorApiFp(this.configuration).info(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actuator root web endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActuatorApi
     */
    public links(options?: any) {
        return ActuatorApiFp(this.configuration).links(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actuator web endpoint \'metrics\'
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActuatorApi
     */
    public metrics(options?: any) {
        return ActuatorApiFp(this.configuration).metrics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actuator web endpoint \'metrics-requiredMetricName\'
     * @param {string} requiredMetricName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActuatorApi
     */
    public metricsRequiredMetricName(requiredMetricName: string, options?: any) {
        return ActuatorApiFp(this.configuration).metricsRequiredMetricName(requiredMetricName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actuator web endpoint \'prometheus\'
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActuatorApi
     */
    public prometheus(options?: any) {
        return ActuatorApiFp(this.configuration).prometheus(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * AgentApi - axios parameter creator
 * @export
 */
export const AgentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create agent
         * @param {CreateAgentRequest} createAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgent: async (createAgentRequest: CreateAgentRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAgentRequest' is not null or undefined
            if (createAgentRequest === null || createAgentRequest === undefined) {
                throw new RequiredError('createAgentRequest','Required parameter createAgentRequest was null or undefined when calling createAgent.');
            }
            const localVarPath = `/api/agents`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof createAgentRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createAgentRequest !== undefined ? createAgentRequest : {}) : (createAgentRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of agents
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [filterTaxNumber] Search by agent\&#39;s taxNumber
         * @param {string} [filterSearch] Search by agent\&#39;s legalName, phone, email
         * @param {string} [filterLegalName] Search by agent\&#39;s legalName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAgents: async (page?: number, size?: number, sort?: Array<string>, filterTaxNumber?: string, filterSearch?: string, filterLegalName?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/agents`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterTaxNumber !== undefined) {
                localVarQueryParameter['filter.taxNumber'] = filterTaxNumber;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }

            if (filterLegalName !== undefined) {
                localVarQueryParameter['filter.legalName'] = filterLegalName;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of agent\'s users
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllUsersByAgentId: async (id: number, page?: number, size?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling findAllUsersByAgentId.');
            }
            const localVarPath = `/api/agents/{id}/users`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return single agent
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgent: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getAgent.');
            }
            const localVarPath = `/api/agents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update agent
         * @param {number} id 
         * @param {UpdateAgentRequest} updateAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgent: async (id: number, updateAgentRequest: UpdateAgentRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateAgent.');
            }
            // verify required parameter 'updateAgentRequest' is not null or undefined
            if (updateAgentRequest === null || updateAgentRequest === undefined) {
                throw new RequiredError('updateAgentRequest','Required parameter updateAgentRequest was null or undefined when calling updateAgent.');
            }
            const localVarPath = `/api/agents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateAgentRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateAgentRequest !== undefined ? updateAgentRequest : {}) : (updateAgentRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentApi - functional programming interface
 * @export
 */
export const AgentApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create agent
         * @param {CreateAgentRequest} createAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAgent(createAgentRequest: CreateAgentRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentDto>> {
            const localVarAxiosArgs = await AgentApiAxiosParamCreator(configuration).createAgent(createAgentRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return list of agents
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [filterTaxNumber] Search by agent\&#39;s taxNumber
         * @param {string} [filterSearch] Search by agent\&#39;s legalName, phone, email
         * @param {string} [filterLegalName] Search by agent\&#39;s legalName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllAgents(page?: number, size?: number, sort?: Array<string>, filterTaxNumber?: string, filterSearch?: string, filterLegalName?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageAgentDtoBrief>> {
            const localVarAxiosArgs = await AgentApiAxiosParamCreator(configuration).findAllAgents(page, size, sort, filterTaxNumber, filterSearch, filterLegalName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return list of agent\'s users
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllUsersByAgentId(id: number, page?: number, size?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageUser>> {
            const localVarAxiosArgs = await AgentApiAxiosParamCreator(configuration).findAllUsersByAgentId(id, page, size, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return single agent
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgent(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentDto>> {
            const localVarAxiosArgs = await AgentApiAxiosParamCreator(configuration).getAgent(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update agent
         * @param {number} id 
         * @param {UpdateAgentRequest} updateAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAgent(id: number, updateAgentRequest: UpdateAgentRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentDto>> {
            const localVarAxiosArgs = await AgentApiAxiosParamCreator(configuration).updateAgent(id, updateAgentRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AgentApi - factory interface
 * @export
 */
export const AgentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Create agent
         * @param {CreateAgentRequest} createAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgent(createAgentRequest: CreateAgentRequest, options?: any): AxiosPromise<AgentDto> {
            return AgentApiFp(configuration).createAgent(createAgentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of agents
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [filterTaxNumber] Search by agent\&#39;s taxNumber
         * @param {string} [filterSearch] Search by agent\&#39;s legalName, phone, email
         * @param {string} [filterLegalName] Search by agent\&#39;s legalName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAgents(page?: number, size?: number, sort?: Array<string>, filterTaxNumber?: string, filterSearch?: string, filterLegalName?: string, options?: any): AxiosPromise<PageAgentDtoBrief> {
            return AgentApiFp(configuration).findAllAgents(page, size, sort, filterTaxNumber, filterSearch, filterLegalName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of agent\'s users
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllUsersByAgentId(id: number, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PageUser> {
            return AgentApiFp(configuration).findAllUsersByAgentId(id, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return single agent
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgent(id: number, options?: any): AxiosPromise<AgentDto> {
            return AgentApiFp(configuration).getAgent(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update agent
         * @param {number} id 
         * @param {UpdateAgentRequest} updateAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgent(id: number, updateAgentRequest: UpdateAgentRequest, options?: any): AxiosPromise<AgentDto> {
            return AgentApiFp(configuration).updateAgent(id, updateAgentRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgentApi - object-oriented interface
 * @export
 * @class AgentApi
 * @extends {BaseAPI}
 */
export class AgentApi extends BaseAPI {
    /**
     * 
     * @summary Create agent
     * @param {CreateAgentRequest} createAgentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    public createAgent(createAgentRequest: CreateAgentRequest, options?: any) {
        return AgentApiFp(this.configuration).createAgent(createAgentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of agents
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [filterTaxNumber] Search by agent\&#39;s taxNumber
     * @param {string} [filterSearch] Search by agent\&#39;s legalName, phone, email
     * @param {string} [filterLegalName] Search by agent\&#39;s legalName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    public findAllAgents(page?: number, size?: number, sort?: Array<string>, filterTaxNumber?: string, filterSearch?: string, filterLegalName?: string, options?: any) {
        return AgentApiFp(this.configuration).findAllAgents(page, size, sort, filterTaxNumber, filterSearch, filterLegalName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of agent\'s users
     * @param {number} id 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    public findAllUsersByAgentId(id: number, page?: number, size?: number, sort?: Array<string>, options?: any) {
        return AgentApiFp(this.configuration).findAllUsersByAgentId(id, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return single agent
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    public getAgent(id: number, options?: any) {
        return AgentApiFp(this.configuration).getAgent(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update agent
     * @param {number} id 
     * @param {UpdateAgentRequest} updateAgentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    public updateAgent(id: number, updateAgentRequest: UpdateAgentRequest, options?: any) {
        return AgentApiFp(this.configuration).updateAgent(id, updateAgentRequest, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * AgentLoanApi - axios parameter creator
 * @export
 */
export const AgentLoanApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of loans for agent
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by loan statuses
         * @param {string} [filterIssueDateFrom] Search by loan issue date from
         * @param {string} [filterIssueDateTo] Search by loan issue date to
         * @param {string} [filterSearch] Search by loan number; borrower\&#39;s full name, phone, email; loan product code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAgentLoans: async (page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterIssueDateFrom?: string, filterIssueDateTo?: string, filterSearch?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/agent/loans`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterStatuses) {
                localVarQueryParameter['filter.statuses'] = filterStatuses;
            }

            if (filterIssueDateFrom !== undefined) {
                localVarQueryParameter['filter.issueDateFrom'] = filterIssueDateFrom;
            }

            if (filterIssueDateTo !== undefined) {
                localVarQueryParameter['filter.issueDateTo'] = filterIssueDateTo;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return agent\'s single loan
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentLoan: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getAgentLoan.');
            }
            const localVarPath = `/api/agent/loans/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentLoanApi - functional programming interface
 * @export
 */
export const AgentLoanApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of loans for agent
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by loan statuses
         * @param {string} [filterIssueDateFrom] Search by loan issue date from
         * @param {string} [filterIssueDateTo] Search by loan issue date to
         * @param {string} [filterSearch] Search by loan number; borrower\&#39;s full name, phone, email; loan product code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllAgentLoans(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterIssueDateFrom?: string, filterIssueDateTo?: string, filterSearch?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanDtoBrief>> {
            const localVarAxiosArgs = await AgentLoanApiAxiosParamCreator(configuration).findAllAgentLoans(page, size, sort, filterStatuses, filterIssueDateFrom, filterIssueDateTo, filterSearch, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return agent\'s single loan
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentLoan(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanDto>> {
            const localVarAxiosArgs = await AgentLoanApiAxiosParamCreator(configuration).getAgentLoan(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AgentLoanApi - factory interface
 * @export
 */
export const AgentLoanApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Return list of loans for agent
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by loan statuses
         * @param {string} [filterIssueDateFrom] Search by loan issue date from
         * @param {string} [filterIssueDateTo] Search by loan issue date to
         * @param {string} [filterSearch] Search by loan number; borrower\&#39;s full name, phone, email; loan product code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAgentLoans(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterIssueDateFrom?: string, filterIssueDateTo?: string, filterSearch?: string, options?: any): AxiosPromise<PageLoanDtoBrief> {
            return AgentLoanApiFp(configuration).findAllAgentLoans(page, size, sort, filterStatuses, filterIssueDateFrom, filterIssueDateTo, filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return agent\'s single loan
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentLoan(id: number, options?: any): AxiosPromise<LoanDto> {
            return AgentLoanApiFp(configuration).getAgentLoan(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgentLoanApi - object-oriented interface
 * @export
 * @class AgentLoanApi
 * @extends {BaseAPI}
 */
export class AgentLoanApi extends BaseAPI {
    /**
     * 
     * @summary Return list of loans for agent
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {Array<string>} [filterStatuses] Search by loan statuses
     * @param {string} [filterIssueDateFrom] Search by loan issue date from
     * @param {string} [filterIssueDateTo] Search by loan issue date to
     * @param {string} [filterSearch] Search by loan number; borrower\&#39;s full name, phone, email; loan product code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentLoanApi
     */
    public findAllAgentLoans(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterIssueDateFrom?: string, filterIssueDateTo?: string, filterSearch?: string, options?: any) {
        return AgentLoanApiFp(this.configuration).findAllAgentLoans(page, size, sort, filterStatuses, filterIssueDateFrom, filterIssueDateTo, filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return agent\'s single loan
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentLoanApi
     */
    public getAgentLoan(id: number, options?: any) {
        return AgentLoanApiFp(this.configuration).getAgentLoan(id, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * AgentLoanApplicationApi - axios parameter creator
 * @export
 */
export const AgentLoanApplicationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of loan applications for agent
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by loan application statuses
         * @param {string} [filterRequestedAtFrom] Search by loan application requested at from
         * @param {string} [filterRequestedAtTo] Search by loan application requested at to
         * @param {string} [filterSearch] Search by loan application number; borrower\&#39;s full name, phone, email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAgentApplications: async (page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterRequestedAtFrom?: string, filterRequestedAtTo?: string, filterSearch?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/agent/loan-applications`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterStatuses) {
                localVarQueryParameter['filter.statuses'] = filterStatuses;
            }

            if (filterRequestedAtFrom !== undefined) {
                localVarQueryParameter['filter.requestedAtFrom'] = filterRequestedAtFrom;
            }

            if (filterRequestedAtTo !== undefined) {
                localVarQueryParameter['filter.requestedAtTo'] = filterRequestedAtTo;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return agent\'s single loan application
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentApplication: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getAgentApplication.');
            }
            const localVarPath = `/api/agent/loan-applications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentLoanApplicationApi - functional programming interface
 * @export
 */
export const AgentLoanApplicationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of loan applications for agent
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by loan application statuses
         * @param {string} [filterRequestedAtFrom] Search by loan application requested at from
         * @param {string} [filterRequestedAtTo] Search by loan application requested at to
         * @param {string} [filterSearch] Search by loan application number; borrower\&#39;s full name, phone, email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllAgentApplications(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterRequestedAtFrom?: string, filterRequestedAtTo?: string, filterSearch?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanApplicationDtoBrief>> {
            const localVarAxiosArgs = await AgentLoanApplicationApiAxiosParamCreator(configuration).findAllAgentApplications(page, size, sort, filterStatuses, filterRequestedAtFrom, filterRequestedAtTo, filterSearch, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return agent\'s single loan application
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentApplication(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanApplicationDto>> {
            const localVarAxiosArgs = await AgentLoanApplicationApiAxiosParamCreator(configuration).getAgentApplication(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AgentLoanApplicationApi - factory interface
 * @export
 */
export const AgentLoanApplicationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Return list of loan applications for agent
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by loan application statuses
         * @param {string} [filterRequestedAtFrom] Search by loan application requested at from
         * @param {string} [filterRequestedAtTo] Search by loan application requested at to
         * @param {string} [filterSearch] Search by loan application number; borrower\&#39;s full name, phone, email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAgentApplications(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterRequestedAtFrom?: string, filterRequestedAtTo?: string, filterSearch?: string, options?: any): AxiosPromise<PageLoanApplicationDtoBrief> {
            return AgentLoanApplicationApiFp(configuration).findAllAgentApplications(page, size, sort, filterStatuses, filterRequestedAtFrom, filterRequestedAtTo, filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return agent\'s single loan application
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentApplication(id: number, options?: any): AxiosPromise<LoanApplicationDto> {
            return AgentLoanApplicationApiFp(configuration).getAgentApplication(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgentLoanApplicationApi - object-oriented interface
 * @export
 * @class AgentLoanApplicationApi
 * @extends {BaseAPI}
 */
export class AgentLoanApplicationApi extends BaseAPI {
    /**
     * 
     * @summary Return list of loan applications for agent
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {Array<string>} [filterStatuses] Search by loan application statuses
     * @param {string} [filterRequestedAtFrom] Search by loan application requested at from
     * @param {string} [filterRequestedAtTo] Search by loan application requested at to
     * @param {string} [filterSearch] Search by loan application number; borrower\&#39;s full name, phone, email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentLoanApplicationApi
     */
    public findAllAgentApplications(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterRequestedAtFrom?: string, filterRequestedAtTo?: string, filterSearch?: string, options?: any) {
        return AgentLoanApplicationApiFp(this.configuration).findAllAgentApplications(page, size, sort, filterStatuses, filterRequestedAtFrom, filterRequestedAtTo, filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return agent\'s single loan application
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentLoanApplicationApi
     */
    public getAgentApplication(id: number, options?: any) {
        return AgentLoanApplicationApiFp(this.configuration).getAgentApplication(id, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * AgentPortalApi - axios parameter creator
 * @export
 */
export const AgentPortalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return agent profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentProfile: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/agent`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update agent
         * @param {UpdateAgentRequest} updateAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgent1: async (updateAgentRequest: UpdateAgentRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateAgentRequest' is not null or undefined
            if (updateAgentRequest === null || updateAgentRequest === undefined) {
                throw new RequiredError('updateAgentRequest','Required parameter updateAgentRequest was null or undefined when calling updateAgent1.');
            }
            const localVarPath = `/api/agent`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateAgentRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateAgentRequest !== undefined ? updateAgentRequest : {}) : (updateAgentRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentPortalApi - functional programming interface
 * @export
 */
export const AgentPortalApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return agent profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentProfile(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentDto>> {
            const localVarAxiosArgs = await AgentPortalApiAxiosParamCreator(configuration).getAgentProfile(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update agent
         * @param {UpdateAgentRequest} updateAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAgent1(updateAgentRequest: UpdateAgentRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentDto>> {
            const localVarAxiosArgs = await AgentPortalApiAxiosParamCreator(configuration).updateAgent1(updateAgentRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AgentPortalApi - factory interface
 * @export
 */
export const AgentPortalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Return agent profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentProfile(options?: any): AxiosPromise<AgentDto> {
            return AgentPortalApiFp(configuration).getAgentProfile(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update agent
         * @param {UpdateAgentRequest} updateAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgent1(updateAgentRequest: UpdateAgentRequest, options?: any): AxiosPromise<AgentDto> {
            return AgentPortalApiFp(configuration).updateAgent1(updateAgentRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgentPortalApi - object-oriented interface
 * @export
 * @class AgentPortalApi
 * @extends {BaseAPI}
 */
export class AgentPortalApi extends BaseAPI {
    /**
     * 
     * @summary Return agent profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentPortalApi
     */
    public getAgentProfile(options?: any) {
        return AgentPortalApiFp(this.configuration).getAgentProfile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update agent
     * @param {UpdateAgentRequest} updateAgentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentPortalApi
     */
    public updateAgent1(updateAgentRequest: UpdateAgentRequest, options?: any) {
        return AgentPortalApiFp(this.configuration).updateAgent1(updateAgentRequest, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * BPMSIncidentsManagementApi - axios parameter creator
 * @export
 */
export const BPMSIncidentsManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Asynchronously increase retry count for all insidents in the system
         * @summary Bulk retry incidents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkRetryIncidents: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/incident/bulk-retry`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BPMSIncidentsManagementApi - functional programming interface
 * @export
 */
export const BPMSIncidentsManagementApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Asynchronously increase retry count for all insidents in the system
         * @summary Bulk retry incidents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkRetryIncidents(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkRetryIncidentsResponse>> {
            const localVarAxiosArgs = await BPMSIncidentsManagementApiAxiosParamCreator(configuration).bulkRetryIncidents(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BPMSIncidentsManagementApi - factory interface
 * @export
 */
export const BPMSIncidentsManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Asynchronously increase retry count for all insidents in the system
         * @summary Bulk retry incidents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkRetryIncidents(options?: any): AxiosPromise<BulkRetryIncidentsResponse> {
            return BPMSIncidentsManagementApiFp(configuration).bulkRetryIncidents(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BPMSIncidentsManagementApi - object-oriented interface
 * @export
 * @class BPMSIncidentsManagementApi
 * @extends {BaseAPI}
 */
export class BPMSIncidentsManagementApi extends BaseAPI {
    /**
     * Asynchronously increase retry count for all insidents in the system
     * @summary Bulk retry incidents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BPMSIncidentsManagementApi
     */
    public bulkRetryIncidents(options?: any) {
        return BPMSIncidentsManagementApiFp(this.configuration).bulkRetryIncidents(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * BPMSResourcesManagementApi - axios parameter creator
 * @export
 */
export const BPMSResourcesManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Allowed to upload multiple resources and also packet to ZIP files. Process instances migration to new versions will be performed after deployment. All system insidents will be retried after the migration.
         * @summary Create a deployment with specified resources
         * @param {string} deploymentName Name for the deployment
         * @param {Array<any>} files Resources which the deployment will consist of
         * @param {boolean} [migrate] Migrate all process instances to new deployed versions. To perform perform migration process definitions has to comply conditions/rules explained at https://www.novatec-gmbh.de/blog/automating-process-instance-migration-with-camunda-bpm/ 
         * @param {boolean} [retryIncidents] Bulk retry all incidents in the system after deployment and migration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (deploymentName: string, files: Array<any>, migrate?: boolean, retryIncidents?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deploymentName' is not null or undefined
            if (deploymentName === null || deploymentName === undefined) {
                throw new RequiredError('deploymentName','Required parameter deploymentName was null or undefined when calling create.');
            }
            // verify required parameter 'files' is not null or undefined
            if (files === null || files === undefined) {
                throw new RequiredError('files','Required parameter files was null or undefined when calling create.');
            }
            const localVarPath = `/api/deployment/create`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (deploymentName !== undefined) {
                localVarQueryParameter['deployment-name'] = deploymentName;
            }

            if (files) {
                localVarQueryParameter['files'] = files;
            }

            if (migrate !== undefined) {
                localVarQueryParameter['migrate'] = migrate;
            }

            if (retryIncidents !== undefined) {
                localVarQueryParameter['retry-incidents'] = retryIncidents;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a form by key from \'/public\' folder in deployment storage
         * @summary Retrieves a deployed form by key
         * @param {string} formKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForm: async (formKey: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'formKey' is not null or undefined
            if (formKey === null || formKey === undefined) {
                throw new RequiredError('formKey','Required parameter formKey was null or undefined when calling getForm.');
            }
            const localVarPath = `/api/deployment/form`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (formKey !== undefined) {
                localVarQueryParameter['form-key'] = formKey;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves latest version of the resource by name from \'/public\' folder from deployment
         * @summary Retrieves a public resource by name
         * @param {string} [jsonFilter] Filters JSON response utilizing JSONPath syntax if response content type is application/json. See for details: https://github.com/json-path/JsonPath#readme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestResource: async (jsonFilter?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/resource/**`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (jsonFilter !== undefined) {
                localVarQueryParameter['jsonFilter'] = jsonFilter;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BPMSResourcesManagementApi - functional programming interface
 * @export
 */
export const BPMSResourcesManagementApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Allowed to upload multiple resources and also packet to ZIP files. Process instances migration to new versions will be performed after deployment. All system insidents will be retried after the migration.
         * @summary Create a deployment with specified resources
         * @param {string} deploymentName Name for the deployment
         * @param {Array<any>} files Resources which the deployment will consist of
         * @param {boolean} [migrate] Migrate all process instances to new deployed versions. To perform perform migration process definitions has to comply conditions/rules explained at https://www.novatec-gmbh.de/blog/automating-process-instance-migration-with-camunda-bpm/ 
         * @param {boolean} [retryIncidents] Bulk retry all incidents in the system after deployment and migration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(deploymentName: string, files: Array<any>, migrate?: boolean, retryIncidents?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeploymentRepresentation>> {
            const localVarAxiosArgs = await BPMSResourcesManagementApiAxiosParamCreator(configuration).create(deploymentName, files, migrate, retryIncidents, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieves a form by key from \'/public\' folder in deployment storage
         * @summary Retrieves a deployed form by key
         * @param {string} formKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForm(formKey: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await BPMSResourcesManagementApiAxiosParamCreator(configuration).getForm(formKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieves latest version of the resource by name from \'/public\' folder from deployment
         * @summary Retrieves a public resource by name
         * @param {string} [jsonFilter] Filters JSON response utilizing JSONPath syntax if response content type is application/json. See for details: https://github.com/json-path/JsonPath#readme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestResource(jsonFilter?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await BPMSResourcesManagementApiAxiosParamCreator(configuration).getLatestResource(jsonFilter, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BPMSResourcesManagementApi - factory interface
 * @export
 */
export const BPMSResourcesManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Allowed to upload multiple resources and also packet to ZIP files. Process instances migration to new versions will be performed after deployment. All system insidents will be retried after the migration.
         * @summary Create a deployment with specified resources
         * @param {string} deploymentName Name for the deployment
         * @param {Array<any>} files Resources which the deployment will consist of
         * @param {boolean} [migrate] Migrate all process instances to new deployed versions. To perform perform migration process definitions has to comply conditions/rules explained at https://www.novatec-gmbh.de/blog/automating-process-instance-migration-with-camunda-bpm/ 
         * @param {boolean} [retryIncidents] Bulk retry all incidents in the system after deployment and migration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(deploymentName: string, files: Array<any>, migrate?: boolean, retryIncidents?: boolean, options?: any): AxiosPromise<DeploymentRepresentation> {
            return BPMSResourcesManagementApiFp(configuration).create(deploymentName, files, migrate, retryIncidents, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a form by key from \'/public\' folder in deployment storage
         * @summary Retrieves a deployed form by key
         * @param {string} formKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForm(formKey: string, options?: any): AxiosPromise<object> {
            return BPMSResourcesManagementApiFp(configuration).getForm(formKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves latest version of the resource by name from \'/public\' folder from deployment
         * @summary Retrieves a public resource by name
         * @param {string} [jsonFilter] Filters JSON response utilizing JSONPath syntax if response content type is application/json. See for details: https://github.com/json-path/JsonPath#readme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestResource(jsonFilter?: string, options?: any): AxiosPromise<any> {
            return BPMSResourcesManagementApiFp(configuration).getLatestResource(jsonFilter, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BPMSResourcesManagementApi - object-oriented interface
 * @export
 * @class BPMSResourcesManagementApi
 * @extends {BaseAPI}
 */
export class BPMSResourcesManagementApi extends BaseAPI {
    /**
     * Allowed to upload multiple resources and also packet to ZIP files. Process instances migration to new versions will be performed after deployment. All system insidents will be retried after the migration.
     * @summary Create a deployment with specified resources
     * @param {string} deploymentName Name for the deployment
     * @param {Array<any>} files Resources which the deployment will consist of
     * @param {boolean} [migrate] Migrate all process instances to new deployed versions. To perform perform migration process definitions has to comply conditions/rules explained at https://www.novatec-gmbh.de/blog/automating-process-instance-migration-with-camunda-bpm/ 
     * @param {boolean} [retryIncidents] Bulk retry all incidents in the system after deployment and migration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BPMSResourcesManagementApi
     */
    public create(deploymentName: string, files: Array<any>, migrate?: boolean, retryIncidents?: boolean, options?: any) {
        return BPMSResourcesManagementApiFp(this.configuration).create(deploymentName, files, migrate, retryIncidents, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a form by key from \'/public\' folder in deployment storage
     * @summary Retrieves a deployed form by key
     * @param {string} formKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BPMSResourcesManagementApi
     */
    public getForm(formKey: string, options?: any) {
        return BPMSResourcesManagementApiFp(this.configuration).getForm(formKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves latest version of the resource by name from \'/public\' folder from deployment
     * @summary Retrieves a public resource by name
     * @param {string} [jsonFilter] Filters JSON response utilizing JSONPath syntax if response content type is application/json. See for details: https://github.com/json-path/JsonPath#readme
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BPMSResourcesManagementApi
     */
    public getLatestResource(jsonFilter?: string, options?: any) {
        return BPMSResourcesManagementApiFp(this.configuration).getLatestResource(jsonFilter, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * BorrowerApi - axios parameter creator
 * @export
 */
export const BorrowerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of borrowers
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [filterBlacklisted] 
         * @param {string} [filterSearch] 
         * @param {boolean} [borrowerFilterRequestFilterBlacklisted] Search by borrower\&#39;s blacklisted flag
         * @param {string} [borrowerFilterRequestFilterSearch] Search by borrower\&#39;s full name, phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllBorrowers: async (page?: number, size?: number, sort?: Array<string>, filterBlacklisted?: boolean, filterSearch?: string, borrowerFilterRequestFilterBlacklisted?: boolean, borrowerFilterRequestFilterSearch?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/borrowers`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterBlacklisted !== undefined) {
                localVarQueryParameter['filter.blacklisted'] = filterBlacklisted;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }

            if (borrowerFilterRequestFilterBlacklisted !== undefined) {
                localVarQueryParameter['borrowerFilterRequest.filter.blacklisted'] = borrowerFilterRequestFilterBlacklisted;
            }

            if (borrowerFilterRequestFilterSearch !== undefined) {
                localVarQueryParameter['borrowerFilterRequest.filter.search'] = borrowerFilterRequestFilterSearch;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return borrower\'s black list record if exists
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBlacklistEntry: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling findBlacklistEntry.');
            }
            const localVarPath = `/api/borrowers/{id}/blacklist-entry`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return single borrower
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrower: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getBorrower.');
            }
            const localVarPath = `/api/borrowers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return borrower\'s history
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerHistory: async (id: number, page?: number, size?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getBorrowerHistory.');
            }
            const localVarPath = `/api/borrowers/{id}/history`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update borrower
         * @param {number} id 
         * @param {UNKNOWN_BASE_TYPE} uNKNOWNBASETYPE 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBorrower: async (id: number, uNKNOWNBASETYPE: UNKNOWN_BASE_TYPE, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateBorrower.');
            }
            // verify required parameter 'uNKNOWNBASETYPE' is not null or undefined
            if (uNKNOWNBASETYPE === null || uNKNOWNBASETYPE === undefined) {
                throw new RequiredError('uNKNOWNBASETYPE','Required parameter uNKNOWNBASETYPE was null or undefined when calling updateBorrower.');
            }
            const localVarPath = `/api/borrowers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof uNKNOWNBASETYPE !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(uNKNOWNBASETYPE !== undefined ? uNKNOWNBASETYPE : {}) : (uNKNOWNBASETYPE || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BorrowerApi - functional programming interface
 * @export
 */
export const BorrowerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of borrowers
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [filterBlacklisted] 
         * @param {string} [filterSearch] 
         * @param {boolean} [borrowerFilterRequestFilterBlacklisted] Search by borrower\&#39;s blacklisted flag
         * @param {string} [borrowerFilterRequestFilterSearch] Search by borrower\&#39;s full name, phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllBorrowers(page?: number, size?: number, sort?: Array<string>, filterBlacklisted?: boolean, filterSearch?: string, borrowerFilterRequestFilterBlacklisted?: boolean, borrowerFilterRequestFilterSearch?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageBorrowerDtoBrief>> {
            const localVarAxiosArgs = await BorrowerApiAxiosParamCreator(configuration).findAllBorrowers(page, size, sort, filterBlacklisted, filterSearch, borrowerFilterRequestFilterBlacklisted, borrowerFilterRequestFilterSearch, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return borrower\'s black list record if exists
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findBlacklistEntry(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await BorrowerApiAxiosParamCreator(configuration).findBlacklistEntry(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return single borrower
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBorrower(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BorrowerDto>> {
            const localVarAxiosArgs = await BorrowerApiAxiosParamCreator(configuration).getBorrower(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return borrower\'s history
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBorrowerHistory(id: number, page?: number, size?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageBorrowerRevisionDto>> {
            const localVarAxiosArgs = await BorrowerApiAxiosParamCreator(configuration).getBorrowerHistory(id, page, size, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update borrower
         * @param {number} id 
         * @param {UNKNOWN_BASE_TYPE} uNKNOWNBASETYPE 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBorrower(id: number, uNKNOWNBASETYPE: UNKNOWN_BASE_TYPE, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BorrowerDto>> {
            const localVarAxiosArgs = await BorrowerApiAxiosParamCreator(configuration).updateBorrower(id, uNKNOWNBASETYPE, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BorrowerApi - factory interface
 * @export
 */
export const BorrowerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Return list of borrowers
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {boolean} [filterBlacklisted] 
         * @param {string} [filterSearch] 
         * @param {boolean} [borrowerFilterRequestFilterBlacklisted] Search by borrower\&#39;s blacklisted flag
         * @param {string} [borrowerFilterRequestFilterSearch] Search by borrower\&#39;s full name, phone
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllBorrowers(page?: number, size?: number, sort?: Array<string>, filterBlacklisted?: boolean, filterSearch?: string, borrowerFilterRequestFilterBlacklisted?: boolean, borrowerFilterRequestFilterSearch?: string, options?: any): AxiosPromise<PageBorrowerDtoBrief> {
            return BorrowerApiFp(configuration).findAllBorrowers(page, size, sort, filterBlacklisted, filterSearch, borrowerFilterRequestFilterBlacklisted, borrowerFilterRequestFilterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return borrower\'s black list record if exists
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBlacklistEntry(id: number, options?: any): AxiosPromise<object> {
            return BorrowerApiFp(configuration).findBlacklistEntry(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return single borrower
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrower(id: number, options?: any): AxiosPromise<BorrowerDto> {
            return BorrowerApiFp(configuration).getBorrower(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return borrower\'s history
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerHistory(id: number, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PageBorrowerRevisionDto> {
            return BorrowerApiFp(configuration).getBorrowerHistory(id, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update borrower
         * @param {number} id 
         * @param {UNKNOWN_BASE_TYPE} uNKNOWNBASETYPE 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBorrower(id: number, uNKNOWNBASETYPE: UNKNOWN_BASE_TYPE, options?: any): AxiosPromise<BorrowerDto> {
            return BorrowerApiFp(configuration).updateBorrower(id, uNKNOWNBASETYPE, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BorrowerApi - object-oriented interface
 * @export
 * @class BorrowerApi
 * @extends {BaseAPI}
 */
export class BorrowerApi extends BaseAPI {
    /**
     * 
     * @summary Return list of borrowers
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {boolean} [filterBlacklisted] 
     * @param {string} [filterSearch] 
     * @param {boolean} [borrowerFilterRequestFilterBlacklisted] Search by borrower\&#39;s blacklisted flag
     * @param {string} [borrowerFilterRequestFilterSearch] Search by borrower\&#39;s full name, phone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BorrowerApi
     */
    public findAllBorrowers(page?: number, size?: number, sort?: Array<string>, filterBlacklisted?: boolean, filterSearch?: string, borrowerFilterRequestFilterBlacklisted?: boolean, borrowerFilterRequestFilterSearch?: string, options?: any) {
        return BorrowerApiFp(this.configuration).findAllBorrowers(page, size, sort, filterBlacklisted, filterSearch, borrowerFilterRequestFilterBlacklisted, borrowerFilterRequestFilterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return borrower\'s black list record if exists
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BorrowerApi
     */
    public findBlacklistEntry(id: number, options?: any) {
        return BorrowerApiFp(this.configuration).findBlacklistEntry(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return single borrower
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BorrowerApi
     */
    public getBorrower(id: number, options?: any) {
        return BorrowerApiFp(this.configuration).getBorrower(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return borrower\'s history
     * @param {number} id 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BorrowerApi
     */
    public getBorrowerHistory(id: number, page?: number, size?: number, sort?: Array<string>, options?: any) {
        return BorrowerApiFp(this.configuration).getBorrowerHistory(id, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update borrower
     * @param {number} id 
     * @param {UNKNOWN_BASE_TYPE} uNKNOWNBASETYPE 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BorrowerApi
     */
    public updateBorrower(id: number, uNKNOWNBASETYPE: UNKNOWN_BASE_TYPE, options?: any) {
        return BorrowerApiFp(this.configuration).updateBorrower(id, uNKNOWNBASETYPE, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * BorrowerPortalApi - axios parameter creator
 * @export
 */
export const BorrowerPortalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of loan\'s transactions for borrower
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllTransactionsByLoanId: async (id: number, page?: number, size?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling findAllTransactionsByLoanId.');
            }
            const localVarPath = `/api/borrower/loan/{id}/transactions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return borrower\'s loan application
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerApplication: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getBorrowerApplication.');
            }
            const localVarPath = `/api/borrower/loanApplications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of loan applications for borrower
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerApplications: async (page?: number, size?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/borrower/loanApplications`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return borrower\'s loan
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerLoan: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getBorrowerLoan.');
            }
            const localVarPath = `/api/borrower/loans/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of loans for borrower
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerLoans: async (page?: number, size?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/borrower/loans`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return borrower profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerProfile: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/borrower/profile`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return loan adjustments request for borrower
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanAdjustmentsRequest: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getLoanAdjustmentsRequest.');
            }
            const localVarPath = `/api/borrower/loan-adjustments-requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of loan adjustments requests  for borrower
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by loan adjustments request statuses
         * @param {Array<number>} [filterLoanId] Search by loan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanAdjustmentsRequests: async (page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterLoanId?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/borrower/loan-adjustments-requests`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterStatuses) {
                localVarQueryParameter['filter.statuses'] = filterStatuses;
            }

            if (filterLoanId) {
                localVarQueryParameter['filter.loanId'] = filterLoanId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save borrower\'s UTM parameters
         * @param {Array<UtmParam>} utmParam Collection of UTM parameters that should be stored for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUtmParams: async (utmParam: Array<UtmParam>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'utmParam' is not null or undefined
            if (utmParam === null || utmParam === undefined) {
                throw new RequiredError('utmParam','Required parameter utmParam was null or undefined when calling saveUtmParams.');
            }
            const localVarPath = `/api/borrower/utmParams`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof utmParam !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(utmParam !== undefined ? utmParam : {}) : (utmParam || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BorrowerPortalApi - functional programming interface
 * @export
 */
export const BorrowerPortalApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of loan\'s transactions for borrower
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllTransactionsByLoanId(id: number, page?: number, size?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageTransactionDtoBorrowerAllowed>> {
            const localVarAxiosArgs = await BorrowerPortalApiAxiosParamCreator(configuration).findAllTransactionsByLoanId(id, page, size, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return borrower\'s loan application
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBorrowerApplication(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanApplicationDtoBorrowerAllowed>> {
            const localVarAxiosArgs = await BorrowerPortalApiAxiosParamCreator(configuration).getBorrowerApplication(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return list of loan applications for borrower
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBorrowerApplications(page?: number, size?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanApplicationDtoBorrowerAllowed>> {
            const localVarAxiosArgs = await BorrowerPortalApiAxiosParamCreator(configuration).getBorrowerApplications(page, size, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return borrower\'s loan
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBorrowerLoan(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanDtoBorrowerAllowed>> {
            const localVarAxiosArgs = await BorrowerPortalApiAxiosParamCreator(configuration).getBorrowerLoan(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return list of loans for borrower
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBorrowerLoans(page?: number, size?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanDtoBorrowerAllowed>> {
            const localVarAxiosArgs = await BorrowerPortalApiAxiosParamCreator(configuration).getBorrowerLoans(page, size, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return borrower profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBorrowerProfile(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BorrowerDtoBorrowerAllowed>> {
            const localVarAxiosArgs = await BorrowerPortalApiAxiosParamCreator(configuration).getBorrowerProfile(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return loan adjustments request for borrower
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoanAdjustmentsRequest(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanAdjustmentsRequestDtoBorrowerAllowed>> {
            const localVarAxiosArgs = await BorrowerPortalApiAxiosParamCreator(configuration).getLoanAdjustmentsRequest(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return list of loan adjustments requests  for borrower
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by loan adjustments request statuses
         * @param {Array<number>} [filterLoanId] Search by loan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoanAdjustmentsRequests(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterLoanId?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanAdjustmentsRequestDtoBorrowerAllowed>> {
            const localVarAxiosArgs = await BorrowerPortalApiAxiosParamCreator(configuration).getLoanAdjustmentsRequests(page, size, sort, filterStatuses, filterLoanId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Save borrower\'s UTM parameters
         * @param {Array<UtmParam>} utmParam Collection of UTM parameters that should be stored for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveUtmParams(utmParam: Array<UtmParam>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await BorrowerPortalApiAxiosParamCreator(configuration).saveUtmParams(utmParam, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BorrowerPortalApi - factory interface
 * @export
 */
export const BorrowerPortalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Return list of loan\'s transactions for borrower
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllTransactionsByLoanId(id: number, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PageTransactionDtoBorrowerAllowed> {
            return BorrowerPortalApiFp(configuration).findAllTransactionsByLoanId(id, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return borrower\'s loan application
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerApplication(id: number, options?: any): AxiosPromise<LoanApplicationDtoBorrowerAllowed> {
            return BorrowerPortalApiFp(configuration).getBorrowerApplication(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of loan applications for borrower
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerApplications(page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PageLoanApplicationDtoBorrowerAllowed> {
            return BorrowerPortalApiFp(configuration).getBorrowerApplications(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return borrower\'s loan
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerLoan(id: number, options?: any): AxiosPromise<LoanDtoBorrowerAllowed> {
            return BorrowerPortalApiFp(configuration).getBorrowerLoan(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of loans for borrower
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerLoans(page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PageLoanDtoBorrowerAllowed> {
            return BorrowerPortalApiFp(configuration).getBorrowerLoans(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return borrower profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBorrowerProfile(options?: any): AxiosPromise<BorrowerDtoBorrowerAllowed> {
            return BorrowerPortalApiFp(configuration).getBorrowerProfile(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return loan adjustments request for borrower
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanAdjustmentsRequest(id: string, options?: any): AxiosPromise<LoanAdjustmentsRequestDtoBorrowerAllowed> {
            return BorrowerPortalApiFp(configuration).getLoanAdjustmentsRequest(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of loan adjustments requests  for borrower
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by loan adjustments request statuses
         * @param {Array<number>} [filterLoanId] Search by loan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanAdjustmentsRequests(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterLoanId?: Array<number>, options?: any): AxiosPromise<PageLoanAdjustmentsRequestDtoBorrowerAllowed> {
            return BorrowerPortalApiFp(configuration).getLoanAdjustmentsRequests(page, size, sort, filterStatuses, filterLoanId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save borrower\'s UTM parameters
         * @param {Array<UtmParam>} utmParam Collection of UTM parameters that should be stored for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUtmParams(utmParam: Array<UtmParam>, options?: any): AxiosPromise<void> {
            return BorrowerPortalApiFp(configuration).saveUtmParams(utmParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BorrowerPortalApi - object-oriented interface
 * @export
 * @class BorrowerPortalApi
 * @extends {BaseAPI}
 */
export class BorrowerPortalApi extends BaseAPI {
    /**
     * 
     * @summary Return list of loan\'s transactions for borrower
     * @param {number} id 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BorrowerPortalApi
     */
    public findAllTransactionsByLoanId(id: number, page?: number, size?: number, sort?: Array<string>, options?: any) {
        return BorrowerPortalApiFp(this.configuration).findAllTransactionsByLoanId(id, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return borrower\'s loan application
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BorrowerPortalApi
     */
    public getBorrowerApplication(id: number, options?: any) {
        return BorrowerPortalApiFp(this.configuration).getBorrowerApplication(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of loan applications for borrower
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BorrowerPortalApi
     */
    public getBorrowerApplications(page?: number, size?: number, sort?: Array<string>, options?: any) {
        return BorrowerPortalApiFp(this.configuration).getBorrowerApplications(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return borrower\'s loan
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BorrowerPortalApi
     */
    public getBorrowerLoan(id: number, options?: any) {
        return BorrowerPortalApiFp(this.configuration).getBorrowerLoan(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of loans for borrower
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BorrowerPortalApi
     */
    public getBorrowerLoans(page?: number, size?: number, sort?: Array<string>, options?: any) {
        return BorrowerPortalApiFp(this.configuration).getBorrowerLoans(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return borrower profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BorrowerPortalApi
     */
    public getBorrowerProfile(options?: any) {
        return BorrowerPortalApiFp(this.configuration).getBorrowerProfile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return loan adjustments request for borrower
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BorrowerPortalApi
     */
    public getLoanAdjustmentsRequest(id: string, options?: any) {
        return BorrowerPortalApiFp(this.configuration).getLoanAdjustmentsRequest(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of loan adjustments requests  for borrower
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {Array<string>} [filterStatuses] Search by loan adjustments request statuses
     * @param {Array<number>} [filterLoanId] Search by loan id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BorrowerPortalApi
     */
    public getLoanAdjustmentsRequests(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterLoanId?: Array<number>, options?: any) {
        return BorrowerPortalApiFp(this.configuration).getLoanAdjustmentsRequests(page, size, sort, filterStatuses, filterLoanId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save borrower\'s UTM parameters
     * @param {Array<UtmParam>} utmParam Collection of UTM parameters that should be stored for the authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BorrowerPortalApi
     */
    public saveUtmParams(utmParam: Array<UtmParam>, options?: any) {
        return BorrowerPortalApiFp(this.configuration).saveUtmParams(utmParam, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * CampaignApi - axios parameter creator
 * @export
 */
export const CampaignApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create campaign
         * @param {CreateCampaignRequest} createCampaignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCampaign: async (createCampaignRequest: CreateCampaignRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCampaignRequest' is not null or undefined
            if (createCampaignRequest === null || createCampaignRequest === undefined) {
                throw new RequiredError('createCampaignRequest','Required parameter createCampaignRequest was null or undefined when calling createCampaign.');
            }
            const localVarPath = `/api/campaigns`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof createCampaignRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createCampaignRequest !== undefined ? createCampaignRequest : {}) : (createCampaignRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of campaigns
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [filterMaxAmount] 
         * @param {number} [filterMaxTerm] 
         * @param {boolean} [filterActive] 
         * @param {string} [filterSearch] 
         * @param {number} [filterAgentId] 
         * @param {number} [campaignFilterRequestFilterMaxAmount] Search by campaign max amount
         * @param {number} [campaignFilterRequestFilterMaxTerm] Search by campaign max term
         * @param {boolean} [campaignFilterRequestFilterActive] Search by campaign active flag
         * @param {string} [campaignFilterRequestFilterSearch] Search by campaign name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllCampaigns: async (page?: number, size?: number, sort?: Array<string>, filterMaxAmount?: number, filterMaxTerm?: number, filterActive?: boolean, filterSearch?: string, filterAgentId?: number, campaignFilterRequestFilterMaxAmount?: number, campaignFilterRequestFilterMaxTerm?: number, campaignFilterRequestFilterActive?: boolean, campaignFilterRequestFilterSearch?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/campaigns`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterMaxAmount !== undefined) {
                localVarQueryParameter['filter.maxAmount'] = filterMaxAmount;
            }

            if (filterMaxTerm !== undefined) {
                localVarQueryParameter['filter.maxTerm'] = filterMaxTerm;
            }

            if (filterActive !== undefined) {
                localVarQueryParameter['filter.active'] = filterActive;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }

            if (filterAgentId !== undefined) {
                localVarQueryParameter['filter.agentId'] = filterAgentId;
            }

            if (campaignFilterRequestFilterMaxAmount !== undefined) {
                localVarQueryParameter['campaignFilterRequest.filter.maxAmount'] = campaignFilterRequestFilterMaxAmount;
            }

            if (campaignFilterRequestFilterMaxTerm !== undefined) {
                localVarQueryParameter['campaignFilterRequest.filter.maxTerm'] = campaignFilterRequestFilterMaxTerm;
            }

            if (campaignFilterRequestFilterActive !== undefined) {
                localVarQueryParameter['campaignFilterRequest.filter.active'] = campaignFilterRequestFilterActive;
            }

            if (campaignFilterRequestFilterSearch !== undefined) {
                localVarQueryParameter['campaignFilterRequest.filter.search'] = campaignFilterRequestFilterSearch;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return campaign
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaign: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getCampaign.');
            }
            const localVarPath = `/api/campaigns/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return current internal scoring model
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentInternalScoringModel: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getCurrentInternalScoringModel.');
            }
            const localVarPath = `/api/campaigns/{id}/scoring/internal/model`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of GiniMachine scoring models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGiniMachineScoringModels: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/campaigns/scoring/ginimachine/model`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of internal scoring models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInternalScoringModels: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/campaigns/scoring/internal/models`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update campaign
         * @param {number} id 
         * @param {UpdateCampaignRequest} updateCampaignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCampaign: async (id: number, updateCampaignRequest: UpdateCampaignRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateCampaign.');
            }
            // verify required parameter 'updateCampaignRequest' is not null or undefined
            if (updateCampaignRequest === null || updateCampaignRequest === undefined) {
                throw new RequiredError('updateCampaignRequest','Required parameter updateCampaignRequest was null or undefined when calling updateCampaign.');
            }
            const localVarPath = `/api/campaigns/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateCampaignRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateCampaignRequest !== undefined ? updateCampaignRequest : {}) : (updateCampaignRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CampaignApi - functional programming interface
 * @export
 */
export const CampaignApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create campaign
         * @param {CreateCampaignRequest} createCampaignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCampaign(createCampaignRequest: CreateCampaignRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignDto>> {
            const localVarAxiosArgs = await CampaignApiAxiosParamCreator(configuration).createCampaign(createCampaignRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return list of campaigns
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [filterMaxAmount] 
         * @param {number} [filterMaxTerm] 
         * @param {boolean} [filterActive] 
         * @param {string} [filterSearch] 
         * @param {number} [filterAgentId] 
         * @param {number} [campaignFilterRequestFilterMaxAmount] Search by campaign max amount
         * @param {number} [campaignFilterRequestFilterMaxTerm] Search by campaign max term
         * @param {boolean} [campaignFilterRequestFilterActive] Search by campaign active flag
         * @param {string} [campaignFilterRequestFilterSearch] Search by campaign name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllCampaigns(page?: number, size?: number, sort?: Array<string>, filterMaxAmount?: number, filterMaxTerm?: number, filterActive?: boolean, filterSearch?: string, filterAgentId?: number, campaignFilterRequestFilterMaxAmount?: number, campaignFilterRequestFilterMaxTerm?: number, campaignFilterRequestFilterActive?: boolean, campaignFilterRequestFilterSearch?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageCampaignDtoBrief>> {
            const localVarAxiosArgs = await CampaignApiAxiosParamCreator(configuration).findAllCampaigns(page, size, sort, filterMaxAmount, filterMaxTerm, filterActive, filterSearch, filterAgentId, campaignFilterRequestFilterMaxAmount, campaignFilterRequestFilterMaxTerm, campaignFilterRequestFilterActive, campaignFilterRequestFilterSearch, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return campaign
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCampaign(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignDto>> {
            const localVarAxiosArgs = await CampaignApiAxiosParamCreator(configuration).getCampaign(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return current internal scoring model
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentInternalScoringModel(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalScoringModelDto>> {
            const localVarAxiosArgs = await CampaignApiAxiosParamCreator(configuration).getCurrentInternalScoringModel(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return list of GiniMachine scoring models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGiniMachineScoringModels(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GiniMachineScoringModel>>> {
            const localVarAxiosArgs = await CampaignApiAxiosParamCreator(configuration).getGiniMachineScoringModels(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return list of internal scoring models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInternalScoringModels(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InternalScoringModelDto>>> {
            const localVarAxiosArgs = await CampaignApiAxiosParamCreator(configuration).getInternalScoringModels(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update campaign
         * @param {number} id 
         * @param {UpdateCampaignRequest} updateCampaignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCampaign(id: number, updateCampaignRequest: UpdateCampaignRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignDto>> {
            const localVarAxiosArgs = await CampaignApiAxiosParamCreator(configuration).updateCampaign(id, updateCampaignRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CampaignApi - factory interface
 * @export
 */
export const CampaignApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Create campaign
         * @param {CreateCampaignRequest} createCampaignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCampaign(createCampaignRequest: CreateCampaignRequest, options?: any): AxiosPromise<CampaignDto> {
            return CampaignApiFp(configuration).createCampaign(createCampaignRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of campaigns
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [filterMaxAmount] 
         * @param {number} [filterMaxTerm] 
         * @param {boolean} [filterActive] 
         * @param {string} [filterSearch] 
         * @param {number} [filterAgentId] 
         * @param {number} [campaignFilterRequestFilterMaxAmount] Search by campaign max amount
         * @param {number} [campaignFilterRequestFilterMaxTerm] Search by campaign max term
         * @param {boolean} [campaignFilterRequestFilterActive] Search by campaign active flag
         * @param {string} [campaignFilterRequestFilterSearch] Search by campaign name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllCampaigns(page?: number, size?: number, sort?: Array<string>, filterMaxAmount?: number, filterMaxTerm?: number, filterActive?: boolean, filterSearch?: string, filterAgentId?: number, campaignFilterRequestFilterMaxAmount?: number, campaignFilterRequestFilterMaxTerm?: number, campaignFilterRequestFilterActive?: boolean, campaignFilterRequestFilterSearch?: string, options?: any): AxiosPromise<PageCampaignDtoBrief> {
            return CampaignApiFp(configuration).findAllCampaigns(page, size, sort, filterMaxAmount, filterMaxTerm, filterActive, filterSearch, filterAgentId, campaignFilterRequestFilterMaxAmount, campaignFilterRequestFilterMaxTerm, campaignFilterRequestFilterActive, campaignFilterRequestFilterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return campaign
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaign(id: number, options?: any): AxiosPromise<CampaignDto> {
            return CampaignApiFp(configuration).getCampaign(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return current internal scoring model
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentInternalScoringModel(id: number, options?: any): AxiosPromise<InternalScoringModelDto> {
            return CampaignApiFp(configuration).getCurrentInternalScoringModel(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of GiniMachine scoring models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGiniMachineScoringModels(options?: any): AxiosPromise<Array<GiniMachineScoringModel>> {
            return CampaignApiFp(configuration).getGiniMachineScoringModels(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of internal scoring models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInternalScoringModels(options?: any): AxiosPromise<Array<InternalScoringModelDto>> {
            return CampaignApiFp(configuration).getInternalScoringModels(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update campaign
         * @param {number} id 
         * @param {UpdateCampaignRequest} updateCampaignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCampaign(id: number, updateCampaignRequest: UpdateCampaignRequest, options?: any): AxiosPromise<CampaignDto> {
            return CampaignApiFp(configuration).updateCampaign(id, updateCampaignRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CampaignApi - object-oriented interface
 * @export
 * @class CampaignApi
 * @extends {BaseAPI}
 */
export class CampaignApi extends BaseAPI {
    /**
     * 
     * @summary Create campaign
     * @param {CreateCampaignRequest} createCampaignRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignApi
     */
    public createCampaign(createCampaignRequest: CreateCampaignRequest, options?: any) {
        return CampaignApiFp(this.configuration).createCampaign(createCampaignRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of campaigns
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [filterMaxAmount] 
     * @param {number} [filterMaxTerm] 
     * @param {boolean} [filterActive] 
     * @param {string} [filterSearch] 
     * @param {number} [filterAgentId] 
     * @param {number} [campaignFilterRequestFilterMaxAmount] Search by campaign max amount
     * @param {number} [campaignFilterRequestFilterMaxTerm] Search by campaign max term
     * @param {boolean} [campaignFilterRequestFilterActive] Search by campaign active flag
     * @param {string} [campaignFilterRequestFilterSearch] Search by campaign name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignApi
     */
    public findAllCampaigns(page?: number, size?: number, sort?: Array<string>, filterMaxAmount?: number, filterMaxTerm?: number, filterActive?: boolean, filterSearch?: string, filterAgentId?: number, campaignFilterRequestFilterMaxAmount?: number, campaignFilterRequestFilterMaxTerm?: number, campaignFilterRequestFilterActive?: boolean, campaignFilterRequestFilterSearch?: string, options?: any) {
        return CampaignApiFp(this.configuration).findAllCampaigns(page, size, sort, filterMaxAmount, filterMaxTerm, filterActive, filterSearch, filterAgentId, campaignFilterRequestFilterMaxAmount, campaignFilterRequestFilterMaxTerm, campaignFilterRequestFilterActive, campaignFilterRequestFilterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return campaign
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignApi
     */
    public getCampaign(id: number, options?: any) {
        return CampaignApiFp(this.configuration).getCampaign(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return current internal scoring model
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignApi
     */
    public getCurrentInternalScoringModel(id: number, options?: any) {
        return CampaignApiFp(this.configuration).getCurrentInternalScoringModel(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of GiniMachine scoring models
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignApi
     */
    public getGiniMachineScoringModels(options?: any) {
        return CampaignApiFp(this.configuration).getGiniMachineScoringModels(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of internal scoring models
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignApi
     */
    public getInternalScoringModels(options?: any) {
        return CampaignApiFp(this.configuration).getInternalScoringModels(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update campaign
     * @param {number} id 
     * @param {UpdateCampaignRequest} updateCampaignRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignApi
     */
    public updateCampaign(id: number, updateCampaignRequest: UpdateCampaignRequest, options?: any) {
        return CampaignApiFp(this.configuration).updateCampaign(id, updateCampaignRequest, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * CollectionApi - axios parameter creator
 * @export
 */
export const CollectionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of collections
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by collection statuses
         * @param {string} [filterSearch] Search by collection number; borrower\&#39;s full name, phone, email
         * @param {string} [filterStartedAtFrom] Search by collection started at from
         * @param {string} [filterStartedAtTo] Search by collection started at to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllCollections: async (page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterSearch?: string, filterStartedAtFrom?: string, filterStartedAtTo?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/collections`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterStatuses) {
                localVarQueryParameter['filter.statuses'] = filterStatuses;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }

            if (filterStartedAtFrom !== undefined) {
                localVarQueryParameter['filter.startedAtFrom'] = filterStartedAtFrom;
            }

            if (filterStartedAtTo !== undefined) {
                localVarQueryParameter['filter.startedAtTo'] = filterStartedAtTo;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return single collection
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollection: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getCollection.');
            }
            const localVarPath = `/api/collections/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CollectionApi - functional programming interface
 * @export
 */
export const CollectionApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of collections
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by collection statuses
         * @param {string} [filterSearch] Search by collection number; borrower\&#39;s full name, phone, email
         * @param {string} [filterStartedAtFrom] Search by collection started at from
         * @param {string} [filterStartedAtTo] Search by collection started at to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllCollections(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterSearch?: string, filterStartedAtFrom?: string, filterStartedAtTo?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageCollectionItemDtoBrief>> {
            const localVarAxiosArgs = await CollectionApiAxiosParamCreator(configuration).findAllCollections(page, size, sort, filterStatuses, filterSearch, filterStartedAtFrom, filterStartedAtTo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return single collection
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollection(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionDto>> {
            const localVarAxiosArgs = await CollectionApiAxiosParamCreator(configuration).getCollection(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CollectionApi - factory interface
 * @export
 */
export const CollectionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Return list of collections
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by collection statuses
         * @param {string} [filterSearch] Search by collection number; borrower\&#39;s full name, phone, email
         * @param {string} [filterStartedAtFrom] Search by collection started at from
         * @param {string} [filterStartedAtTo] Search by collection started at to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllCollections(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterSearch?: string, filterStartedAtFrom?: string, filterStartedAtTo?: string, options?: any): AxiosPromise<PageCollectionItemDtoBrief> {
            return CollectionApiFp(configuration).findAllCollections(page, size, sort, filterStatuses, filterSearch, filterStartedAtFrom, filterStartedAtTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return single collection
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollection(id: number, options?: any): AxiosPromise<CollectionDto> {
            return CollectionApiFp(configuration).getCollection(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CollectionApi - object-oriented interface
 * @export
 * @class CollectionApi
 * @extends {BaseAPI}
 */
export class CollectionApi extends BaseAPI {
    /**
     * 
     * @summary Return list of collections
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {Array<string>} [filterStatuses] Search by collection statuses
     * @param {string} [filterSearch] Search by collection number; borrower\&#39;s full name, phone, email
     * @param {string} [filterStartedAtFrom] Search by collection started at from
     * @param {string} [filterStartedAtTo] Search by collection started at to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionApi
     */
    public findAllCollections(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterSearch?: string, filterStartedAtFrom?: string, filterStartedAtTo?: string, options?: any) {
        return CollectionApiFp(this.configuration).findAllCollections(page, size, sort, filterStatuses, filterSearch, filterStartedAtFrom, filterStartedAtTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return single collection
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CollectionApi
     */
    public getCollection(id: number, options?: any) {
        return CollectionApiFp(this.configuration).getCollection(id, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * DocumentTemplateApi - axios parameter creator
 * @export
 */
export const DocumentTemplateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete document template by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentTemplate: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteDocumentTemplate.');
            }
            const localVarPath = `/api/settings/document-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of document templates
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [filterType] Filter by document template\&#39;s type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllDocumentTemplates: async (page?: number, size?: number, sort?: Array<string>, filterType?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/document-templates`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterType !== undefined) {
                localVarQueryParameter['filter.type'] = filterType;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate template placeholders
         * @param {string} fileUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateTemplateByFileUuid: async (fileUuid: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileUuid' is not null or undefined
            if (fileUuid === null || fileUuid === undefined) {
                throw new RequiredError('fileUuid','Required parameter fileUuid was null or undefined when calling validateTemplateByFileUuid.');
            }
            const localVarPath = `/api/settings/document-templates/{fileUuid}`
                .replace(`{${"fileUuid"}}`, encodeURIComponent(String(fileUuid)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentTemplateApi - functional programming interface
 * @export
 */
export const DocumentTemplateApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete document template by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocumentTemplate(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await DocumentTemplateApiAxiosParamCreator(configuration).deleteDocumentTemplate(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return list of document templates
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [filterType] Filter by document template\&#39;s type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllDocumentTemplates(page?: number, size?: number, sort?: Array<string>, filterType?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDocumentTemplateDto>> {
            const localVarAxiosArgs = await DocumentTemplateApiAxiosParamCreator(configuration).findAllDocumentTemplates(page, size, sort, filterType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validate template placeholders
         * @param {string} fileUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateTemplateByFileUuid(fileUuid: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await DocumentTemplateApiAxiosParamCreator(configuration).validateTemplateByFileUuid(fileUuid, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DocumentTemplateApi - factory interface
 * @export
 */
export const DocumentTemplateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Delete document template by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentTemplate(id: number, options?: any): AxiosPromise<void> {
            return DocumentTemplateApiFp(configuration).deleteDocumentTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of document templates
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [filterType] Filter by document template\&#39;s type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllDocumentTemplates(page?: number, size?: number, sort?: Array<string>, filterType?: string, options?: any): AxiosPromise<PageDocumentTemplateDto> {
            return DocumentTemplateApiFp(configuration).findAllDocumentTemplates(page, size, sort, filterType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate template placeholders
         * @param {string} fileUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateTemplateByFileUuid(fileUuid: string, options?: any): AxiosPromise<{ [key: string]: object; }> {
            return DocumentTemplateApiFp(configuration).validateTemplateByFileUuid(fileUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentTemplateApi - object-oriented interface
 * @export
 * @class DocumentTemplateApi
 * @extends {BaseAPI}
 */
export class DocumentTemplateApi extends BaseAPI {
    /**
     * 
     * @summary Delete document template by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentTemplateApi
     */
    public deleteDocumentTemplate(id: number, options?: any) {
        return DocumentTemplateApiFp(this.configuration).deleteDocumentTemplate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of document templates
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [filterType] Filter by document template\&#39;s type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentTemplateApi
     */
    public findAllDocumentTemplates(page?: number, size?: number, sort?: Array<string>, filterType?: string, options?: any) {
        return DocumentTemplateApiFp(this.configuration).findAllDocumentTemplates(page, size, sort, filterType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate template placeholders
     * @param {string} fileUuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentTemplateApi
     */
    public validateTemplateByFileUuid(fileUuid: string, options?: any) {
        return DocumentTemplateApiFp(this.configuration).validateTemplateByFileUuid(fileUuid, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * DocumentTemplatesApi - axios parameter creator
 * @export
 */
export const DocumentTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of available templates in requested folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllTemplates: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document-templates/**`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentTemplatesApi - functional programming interface
 * @export
 */
export const DocumentTemplatesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of available templates in requested folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllTemplates(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TemplateDescription>>> {
            const localVarAxiosArgs = await DocumentTemplatesApiAxiosParamCreator(configuration).findAllTemplates(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DocumentTemplatesApi - factory interface
 * @export
 */
export const DocumentTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Return list of available templates in requested folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllTemplates(options?: any): AxiosPromise<Array<TemplateDescription>> {
            return DocumentTemplatesApiFp(configuration).findAllTemplates(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentTemplatesApi - object-oriented interface
 * @export
 * @class DocumentTemplatesApi
 * @extends {BaseAPI}
 */
export class DocumentTemplatesApi extends BaseAPI {
    /**
     * 
     * @summary Return list of available templates in requested folder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentTemplatesApi
     */
    public findAllTemplates(options?: any) {
        return DocumentTemplatesApiFp(this.configuration).findAllTemplates(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * FileStorageApi - axios parameter creator
 * @export
 */
export const FileStorageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes a file from configured storage
         * @summary File deletion
         * @param {string} fileUuid The file name to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (fileUuid: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileUuid' is not null or undefined
            if (fileUuid === null || fileUuid === undefined) {
                throw new RequiredError('fileUuid','Required parameter fileUuid was null or undefined when calling _delete.');
            }
            const localVarPath = `/api/file`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (fileUuid !== undefined) {
                localVarQueryParameter['fileUuid'] = fileUuid;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a file from configured storage or pre-generated location
         * @summary File download
         * @param {string} fileUuid The file UUID to retrieve
         * @param {boolean} [asAttachment] The download file content disposition. True - \&#39;attachment\&#39;, false - \&#39;inline\&#39;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        download: async (fileUuid: string, asAttachment?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileUuid' is not null or undefined
            if (fileUuid === null || fileUuid === undefined) {
                throw new RequiredError('fileUuid','Required parameter fileUuid was null or undefined when calling download.');
            }
            const localVarPath = `/api/file`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (fileUuid !== undefined) {
                localVarQueryParameter['fileUuid'] = fileUuid;
            }

            if (asAttachment !== undefined) {
                localVarQueryParameter['asAttachment'] = asAttachment;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Receives a file and stores it in configured storage
         * @summary File upload
         * @param {string} dir The directory to store file into
         * @param {any} file The file content to store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload: async (dir: string, file: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dir' is not null or undefined
            if (dir === null || dir === undefined) {
                throw new RequiredError('dir','Required parameter dir was null or undefined when calling upload.');
            }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling upload.');
            }
            const localVarPath = `/api/file`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (dir !== undefined) {
                localVarQueryParameter['dir'] = dir;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileStorageApi - functional programming interface
 * @export
 */
export const FileStorageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Deletes a file from configured storage
         * @summary File deletion
         * @param {string} fileUuid The file name to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(fileUuid: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FileStorageApiAxiosParamCreator(configuration)._delete(fileUuid, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieves a file from configured storage or pre-generated location
         * @summary File download
         * @param {string} fileUuid The file UUID to retrieve
         * @param {boolean} [asAttachment] The download file content disposition. True - \&#39;attachment\&#39;, false - \&#39;inline\&#39;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async download(fileUuid: string, asAttachment?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await FileStorageApiAxiosParamCreator(configuration).download(fileUuid, asAttachment, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Receives a file and stores it in configured storage
         * @summary File upload
         * @param {string} dir The directory to store file into
         * @param {any} file The file content to store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upload(dir: string, file: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadResponse>> {
            const localVarAxiosArgs = await FileStorageApiAxiosParamCreator(configuration).upload(dir, file, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FileStorageApi - factory interface
 * @export
 */
export const FileStorageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Deletes a file from configured storage
         * @summary File deletion
         * @param {string} fileUuid The file name to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(fileUuid: string, options?: any): AxiosPromise<void> {
            return FileStorageApiFp(configuration)._delete(fileUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a file from configured storage or pre-generated location
         * @summary File download
         * @param {string} fileUuid The file UUID to retrieve
         * @param {boolean} [asAttachment] The download file content disposition. True - \&#39;attachment\&#39;, false - \&#39;inline\&#39;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        download(fileUuid: string, asAttachment?: boolean, options?: any): AxiosPromise<any> {
            return FileStorageApiFp(configuration).download(fileUuid, asAttachment, options).then((request) => request(axios, basePath));
        },
        /**
         * Receives a file and stores it in configured storage
         * @summary File upload
         * @param {string} dir The directory to store file into
         * @param {any} file The file content to store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload(dir: string, file: any, options?: any): AxiosPromise<FileUploadResponse> {
            return FileStorageApiFp(configuration).upload(dir, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FileStorageApi - object-oriented interface
 * @export
 * @class FileStorageApi
 * @extends {BaseAPI}
 */
export class FileStorageApi extends BaseAPI {
    /**
     * Deletes a file from configured storage
     * @summary File deletion
     * @param {string} fileUuid The file name to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileStorageApi
     */
    public _delete(fileUuid: string, options?: any) {
        return FileStorageApiFp(this.configuration)._delete(fileUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a file from configured storage or pre-generated location
     * @summary File download
     * @param {string} fileUuid The file UUID to retrieve
     * @param {boolean} [asAttachment] The download file content disposition. True - \&#39;attachment\&#39;, false - \&#39;inline\&#39;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileStorageApi
     */
    public download(fileUuid: string, asAttachment?: boolean, options?: any) {
        return FileStorageApiFp(this.configuration).download(fileUuid, asAttachment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Receives a file and stores it in configured storage
     * @summary File upload
     * @param {string} dir The directory to store file into
     * @param {any} file The file content to store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileStorageApi
     */
    public upload(dir: string, file: any, options?: any) {
        return FileStorageApiFp(this.configuration).upload(dir, file, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * IntegrationApi - axios parameter creator
 * @export
 */
export const IntegrationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a loan based on the loan application
         * @param {RequestLoanManagement} requestLoanManagement 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageLoan: async (requestLoanManagement: RequestLoanManagement, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestLoanManagement' is not null or undefined
            if (requestLoanManagement === null || requestLoanManagement === undefined) {
                throw new RequiredError('requestLoanManagement','Required parameter requestLoanManagement was null or undefined when calling manageLoan.');
            }
            const localVarPath = `/api/integration/v1/manage-loan`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof requestLoanManagement !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(requestLoanManagement !== undefined ? requestLoanManagement : {}) : (requestLoanManagement || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Originate and manage loan application with borrower as legal entity
         * @param {Array} balanceSheet List of Balance sheet files
         * @param {Array} idDocument List of files of the document identifying the representative of the legal entity
         * @param {Array} pnlStatement List of Profit and loss statement files
         * @param {RequestLegalEntityLoanOrigination} request 
         * @param {string} [callbackUrl] URL for sending a callback with a processed loan application. Callback will not performed if the parameter not provided
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        originateAndManageLoanLegalEntity: async (balanceSheet: Array, idDocument: Array, pnlStatement: Array, request: RequestLegalEntityLoanOrigination, callbackUrl?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'balanceSheet' is not null or undefined
            if (balanceSheet === null || balanceSheet === undefined) {
                throw new RequiredError('balanceSheet','Required parameter balanceSheet was null or undefined when calling originateAndManageLoanLegalEntity.');
            }
            // verify required parameter 'idDocument' is not null or undefined
            if (idDocument === null || idDocument === undefined) {
                throw new RequiredError('idDocument','Required parameter idDocument was null or undefined when calling originateAndManageLoanLegalEntity.');
            }
            // verify required parameter 'pnlStatement' is not null or undefined
            if (pnlStatement === null || pnlStatement === undefined) {
                throw new RequiredError('pnlStatement','Required parameter pnlStatement was null or undefined when calling originateAndManageLoanLegalEntity.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new RequiredError('request','Required parameter request was null or undefined when calling originateAndManageLoanLegalEntity.');
            }
            const localVarPath = `/api/integration/v1/originate-and-manage-loan-legal-entity`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


            if (balanceSheet !== undefined) { 
                localVarFormParams.append('balanceSheet', balanceSheet as any);
            }
    
            if (callbackUrl !== undefined) { 
                localVarFormParams.append('callbackUrl', callbackUrl as any);
            }
    
            if (idDocument !== undefined) { 
                localVarFormParams.append('idDocument', idDocument as any);
            }
    
            if (pnlStatement !== undefined) { 
                localVarFormParams.append('pnlStatement', pnlStatement as any);
            }
    
            if (request !== undefined) { 
                localVarFormParams.append('request', request as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Originate and manage loan application with borrower as person
         * @param {Array} idDocument List of the identification document\\\&#39;s files
         * @param {RequestPersonLoanOrigination} request 
         * @param {string} [callbackUrl] URL for sending a callback with a processed loan application. Callback will not performed if the parameter not provided
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        originateAndManageLoanPerson: async (idDocument: Array, request: RequestPersonLoanOrigination, callbackUrl?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idDocument' is not null or undefined
            if (idDocument === null || idDocument === undefined) {
                throw new RequiredError('idDocument','Required parameter idDocument was null or undefined when calling originateAndManageLoanPerson.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new RequiredError('request','Required parameter request was null or undefined when calling originateAndManageLoanPerson.');
            }
            const localVarPath = `/api/integration/v1/originate-and-manage-loan-person`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


            if (callbackUrl !== undefined) { 
                localVarFormParams.append('callbackUrl', callbackUrl as any);
            }
    
            if (idDocument !== undefined) { 
                localVarFormParams.append('idDocument', idDocument as any);
            }
    
            if (request !== undefined) { 
                localVarFormParams.append('request', request as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Originate loan application with borrower as legal entity
         * @param {Array} balanceSheet List of Balance sheet files
         * @param {string} callbackUrl URL for sending a callback with a processed loan application
         * @param {Array} idDocument List of files of the document identifying the representative of the legal entity
         * @param {Array} pnlStatement List of Profit and loss statement files
         * @param {RequestLegalEntityLoanOrigination} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        originateLoanLegalEntity: async (balanceSheet: Array, callbackUrl: string, idDocument: Array, pnlStatement: Array, request: RequestLegalEntityLoanOrigination, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'balanceSheet' is not null or undefined
            if (balanceSheet === null || balanceSheet === undefined) {
                throw new RequiredError('balanceSheet','Required parameter balanceSheet was null or undefined when calling originateLoanLegalEntity.');
            }
            // verify required parameter 'callbackUrl' is not null or undefined
            if (callbackUrl === null || callbackUrl === undefined) {
                throw new RequiredError('callbackUrl','Required parameter callbackUrl was null or undefined when calling originateLoanLegalEntity.');
            }
            // verify required parameter 'idDocument' is not null or undefined
            if (idDocument === null || idDocument === undefined) {
                throw new RequiredError('idDocument','Required parameter idDocument was null or undefined when calling originateLoanLegalEntity.');
            }
            // verify required parameter 'pnlStatement' is not null or undefined
            if (pnlStatement === null || pnlStatement === undefined) {
                throw new RequiredError('pnlStatement','Required parameter pnlStatement was null or undefined when calling originateLoanLegalEntity.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new RequiredError('request','Required parameter request was null or undefined when calling originateLoanLegalEntity.');
            }
            const localVarPath = `/api/integration/v1/originate-loan-legal-entity`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


            if (balanceSheet !== undefined) { 
                localVarFormParams.append('balanceSheet', balanceSheet as any);
            }
    
            if (callbackUrl !== undefined) { 
                localVarFormParams.append('callbackUrl', callbackUrl as any);
            }
    
            if (idDocument !== undefined) { 
                localVarFormParams.append('idDocument', idDocument as any);
            }
    
            if (pnlStatement !== undefined) { 
                localVarFormParams.append('pnlStatement', pnlStatement as any);
            }
    
            if (request !== undefined) { 
                localVarFormParams.append('request', request as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Originate loan application with borrower as person
         * @param {string} callbackUrl URL for sending a callback with a processed loan application
         * @param {Array} idDocument List of the identification document\\\&#39;s files
         * @param {RequestPersonLoanOrigination} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        originateLoanPerson: async (callbackUrl: string, idDocument: Array, request: RequestPersonLoanOrigination, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'callbackUrl' is not null or undefined
            if (callbackUrl === null || callbackUrl === undefined) {
                throw new RequiredError('callbackUrl','Required parameter callbackUrl was null or undefined when calling originateLoanPerson.');
            }
            // verify required parameter 'idDocument' is not null or undefined
            if (idDocument === null || idDocument === undefined) {
                throw new RequiredError('idDocument','Required parameter idDocument was null or undefined when calling originateLoanPerson.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new RequiredError('request','Required parameter request was null or undefined when calling originateLoanPerson.');
            }
            const localVarPath = `/api/integration/v1/originate-loan-person`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


            if (callbackUrl !== undefined) { 
                localVarFormParams.append('callbackUrl', callbackUrl as any);
            }
    
            if (idDocument !== undefined) { 
                localVarFormParams.append('idDocument', idDocument as any);
            }
    
            if (request !== undefined) { 
                localVarFormParams.append('request', request as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntegrationApi - functional programming interface
 * @export
 */
export const IntegrationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a loan based on the loan application
         * @param {RequestLoanManagement} requestLoanManagement 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manageLoan(requestLoanManagement: RequestLoanManagement, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanApplicationDto>> {
            const localVarAxiosArgs = await IntegrationApiAxiosParamCreator(configuration).manageLoan(requestLoanManagement, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Originate and manage loan application with borrower as legal entity
         * @param {Array} balanceSheet List of Balance sheet files
         * @param {Array} idDocument List of files of the document identifying the representative of the legal entity
         * @param {Array} pnlStatement List of Profit and loss statement files
         * @param {RequestLegalEntityLoanOrigination} request 
         * @param {string} [callbackUrl] URL for sending a callback with a processed loan application. Callback will not performed if the parameter not provided
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async originateAndManageLoanLegalEntity(balanceSheet: Array, idDocument: Array, pnlStatement: Array, request: RequestLegalEntityLoanOrigination, callbackUrl?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await IntegrationApiAxiosParamCreator(configuration).originateAndManageLoanLegalEntity(balanceSheet, idDocument, pnlStatement, request, callbackUrl, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Originate and manage loan application with borrower as person
         * @param {Array} idDocument List of the identification document\\\&#39;s files
         * @param {RequestPersonLoanOrigination} request 
         * @param {string} [callbackUrl] URL for sending a callback with a processed loan application. Callback will not performed if the parameter not provided
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async originateAndManageLoanPerson(idDocument: Array, request: RequestPersonLoanOrigination, callbackUrl?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await IntegrationApiAxiosParamCreator(configuration).originateAndManageLoanPerson(idDocument, request, callbackUrl, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Originate loan application with borrower as legal entity
         * @param {Array} balanceSheet List of Balance sheet files
         * @param {string} callbackUrl URL for sending a callback with a processed loan application
         * @param {Array} idDocument List of files of the document identifying the representative of the legal entity
         * @param {Array} pnlStatement List of Profit and loss statement files
         * @param {RequestLegalEntityLoanOrigination} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async originateLoanLegalEntity(balanceSheet: Array, callbackUrl: string, idDocument: Array, pnlStatement: Array, request: RequestLegalEntityLoanOrigination, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await IntegrationApiAxiosParamCreator(configuration).originateLoanLegalEntity(balanceSheet, callbackUrl, idDocument, pnlStatement, request, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Originate loan application with borrower as person
         * @param {string} callbackUrl URL for sending a callback with a processed loan application
         * @param {Array} idDocument List of the identification document\\\&#39;s files
         * @param {RequestPersonLoanOrigination} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async originateLoanPerson(callbackUrl: string, idDocument: Array, request: RequestPersonLoanOrigination, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await IntegrationApiAxiosParamCreator(configuration).originateLoanPerson(callbackUrl, idDocument, request, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * IntegrationApi - factory interface
 * @export
 */
export const IntegrationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Create a loan based on the loan application
         * @param {RequestLoanManagement} requestLoanManagement 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageLoan(requestLoanManagement: RequestLoanManagement, options?: any): AxiosPromise<LoanApplicationDto> {
            return IntegrationApiFp(configuration).manageLoan(requestLoanManagement, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Originate and manage loan application with borrower as legal entity
         * @param {Array} balanceSheet List of Balance sheet files
         * @param {Array} idDocument List of files of the document identifying the representative of the legal entity
         * @param {Array} pnlStatement List of Profit and loss statement files
         * @param {RequestLegalEntityLoanOrigination} request 
         * @param {string} [callbackUrl] URL for sending a callback with a processed loan application. Callback will not performed if the parameter not provided
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        originateAndManageLoanLegalEntity(balanceSheet: Array, idDocument: Array, pnlStatement: Array, request: RequestLegalEntityLoanOrigination, callbackUrl?: string, options?: any): AxiosPromise<string> {
            return IntegrationApiFp(configuration).originateAndManageLoanLegalEntity(balanceSheet, idDocument, pnlStatement, request, callbackUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Originate and manage loan application with borrower as person
         * @param {Array} idDocument List of the identification document\\\&#39;s files
         * @param {RequestPersonLoanOrigination} request 
         * @param {string} [callbackUrl] URL for sending a callback with a processed loan application. Callback will not performed if the parameter not provided
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        originateAndManageLoanPerson(idDocument: Array, request: RequestPersonLoanOrigination, callbackUrl?: string, options?: any): AxiosPromise<string> {
            return IntegrationApiFp(configuration).originateAndManageLoanPerson(idDocument, request, callbackUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Originate loan application with borrower as legal entity
         * @param {Array} balanceSheet List of Balance sheet files
         * @param {string} callbackUrl URL for sending a callback with a processed loan application
         * @param {Array} idDocument List of files of the document identifying the representative of the legal entity
         * @param {Array} pnlStatement List of Profit and loss statement files
         * @param {RequestLegalEntityLoanOrigination} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        originateLoanLegalEntity(balanceSheet: Array, callbackUrl: string, idDocument: Array, pnlStatement: Array, request: RequestLegalEntityLoanOrigination, options?: any): AxiosPromise<string> {
            return IntegrationApiFp(configuration).originateLoanLegalEntity(balanceSheet, callbackUrl, idDocument, pnlStatement, request, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Originate loan application with borrower as person
         * @param {string} callbackUrl URL for sending a callback with a processed loan application
         * @param {Array} idDocument List of the identification document\\\&#39;s files
         * @param {RequestPersonLoanOrigination} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        originateLoanPerson(callbackUrl: string, idDocument: Array, request: RequestPersonLoanOrigination, options?: any): AxiosPromise<string> {
            return IntegrationApiFp(configuration).originateLoanPerson(callbackUrl, idDocument, request, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IntegrationApi - object-oriented interface
 * @export
 * @class IntegrationApi
 * @extends {BaseAPI}
 */
export class IntegrationApi extends BaseAPI {
    /**
     * 
     * @summary Create a loan based on the loan application
     * @param {RequestLoanManagement} requestLoanManagement 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApi
     */
    public manageLoan(requestLoanManagement: RequestLoanManagement, options?: any) {
        return IntegrationApiFp(this.configuration).manageLoan(requestLoanManagement, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Originate and manage loan application with borrower as legal entity
     * @param {Array} balanceSheet List of Balance sheet files
     * @param {Array} idDocument List of files of the document identifying the representative of the legal entity
     * @param {Array} pnlStatement List of Profit and loss statement files
     * @param {RequestLegalEntityLoanOrigination} request 
     * @param {string} [callbackUrl] URL for sending a callback with a processed loan application. Callback will not performed if the parameter not provided
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApi
     */
    public originateAndManageLoanLegalEntity(balanceSheet: Array, idDocument: Array, pnlStatement: Array, request: RequestLegalEntityLoanOrigination, callbackUrl?: string, options?: any) {
        return IntegrationApiFp(this.configuration).originateAndManageLoanLegalEntity(balanceSheet, idDocument, pnlStatement, request, callbackUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Originate and manage loan application with borrower as person
     * @param {Array} idDocument List of the identification document\\\&#39;s files
     * @param {RequestPersonLoanOrigination} request 
     * @param {string} [callbackUrl] URL for sending a callback with a processed loan application. Callback will not performed if the parameter not provided
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApi
     */
    public originateAndManageLoanPerson(idDocument: Array, request: RequestPersonLoanOrigination, callbackUrl?: string, options?: any) {
        return IntegrationApiFp(this.configuration).originateAndManageLoanPerson(idDocument, request, callbackUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Originate loan application with borrower as legal entity
     * @param {Array} balanceSheet List of Balance sheet files
     * @param {string} callbackUrl URL for sending a callback with a processed loan application
     * @param {Array} idDocument List of files of the document identifying the representative of the legal entity
     * @param {Array} pnlStatement List of Profit and loss statement files
     * @param {RequestLegalEntityLoanOrigination} request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApi
     */
    public originateLoanLegalEntity(balanceSheet: Array, callbackUrl: string, idDocument: Array, pnlStatement: Array, request: RequestLegalEntityLoanOrigination, options?: any) {
        return IntegrationApiFp(this.configuration).originateLoanLegalEntity(balanceSheet, callbackUrl, idDocument, pnlStatement, request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Originate loan application with borrower as person
     * @param {string} callbackUrl URL for sending a callback with a processed loan application
     * @param {Array} idDocument List of the identification document\\\&#39;s files
     * @param {RequestPersonLoanOrigination} request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApi
     */
    public originateLoanPerson(callbackUrl: string, idDocument: Array, request: RequestPersonLoanOrigination, options?: any) {
        return IntegrationApiFp(this.configuration).originateLoanPerson(callbackUrl, idDocument, request, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * InterestRateSettingsApi - axios parameter creator
 * @export
 */
export const InterestRateSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return actual interest rate settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActualInterestRateSetting: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/interest-rate/actual`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return latest interest rate settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestInterestRateSetting: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/interest-rate/latest`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InterestRateSettingsApi - functional programming interface
 * @export
 */
export const InterestRateSettingsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return actual interest rate settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActualInterestRateSetting(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterestRateSettingsResponse>> {
            const localVarAxiosArgs = await InterestRateSettingsApiAxiosParamCreator(configuration).getActualInterestRateSetting(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return latest interest rate settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestInterestRateSetting(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterestRateSettingsResponse>> {
            const localVarAxiosArgs = await InterestRateSettingsApiAxiosParamCreator(configuration).getLatestInterestRateSetting(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * InterestRateSettingsApi - factory interface
 * @export
 */
export const InterestRateSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Return actual interest rate settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActualInterestRateSetting(options?: any): AxiosPromise<InterestRateSettingsResponse> {
            return InterestRateSettingsApiFp(configuration).getActualInterestRateSetting(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return latest interest rate settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestInterestRateSetting(options?: any): AxiosPromise<InterestRateSettingsResponse> {
            return InterestRateSettingsApiFp(configuration).getLatestInterestRateSetting(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InterestRateSettingsApi - object-oriented interface
 * @export
 * @class InterestRateSettingsApi
 * @extends {BaseAPI}
 */
export class InterestRateSettingsApi extends BaseAPI {
    /**
     * 
     * @summary Return actual interest rate settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterestRateSettingsApi
     */
    public getActualInterestRateSetting(options?: any) {
        return InterestRateSettingsApiFp(this.configuration).getActualInterestRateSetting(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return latest interest rate settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterestRateSettingsApi
     */
    public getLatestInterestRateSetting(options?: any) {
        return InterestRateSettingsApiFp(this.configuration).getLatestInterestRateSetting(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * LandingPageSettingsApi - axios parameter creator
 * @export
 */
export const LandingPageSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return landing page settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLandingPageSettings: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/landing-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update landing page settings
         * @param {LandingPageSettingsRequest} landingPageSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLandingPageSettings: async (landingPageSettingsRequest: LandingPageSettingsRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'landingPageSettingsRequest' is not null or undefined
            if (landingPageSettingsRequest === null || landingPageSettingsRequest === undefined) {
                throw new RequiredError('landingPageSettingsRequest','Required parameter landingPageSettingsRequest was null or undefined when calling updateLandingPageSettings.');
            }
            const localVarPath = `/api/settings/landing-page`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof landingPageSettingsRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(landingPageSettingsRequest !== undefined ? landingPageSettingsRequest : {}) : (landingPageSettingsRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LandingPageSettingsApi - functional programming interface
 * @export
 */
export const LandingPageSettingsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return landing page settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLandingPageSettings(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LandingPageSettingsResponse>> {
            const localVarAxiosArgs = await LandingPageSettingsApiAxiosParamCreator(configuration).getLandingPageSettings(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update landing page settings
         * @param {LandingPageSettingsRequest} landingPageSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLandingPageSettings(landingPageSettingsRequest: LandingPageSettingsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LandingPageSettingsResponse>> {
            const localVarAxiosArgs = await LandingPageSettingsApiAxiosParamCreator(configuration).updateLandingPageSettings(landingPageSettingsRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LandingPageSettingsApi - factory interface
 * @export
 */
export const LandingPageSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Return landing page settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLandingPageSettings(options?: any): AxiosPromise<LandingPageSettingsResponse> {
            return LandingPageSettingsApiFp(configuration).getLandingPageSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update landing page settings
         * @param {LandingPageSettingsRequest} landingPageSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLandingPageSettings(landingPageSettingsRequest: LandingPageSettingsRequest, options?: any): AxiosPromise<LandingPageSettingsResponse> {
            return LandingPageSettingsApiFp(configuration).updateLandingPageSettings(landingPageSettingsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LandingPageSettingsApi - object-oriented interface
 * @export
 * @class LandingPageSettingsApi
 * @extends {BaseAPI}
 */
export class LandingPageSettingsApi extends BaseAPI {
    /**
     * 
     * @summary Return landing page settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandingPageSettingsApi
     */
    public getLandingPageSettings(options?: any) {
        return LandingPageSettingsApiFp(this.configuration).getLandingPageSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update landing page settings
     * @param {LandingPageSettingsRequest} landingPageSettingsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandingPageSettingsApi
     */
    public updateLandingPageSettings(landingPageSettingsRequest: LandingPageSettingsRequest, options?: any) {
        return LandingPageSettingsApiFp(this.configuration).updateLandingPageSettings(landingPageSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * LandingRequestsApi - axios parameter creator
 * @export
 */
export const LandingRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Calculate loan preconditions for landing calculator
         * @param {number} amount 
         * @param {number} term 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateLoanPreconditions: async (amount: number, term: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'amount' is not null or undefined
            if (amount === null || amount === undefined) {
                throw new RequiredError('amount','Required parameter amount was null or undefined when calling calculateLoanPreconditions.');
            }
            // verify required parameter 'term' is not null or undefined
            if (term === null || term === undefined) {
                throw new RequiredError('term','Required parameter term was null or undefined when calling calculateLoanPreconditions.');
            }
            const localVarPath = `/api/landing/calculate`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return landing calculator settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLandingCalculatorSettings: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/landing/calculator`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LandingRequestsApi - functional programming interface
 * @export
 */
export const LandingRequestsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Calculate loan preconditions for landing calculator
         * @param {number} amount 
         * @param {number} term 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateLoanPreconditions(amount: number, term: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanPreconditionsResponse>> {
            const localVarAxiosArgs = await LandingRequestsApiAxiosParamCreator(configuration).calculateLoanPreconditions(amount, term, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return landing calculator settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLandingCalculatorSettings(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LandingCalculatorSettingsResponse>> {
            const localVarAxiosArgs = await LandingRequestsApiAxiosParamCreator(configuration).getLandingCalculatorSettings(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LandingRequestsApi - factory interface
 * @export
 */
export const LandingRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Calculate loan preconditions for landing calculator
         * @param {number} amount 
         * @param {number} term 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateLoanPreconditions(amount: number, term: number, options?: any): AxiosPromise<LoanPreconditionsResponse> {
            return LandingRequestsApiFp(configuration).calculateLoanPreconditions(amount, term, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return landing calculator settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLandingCalculatorSettings(options?: any): AxiosPromise<LandingCalculatorSettingsResponse> {
            return LandingRequestsApiFp(configuration).getLandingCalculatorSettings(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LandingRequestsApi - object-oriented interface
 * @export
 * @class LandingRequestsApi
 * @extends {BaseAPI}
 */
export class LandingRequestsApi extends BaseAPI {
    /**
     * 
     * @summary Calculate loan preconditions for landing calculator
     * @param {number} amount 
     * @param {number} term 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandingRequestsApi
     */
    public calculateLoanPreconditions(amount: number, term: number, options?: any) {
        return LandingRequestsApiFp(this.configuration).calculateLoanPreconditions(amount, term, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return landing calculator settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandingRequestsApi
     */
    public getLandingCalculatorSettings(options?: any) {
        return LandingRequestsApiFp(this.configuration).getLandingCalculatorSettings(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * LeadApi - axios parameter creator
 * @export
 */
export const LeadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create lead
         * @param {CreateLeadRequest} createLeadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLead: async (createLeadRequest: CreateLeadRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLeadRequest' is not null or undefined
            if (createLeadRequest === null || createLeadRequest === undefined) {
                throw new RequiredError('createLeadRequest','Required parameter createLeadRequest was null or undefined when calling createLead.');
            }
            const localVarPath = `/api/leads`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof createLeadRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createLeadRequest !== undefined ? createLeadRequest : {}) : (createLeadRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of leads
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [filterSearch] Search by lead\&#39;s fullName, phone, email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllLeads: async (page?: number, size?: number, sort?: Array<string>, filterSearch?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/leads`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return single lead
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLead: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getLead.');
            }
            const localVarPath = `/api/leads/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update lead
         * @param {number} id 
         * @param {UpdateLeadRequest} updateLeadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLead: async (id: number, updateLeadRequest: UpdateLeadRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateLead.');
            }
            // verify required parameter 'updateLeadRequest' is not null or undefined
            if (updateLeadRequest === null || updateLeadRequest === undefined) {
                throw new RequiredError('updateLeadRequest','Required parameter updateLeadRequest was null or undefined when calling updateLead.');
            }
            const localVarPath = `/api/leads/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateLeadRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateLeadRequest !== undefined ? updateLeadRequest : {}) : (updateLeadRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LeadApi - functional programming interface
 * @export
 */
export const LeadApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create lead
         * @param {CreateLeadRequest} createLeadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLead(createLeadRequest: CreateLeadRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeadDto>> {
            const localVarAxiosArgs = await LeadApiAxiosParamCreator(configuration).createLead(createLeadRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return list of leads
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [filterSearch] Search by lead\&#39;s fullName, phone, email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllLeads(page?: number, size?: number, sort?: Array<string>, filterSearch?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLeadDtoBrief>> {
            const localVarAxiosArgs = await LeadApiAxiosParamCreator(configuration).findAllLeads(page, size, sort, filterSearch, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return single lead
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLead(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeadDto>> {
            const localVarAxiosArgs = await LeadApiAxiosParamCreator(configuration).getLead(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update lead
         * @param {number} id 
         * @param {UpdateLeadRequest} updateLeadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLead(id: number, updateLeadRequest: UpdateLeadRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeadDto>> {
            const localVarAxiosArgs = await LeadApiAxiosParamCreator(configuration).updateLead(id, updateLeadRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LeadApi - factory interface
 * @export
 */
export const LeadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Create lead
         * @param {CreateLeadRequest} createLeadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLead(createLeadRequest: CreateLeadRequest, options?: any): AxiosPromise<LeadDto> {
            return LeadApiFp(configuration).createLead(createLeadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of leads
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [filterSearch] Search by lead\&#39;s fullName, phone, email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllLeads(page?: number, size?: number, sort?: Array<string>, filterSearch?: string, options?: any): AxiosPromise<PageLeadDtoBrief> {
            return LeadApiFp(configuration).findAllLeads(page, size, sort, filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return single lead
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLead(id: number, options?: any): AxiosPromise<LeadDto> {
            return LeadApiFp(configuration).getLead(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update lead
         * @param {number} id 
         * @param {UpdateLeadRequest} updateLeadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLead(id: number, updateLeadRequest: UpdateLeadRequest, options?: any): AxiosPromise<LeadDto> {
            return LeadApiFp(configuration).updateLead(id, updateLeadRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LeadApi - object-oriented interface
 * @export
 * @class LeadApi
 * @extends {BaseAPI}
 */
export class LeadApi extends BaseAPI {
    /**
     * 
     * @summary Create lead
     * @param {CreateLeadRequest} createLeadRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadApi
     */
    public createLead(createLeadRequest: CreateLeadRequest, options?: any) {
        return LeadApiFp(this.configuration).createLead(createLeadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of leads
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {string} [filterSearch] Search by lead\&#39;s fullName, phone, email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadApi
     */
    public findAllLeads(page?: number, size?: number, sort?: Array<string>, filterSearch?: string, options?: any) {
        return LeadApiFp(this.configuration).findAllLeads(page, size, sort, filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return single lead
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadApi
     */
    public getLead(id: number, options?: any) {
        return LeadApiFp(this.configuration).getLead(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update lead
     * @param {number} id 
     * @param {UpdateLeadRequest} updateLeadRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadApi
     */
    public updateLead(id: number, updateLeadRequest: UpdateLeadRequest, options?: any) {
        return LeadApiFp(this.configuration).updateLead(id, updateLeadRequest, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * LicenseApi - axios parameter creator
 * @export
 */
export const LicenseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Activate license
         * @param {LicenseActivationRequest} licenseActivationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateLicense: async (licenseActivationRequest: LicenseActivationRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'licenseActivationRequest' is not null or undefined
            if (licenseActivationRequest === null || licenseActivationRequest === undefined) {
                throw new RequiredError('licenseActivationRequest','Required parameter licenseActivationRequest was null or undefined when calling activateLicense.');
            }
            const localVarPath = `/api/license`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof licenseActivationRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(licenseActivationRequest !== undefined ? licenseActivationRequest : {}) : (licenseActivationRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return license info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLicenseInfo: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/license`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LicenseApi - functional programming interface
 * @export
 */
export const LicenseApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Activate license
         * @param {LicenseActivationRequest} licenseActivationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateLicense(licenseActivationRequest: LicenseActivationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LicenseResponse>> {
            const localVarAxiosArgs = await LicenseApiAxiosParamCreator(configuration).activateLicense(licenseActivationRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return license info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLicenseInfo(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LicenseResponse>> {
            const localVarAxiosArgs = await LicenseApiAxiosParamCreator(configuration).getLicenseInfo(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LicenseApi - factory interface
 * @export
 */
export const LicenseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Activate license
         * @param {LicenseActivationRequest} licenseActivationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateLicense(licenseActivationRequest: LicenseActivationRequest, options?: any): AxiosPromise<LicenseResponse> {
            return LicenseApiFp(configuration).activateLicense(licenseActivationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return license info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLicenseInfo(options?: any): AxiosPromise<LicenseResponse> {
            return LicenseApiFp(configuration).getLicenseInfo(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LicenseApi - object-oriented interface
 * @export
 * @class LicenseApi
 * @extends {BaseAPI}
 */
export class LicenseApi extends BaseAPI {
    /**
     * 
     * @summary Activate license
     * @param {LicenseActivationRequest} licenseActivationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicenseApi
     */
    public activateLicense(licenseActivationRequest: LicenseActivationRequest, options?: any) {
        return LicenseApiFp(this.configuration).activateLicense(licenseActivationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return license info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicenseApi
     */
    public getLicenseInfo(options?: any) {
        return LicenseApiFp(this.configuration).getLicenseInfo(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * LoanApi - axios parameter creator
 * @export
 */
export const LoanApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of agent\'s loans
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByAgentId: async (id: number, page?: number, size?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling findAllByAgentId.');
            }
            const localVarPath = `/api/loans/agent/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of borrower\'s loans
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByBorrowerId: async (id: number, page?: number, size?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling findAllByBorrowerId.');
            }
            const localVarPath = `/api/loans/borrower/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of loans
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by loan statuses
         * @param {string} [filterIssueDateFrom] Search by loan issue date from
         * @param {string} [filterIssueDateTo] Search by loan issue date to
         * @param {string} [filterSearch] Search by loan number; borrower\&#39;s full name, phone, email; loan product code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllLoans: async (page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterIssueDateFrom?: string, filterIssueDateTo?: string, filterSearch?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/loans`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterStatuses) {
                localVarQueryParameter['filter.statuses'] = filterStatuses;
            }

            if (filterIssueDateFrom !== undefined) {
                localVarQueryParameter['filter.issueDateFrom'] = filterIssueDateFrom;
            }

            if (filterIssueDateTo !== undefined) {
                localVarQueryParameter['filter.issueDateTo'] = filterIssueDateTo;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of loan\'s operations
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllOperationsByLoanId: async (id: number, page?: number, size?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling findAllOperationsByLoanId.');
            }
            const localVarPath = `/api/loans/{id}/operations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of loan\'s operations
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOperationById: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling findOperationById.');
            }
            const localVarPath = `/api/loans/loan/operations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return single loan
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoan: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getLoan.');
            }
            const localVarPath = `/api/loans/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanApi - functional programming interface
 * @export
 */
export const LoanApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of agent\'s loans
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllByAgentId(id: number, page?: number, size?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanDtoBrief>> {
            const localVarAxiosArgs = await LoanApiAxiosParamCreator(configuration).findAllByAgentId(id, page, size, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return list of borrower\'s loans
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllByBorrowerId(id: number, page?: number, size?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanDtoBrief>> {
            const localVarAxiosArgs = await LoanApiAxiosParamCreator(configuration).findAllByBorrowerId(id, page, size, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return list of loans
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by loan statuses
         * @param {string} [filterIssueDateFrom] Search by loan issue date from
         * @param {string} [filterIssueDateTo] Search by loan issue date to
         * @param {string} [filterSearch] Search by loan number; borrower\&#39;s full name, phone, email; loan product code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllLoans(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterIssueDateFrom?: string, filterIssueDateTo?: string, filterSearch?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanDtoBrief>> {
            const localVarAxiosArgs = await LoanApiAxiosParamCreator(configuration).findAllLoans(page, size, sort, filterStatuses, filterIssueDateFrom, filterIssueDateTo, filterSearch, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return list of loan\'s operations
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllOperationsByLoanId(id: number, page?: number, size?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanOperationDto>> {
            const localVarAxiosArgs = await LoanApiAxiosParamCreator(configuration).findAllOperationsByLoanId(id, page, size, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return list of loan\'s operations
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOperationById(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanOperationDto>> {
            const localVarAxiosArgs = await LoanApiAxiosParamCreator(configuration).findOperationById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return single loan
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoan(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanDto>> {
            const localVarAxiosArgs = await LoanApiAxiosParamCreator(configuration).getLoan(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LoanApi - factory interface
 * @export
 */
export const LoanApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Return list of agent\'s loans
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByAgentId(id: number, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PageLoanDtoBrief> {
            return LoanApiFp(configuration).findAllByAgentId(id, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of borrower\'s loans
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByBorrowerId(id: number, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PageLoanDtoBrief> {
            return LoanApiFp(configuration).findAllByBorrowerId(id, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of loans
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by loan statuses
         * @param {string} [filterIssueDateFrom] Search by loan issue date from
         * @param {string} [filterIssueDateTo] Search by loan issue date to
         * @param {string} [filterSearch] Search by loan number; borrower\&#39;s full name, phone, email; loan product code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllLoans(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterIssueDateFrom?: string, filterIssueDateTo?: string, filterSearch?: string, options?: any): AxiosPromise<PageLoanDtoBrief> {
            return LoanApiFp(configuration).findAllLoans(page, size, sort, filterStatuses, filterIssueDateFrom, filterIssueDateTo, filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of loan\'s operations
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllOperationsByLoanId(id: number, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PageLoanOperationDto> {
            return LoanApiFp(configuration).findAllOperationsByLoanId(id, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of loan\'s operations
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOperationById(id: number, options?: any): AxiosPromise<LoanOperationDto> {
            return LoanApiFp(configuration).findOperationById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return single loan
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoan(id: number, options?: any): AxiosPromise<LoanDto> {
            return LoanApiFp(configuration).getLoan(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoanApi - object-oriented interface
 * @export
 * @class LoanApi
 * @extends {BaseAPI}
 */
export class LoanApi extends BaseAPI {
    /**
     * 
     * @summary Return list of agent\'s loans
     * @param {number} id 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApi
     */
    public findAllByAgentId(id: number, page?: number, size?: number, sort?: Array<string>, options?: any) {
        return LoanApiFp(this.configuration).findAllByAgentId(id, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of borrower\'s loans
     * @param {number} id 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApi
     */
    public findAllByBorrowerId(id: number, page?: number, size?: number, sort?: Array<string>, options?: any) {
        return LoanApiFp(this.configuration).findAllByBorrowerId(id, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of loans
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {Array<string>} [filterStatuses] Search by loan statuses
     * @param {string} [filterIssueDateFrom] Search by loan issue date from
     * @param {string} [filterIssueDateTo] Search by loan issue date to
     * @param {string} [filterSearch] Search by loan number; borrower\&#39;s full name, phone, email; loan product code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApi
     */
    public findAllLoans(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterIssueDateFrom?: string, filterIssueDateTo?: string, filterSearch?: string, options?: any) {
        return LoanApiFp(this.configuration).findAllLoans(page, size, sort, filterStatuses, filterIssueDateFrom, filterIssueDateTo, filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of loan\'s operations
     * @param {number} id 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApi
     */
    public findAllOperationsByLoanId(id: number, page?: number, size?: number, sort?: Array<string>, options?: any) {
        return LoanApiFp(this.configuration).findAllOperationsByLoanId(id, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of loan\'s operations
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApi
     */
    public findOperationById(id: number, options?: any) {
        return LoanApiFp(this.configuration).findOperationById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return single loan
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApi
     */
    public getLoan(id: number, options?: any) {
        return LoanApiFp(this.configuration).getLoan(id, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * LoanAdjustmentsApi - axios parameter creator
 * @export
 */
export const LoanAdjustmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of loan\'s agreements
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAgreementsByLoanId: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling findAllAgreementsByLoanId.');
            }
            const localVarPath = `/api/loan-adjustments/loan/{id}/agreements`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanAdjustmentsApi - functional programming interface
 * @export
 */
export const LoanAdjustmentsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of loan\'s agreements
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllAgreementsByLoanId(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LoanAgreementDto>>> {
            const localVarAxiosArgs = await LoanAdjustmentsApiAxiosParamCreator(configuration).findAllAgreementsByLoanId(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LoanAdjustmentsApi - factory interface
 * @export
 */
export const LoanAdjustmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Return list of loan\'s agreements
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAgreementsByLoanId(id: number, options?: any): AxiosPromise<Array<LoanAgreementDto>> {
            return LoanAdjustmentsApiFp(configuration).findAllAgreementsByLoanId(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoanAdjustmentsApi - object-oriented interface
 * @export
 * @class LoanAdjustmentsApi
 * @extends {BaseAPI}
 */
export class LoanAdjustmentsApi extends BaseAPI {
    /**
     * 
     * @summary Return list of loan\'s agreements
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanAdjustmentsApi
     */
    public findAllAgreementsByLoanId(id: number, options?: any) {
        return LoanAdjustmentsApiFp(this.configuration).findAllAgreementsByLoanId(id, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * LoanApplicationApi - axios parameter creator
 * @export
 */
export const LoanApplicationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of loan applications
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by loan application statuses
         * @param {string} [filterRequestedAtFrom] Search by loan application requested at (by a borrower) from
         * @param {string} [filterRequestedAtTo] Search by loan application requested at (by a borrower) to
         * @param {string} [filterSearch] Search by loan application number; borrower\&#39;s full name, phone, email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllApplications: async (page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterRequestedAtFrom?: string, filterRequestedAtTo?: string, filterSearch?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/loan-applications`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterStatuses) {
                localVarQueryParameter['filter.statuses'] = filterStatuses;
            }

            if (filterRequestedAtFrom !== undefined) {
                localVarQueryParameter['filter.requestedAtFrom'] = filterRequestedAtFrom;
            }

            if (filterRequestedAtTo !== undefined) {
                localVarQueryParameter['filter.requestedAtTo'] = filterRequestedAtTo;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of agent\'s loan applications
         * @param {number} id Agent id
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByAgentId1: async (id: number, page?: number, size?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling findAllByAgentId1.');
            }
            const localVarPath = `/api/loan-applications/agent/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of borrower\'s loan applications
         * @param {number} id Borrower id
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByBorrowerId1: async (id: number, page?: number, size?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling findAllByBorrowerId1.');
            }
            const localVarPath = `/api/loan-applications/borrower/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return single loan application
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplication: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getApplication.');
            }
            const localVarPath = `/api/loan-applications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return audit trail for the loan application
         * @param {string} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditTrail: async (id: string, page?: number, size?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getAuditTrail.');
            }
            const localVarPath = `/api/loan-applications/{id}/audit-trail`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanApplicationApi - functional programming interface
 * @export
 */
export const LoanApplicationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of loan applications
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by loan application statuses
         * @param {string} [filterRequestedAtFrom] Search by loan application requested at (by a borrower) from
         * @param {string} [filterRequestedAtTo] Search by loan application requested at (by a borrower) to
         * @param {string} [filterSearch] Search by loan application number; borrower\&#39;s full name, phone, email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllApplications(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterRequestedAtFrom?: string, filterRequestedAtTo?: string, filterSearch?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanApplicationDtoBrief>> {
            const localVarAxiosArgs = await LoanApplicationApiAxiosParamCreator(configuration).findAllApplications(page, size, sort, filterStatuses, filterRequestedAtFrom, filterRequestedAtTo, filterSearch, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return list of agent\'s loan applications
         * @param {number} id Agent id
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllByAgentId1(id: number, page?: number, size?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanApplicationDtoBrief>> {
            const localVarAxiosArgs = await LoanApplicationApiAxiosParamCreator(configuration).findAllByAgentId1(id, page, size, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return list of borrower\'s loan applications
         * @param {number} id Borrower id
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllByBorrowerId1(id: number, page?: number, size?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanApplicationDtoBrief>> {
            const localVarAxiosArgs = await LoanApplicationApiAxiosParamCreator(configuration).findAllByBorrowerId1(id, page, size, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return single loan application
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApplication(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanApplicationDto>> {
            const localVarAxiosArgs = await LoanApplicationApiAxiosParamCreator(configuration).getApplication(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return audit trail for the loan application
         * @param {string} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuditTrail(id: string, page?: number, size?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageActivityAuditTrailDto>> {
            const localVarAxiosArgs = await LoanApplicationApiAxiosParamCreator(configuration).getAuditTrail(id, page, size, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LoanApplicationApi - factory interface
 * @export
 */
export const LoanApplicationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Return list of loan applications
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Search by loan application statuses
         * @param {string} [filterRequestedAtFrom] Search by loan application requested at (by a borrower) from
         * @param {string} [filterRequestedAtTo] Search by loan application requested at (by a borrower) to
         * @param {string} [filterSearch] Search by loan application number; borrower\&#39;s full name, phone, email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllApplications(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterRequestedAtFrom?: string, filterRequestedAtTo?: string, filterSearch?: string, options?: any): AxiosPromise<PageLoanApplicationDtoBrief> {
            return LoanApplicationApiFp(configuration).findAllApplications(page, size, sort, filterStatuses, filterRequestedAtFrom, filterRequestedAtTo, filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of agent\'s loan applications
         * @param {number} id Agent id
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByAgentId1(id: number, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PageLoanApplicationDtoBrief> {
            return LoanApplicationApiFp(configuration).findAllByAgentId1(id, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of borrower\'s loan applications
         * @param {number} id Borrower id
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByBorrowerId1(id: number, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PageLoanApplicationDtoBrief> {
            return LoanApplicationApiFp(configuration).findAllByBorrowerId1(id, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return single loan application
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplication(id: number, options?: any): AxiosPromise<LoanApplicationDto> {
            return LoanApplicationApiFp(configuration).getApplication(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return audit trail for the loan application
         * @param {string} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditTrail(id: string, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PageActivityAuditTrailDto> {
            return LoanApplicationApiFp(configuration).getAuditTrail(id, page, size, sort, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoanApplicationApi - object-oriented interface
 * @export
 * @class LoanApplicationApi
 * @extends {BaseAPI}
 */
export class LoanApplicationApi extends BaseAPI {
    /**
     * 
     * @summary Return list of loan applications
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {Array<string>} [filterStatuses] Search by loan application statuses
     * @param {string} [filterRequestedAtFrom] Search by loan application requested at (by a borrower) from
     * @param {string} [filterRequestedAtTo] Search by loan application requested at (by a borrower) to
     * @param {string} [filterSearch] Search by loan application number; borrower\&#39;s full name, phone, email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApplicationApi
     */
    public findAllApplications(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterRequestedAtFrom?: string, filterRequestedAtTo?: string, filterSearch?: string, options?: any) {
        return LoanApplicationApiFp(this.configuration).findAllApplications(page, size, sort, filterStatuses, filterRequestedAtFrom, filterRequestedAtTo, filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of agent\'s loan applications
     * @param {number} id Agent id
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApplicationApi
     */
    public findAllByAgentId1(id: number, page?: number, size?: number, sort?: Array<string>, options?: any) {
        return LoanApplicationApiFp(this.configuration).findAllByAgentId1(id, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of borrower\'s loan applications
     * @param {number} id Borrower id
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApplicationApi
     */
    public findAllByBorrowerId1(id: number, page?: number, size?: number, sort?: Array<string>, options?: any) {
        return LoanApplicationApiFp(this.configuration).findAllByBorrowerId1(id, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return single loan application
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApplicationApi
     */
    public getApplication(id: number, options?: any) {
        return LoanApplicationApiFp(this.configuration).getApplication(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return audit trail for the loan application
     * @param {string} id 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApplicationApi
     */
    public getAuditTrail(id: string, page?: number, size?: number, sort?: Array<string>, options?: any) {
        return LoanApplicationApiFp(this.configuration).getAuditTrail(id, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * LoanProductApi - axios parameter creator
 * @export
 */
export const LoanProductApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create loan product
         * @param {CreateLoanProductRequest} createLoanProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct: async (createLoanProductRequest: CreateLoanProductRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLoanProductRequest' is not null or undefined
            if (createLoanProductRequest === null || createLoanProductRequest === undefined) {
                throw new RequiredError('createLoanProductRequest','Required parameter createLoanProductRequest was null or undefined when calling createProduct.');
            }
            const localVarPath = `/api/loan-products`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof createLoanProductRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createLoanProductRequest !== undefined ? createLoanProductRequest : {}) : (createLoanProductRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of campaign\'s loan products
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByCampaignId: async (id: number, page?: number, size?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling findAllByCampaignId.');
            }
            const localVarPath = `/api/loan-products/campaign/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of loan products
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [filterAmount] Search by loan product amount
         * @param {number} [filterTerm] Search by loan product term
         * @param {boolean} [filterActive] Search by loan product active flag
         * @param {string} [filterCampaignId] Search by loan product group id
         * @param {number} [filterInterestRate] 
         * @param {string} [filterSearch] Search by loan product code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllProducts: async (page?: number, size?: number, sort?: Array<string>, filterAmount?: number, filterTerm?: number, filterActive?: boolean, filterCampaignId?: string, filterInterestRate?: number, filterSearch?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/loan-products`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterAmount !== undefined) {
                localVarQueryParameter['filter.amount'] = filterAmount;
            }

            if (filterTerm !== undefined) {
                localVarQueryParameter['filter.term'] = filterTerm;
            }

            if (filterActive !== undefined) {
                localVarQueryParameter['filter.active'] = filterActive;
            }

            if (filterCampaignId !== undefined) {
                localVarQueryParameter['filter.campaignId'] = filterCampaignId;
            }

            if (filterInterestRate !== undefined) {
                localVarQueryParameter['filter.interestRate'] = filterInterestRate;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return loan product\'s history
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistory: async (id: number, page?: number, size?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getHistory.');
            }
            const localVarPath = `/api/loan-products/{id}/history`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return single loan product
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getProduct.');
            }
            const localVarPath = `/api/loan-products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update loan product
         * @param {number} id 
         * @param {UpdateLoanProductRequest} updateLoanProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct: async (id: number, updateLoanProductRequest: UpdateLoanProductRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateProduct.');
            }
            // verify required parameter 'updateLoanProductRequest' is not null or undefined
            if (updateLoanProductRequest === null || updateLoanProductRequest === undefined) {
                throw new RequiredError('updateLoanProductRequest','Required parameter updateLoanProductRequest was null or undefined when calling updateProduct.');
            }
            const localVarPath = `/api/loan-products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateLoanProductRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateLoanProductRequest !== undefined ? updateLoanProductRequest : {}) : (updateLoanProductRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanProductApi - functional programming interface
 * @export
 */
export const LoanProductApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create loan product
         * @param {CreateLoanProductRequest} createLoanProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProduct(createLoanProductRequest: CreateLoanProductRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanProductDto>> {
            const localVarAxiosArgs = await LoanProductApiAxiosParamCreator(configuration).createProduct(createLoanProductRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return list of campaign\'s loan products
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllByCampaignId(id: number, page?: number, size?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanProductDto>> {
            const localVarAxiosArgs = await LoanProductApiAxiosParamCreator(configuration).findAllByCampaignId(id, page, size, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return list of loan products
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [filterAmount] Search by loan product amount
         * @param {number} [filterTerm] Search by loan product term
         * @param {boolean} [filterActive] Search by loan product active flag
         * @param {string} [filterCampaignId] Search by loan product group id
         * @param {number} [filterInterestRate] 
         * @param {string} [filterSearch] Search by loan product code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllProducts(page?: number, size?: number, sort?: Array<string>, filterAmount?: number, filterTerm?: number, filterActive?: boolean, filterCampaignId?: string, filterInterestRate?: number, filterSearch?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanProductDto>> {
            const localVarAxiosArgs = await LoanProductApiAxiosParamCreator(configuration).findAllProducts(page, size, sort, filterAmount, filterTerm, filterActive, filterCampaignId, filterInterestRate, filterSearch, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return loan product\'s history
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHistory(id: number, page?: number, size?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanProductRevisionDto>> {
            const localVarAxiosArgs = await LoanProductApiAxiosParamCreator(configuration).getHistory(id, page, size, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return single loan product
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProduct(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanProductDto>> {
            const localVarAxiosArgs = await LoanProductApiAxiosParamCreator(configuration).getProduct(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update loan product
         * @param {number} id 
         * @param {UpdateLoanProductRequest} updateLoanProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProduct(id: number, updateLoanProductRequest: UpdateLoanProductRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanProductDto>> {
            const localVarAxiosArgs = await LoanProductApiAxiosParamCreator(configuration).updateProduct(id, updateLoanProductRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LoanProductApi - factory interface
 * @export
 */
export const LoanProductApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Create loan product
         * @param {CreateLoanProductRequest} createLoanProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct(createLoanProductRequest: CreateLoanProductRequest, options?: any): AxiosPromise<LoanProductDto> {
            return LoanProductApiFp(configuration).createProduct(createLoanProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of campaign\'s loan products
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByCampaignId(id: number, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PageLoanProductDto> {
            return LoanProductApiFp(configuration).findAllByCampaignId(id, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of loan products
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [filterAmount] Search by loan product amount
         * @param {number} [filterTerm] Search by loan product term
         * @param {boolean} [filterActive] Search by loan product active flag
         * @param {string} [filterCampaignId] Search by loan product group id
         * @param {number} [filterInterestRate] 
         * @param {string} [filterSearch] Search by loan product code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllProducts(page?: number, size?: number, sort?: Array<string>, filterAmount?: number, filterTerm?: number, filterActive?: boolean, filterCampaignId?: string, filterInterestRate?: number, filterSearch?: string, options?: any): AxiosPromise<PageLoanProductDto> {
            return LoanProductApiFp(configuration).findAllProducts(page, size, sort, filterAmount, filterTerm, filterActive, filterCampaignId, filterInterestRate, filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return loan product\'s history
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistory(id: number, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PageLoanProductRevisionDto> {
            return LoanProductApiFp(configuration).getHistory(id, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return single loan product
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct(id: number, options?: any): AxiosPromise<LoanProductDto> {
            return LoanProductApiFp(configuration).getProduct(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update loan product
         * @param {number} id 
         * @param {UpdateLoanProductRequest} updateLoanProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct(id: number, updateLoanProductRequest: UpdateLoanProductRequest, options?: any): AxiosPromise<LoanProductDto> {
            return LoanProductApiFp(configuration).updateProduct(id, updateLoanProductRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoanProductApi - object-oriented interface
 * @export
 * @class LoanProductApi
 * @extends {BaseAPI}
 */
export class LoanProductApi extends BaseAPI {
    /**
     * 
     * @summary Create loan product
     * @param {CreateLoanProductRequest} createLoanProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanProductApi
     */
    public createProduct(createLoanProductRequest: CreateLoanProductRequest, options?: any) {
        return LoanProductApiFp(this.configuration).createProduct(createLoanProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of campaign\'s loan products
     * @param {number} id 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanProductApi
     */
    public findAllByCampaignId(id: number, page?: number, size?: number, sort?: Array<string>, options?: any) {
        return LoanProductApiFp(this.configuration).findAllByCampaignId(id, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of loan products
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [filterAmount] Search by loan product amount
     * @param {number} [filterTerm] Search by loan product term
     * @param {boolean} [filterActive] Search by loan product active flag
     * @param {string} [filterCampaignId] Search by loan product group id
     * @param {number} [filterInterestRate] 
     * @param {string} [filterSearch] Search by loan product code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanProductApi
     */
    public findAllProducts(page?: number, size?: number, sort?: Array<string>, filterAmount?: number, filterTerm?: number, filterActive?: boolean, filterCampaignId?: string, filterInterestRate?: number, filterSearch?: string, options?: any) {
        return LoanProductApiFp(this.configuration).findAllProducts(page, size, sort, filterAmount, filterTerm, filterActive, filterCampaignId, filterInterestRate, filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return loan product\'s history
     * @param {number} id 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanProductApi
     */
    public getHistory(id: number, page?: number, size?: number, sort?: Array<string>, options?: any) {
        return LoanProductApiFp(this.configuration).getHistory(id, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return single loan product
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanProductApi
     */
    public getProduct(id: number, options?: any) {
        return LoanProductApiFp(this.configuration).getProduct(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update loan product
     * @param {number} id 
     * @param {UpdateLoanProductRequest} updateLoanProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanProductApi
     */
    public updateProduct(id: number, updateLoanProductRequest: UpdateLoanProductRequest, options?: any) {
        return LoanProductApiFp(this.configuration).updateProduct(id, updateLoanProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * MetabaseApi - axios parameter creator
 * @export
 */
export const MetabaseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboards: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/metabase/dashboards`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmbedDashboard: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getEmbedDashboard.');
            }
            const localVarPath = `/api/metabase/dashboard/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetabaseApi - functional programming interface
 * @export
 */
export const MetabaseApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboards(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardsResponse>> {
            const localVarAxiosArgs = await MetabaseApiAxiosParamCreator(configuration).getDashboards(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmbedDashboard(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmbedDashboardResponse>> {
            const localVarAxiosArgs = await MetabaseApiAxiosParamCreator(configuration).getEmbedDashboard(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * MetabaseApi - factory interface
 * @export
 */
export const MetabaseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboards(options?: any): AxiosPromise<DashboardsResponse> {
            return MetabaseApiFp(configuration).getDashboards(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmbedDashboard(id: number, options?: any): AxiosPromise<EmbedDashboardResponse> {
            return MetabaseApiFp(configuration).getEmbedDashboard(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MetabaseApi - object-oriented interface
 * @export
 * @class MetabaseApi
 * @extends {BaseAPI}
 */
export class MetabaseApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetabaseApi
     */
    public getDashboards(options?: any) {
        return MetabaseApiFp(this.configuration).getDashboards(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetabaseApi
     */
    public getEmbedDashboard(id: number, options?: any) {
        return MetabaseApiFp(this.configuration).getEmbedDashboard(id, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * NotificationTemplateApi - axios parameter creator
 * @export
 */
export const NotificationTemplateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of notification templates
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllNotificationTemplates: async (page?: number, size?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/notification-templates`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return notification template
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationTemplate: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getNotificationTemplate.');
            }
            const localVarPath = `/api/settings/notification-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update notification template
         * @param {number} id 
         * @param {NotificationTemplateRequest} notificationTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationTemplate: async (id: number, notificationTemplateRequest: NotificationTemplateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateNotificationTemplate.');
            }
            // verify required parameter 'notificationTemplateRequest' is not null or undefined
            if (notificationTemplateRequest === null || notificationTemplateRequest === undefined) {
                throw new RequiredError('notificationTemplateRequest','Required parameter notificationTemplateRequest was null or undefined when calling updateNotificationTemplate.');
            }
            const localVarPath = `/api/settings/notification-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof notificationTemplateRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(notificationTemplateRequest !== undefined ? notificationTemplateRequest : {}) : (notificationTemplateRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationTemplateApi - functional programming interface
 * @export
 */
export const NotificationTemplateApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of notification templates
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllNotificationTemplates(page?: number, size?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageNotificationTemplateDto>> {
            const localVarAxiosArgs = await NotificationTemplateApiAxiosParamCreator(configuration).findAllNotificationTemplates(page, size, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return notification template
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationTemplate(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationTemplateDto>> {
            const localVarAxiosArgs = await NotificationTemplateApiAxiosParamCreator(configuration).getNotificationTemplate(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update notification template
         * @param {number} id 
         * @param {NotificationTemplateRequest} notificationTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNotificationTemplate(id: number, notificationTemplateRequest: NotificationTemplateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationTemplateDto>> {
            const localVarAxiosArgs = await NotificationTemplateApiAxiosParamCreator(configuration).updateNotificationTemplate(id, notificationTemplateRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * NotificationTemplateApi - factory interface
 * @export
 */
export const NotificationTemplateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Return list of notification templates
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllNotificationTemplates(page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PageNotificationTemplateDto> {
            return NotificationTemplateApiFp(configuration).findAllNotificationTemplates(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return notification template
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationTemplate(id: number, options?: any): AxiosPromise<NotificationTemplateDto> {
            return NotificationTemplateApiFp(configuration).getNotificationTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update notification template
         * @param {number} id 
         * @param {NotificationTemplateRequest} notificationTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationTemplate(id: number, notificationTemplateRequest: NotificationTemplateRequest, options?: any): AxiosPromise<NotificationTemplateDto> {
            return NotificationTemplateApiFp(configuration).updateNotificationTemplate(id, notificationTemplateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationTemplateApi - object-oriented interface
 * @export
 * @class NotificationTemplateApi
 * @extends {BaseAPI}
 */
export class NotificationTemplateApi extends BaseAPI {
    /**
     * 
     * @summary Return list of notification templates
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationTemplateApi
     */
    public findAllNotificationTemplates(page?: number, size?: number, sort?: Array<string>, options?: any) {
        return NotificationTemplateApiFp(this.configuration).findAllNotificationTemplates(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return notification template
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationTemplateApi
     */
    public getNotificationTemplate(id: number, options?: any) {
        return NotificationTemplateApiFp(this.configuration).getNotificationTemplate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update notification template
     * @param {number} id 
     * @param {NotificationTemplateRequest} notificationTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationTemplateApi
     */
    public updateNotificationTemplate(id: number, notificationTemplateRequest: NotificationTemplateRequest, options?: any) {
        return NotificationTemplateApiFp(this.configuration).updateNotificationTemplate(id, notificationTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ProcessDefinitionManagerApi - axios parameter creator
 * @export
 */
export const ProcessDefinitionManagerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Starts a process instance of latest definition and return reslut at first wait state. If allowed to access. The process definition has to have an extension: tag = calculator.
         * @summary Start a process instance with result in return
         * @param {string} key Process definition key
         * @param {{ [key: string]: object; }} variables Input variables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateGet: async (key: string, variables: { [key: string]: object; }, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError('key','Required parameter key was null or undefined when calling calculateGet.');
            }
            // verify required parameter 'variables' is not null or undefined
            if (variables === null || variables === undefined) {
                throw new RequiredError('variables','Required parameter variables was null or undefined when calling calculateGet.');
            }
            const localVarPath = `/api/process-definition/key/{key}/calculate`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (variables !== undefined) {
                localVarQueryParameter['variables'] = variables;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Starts a process instance of latest definition and return result at first wait state. If allowed to access. The process definition has to have an extension: tag = calculator.
         * @summary Start a process instance with result in return
         * @param {string} key Process definition key
         * @param {{ [key: string]: object; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculatePost: async (key: string, requestBody: { [key: string]: object; }, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError('key','Required parameter key was null or undefined when calling calculatePost.');
            }
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError('requestBody','Required parameter requestBody was null or undefined when calling calculatePost.');
            }
            const localVarPath = `/api/process-definition/key/{key}/calculate`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof requestBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(requestBody !== undefined ? requestBody : {}) : (requestBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List process definitions allowed to start by the user performed the request
         * @summary List process definitions allowed to start
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessDefinition: async (key: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError('key','Required parameter key was null or undefined when calling getProcessDefinition.');
            }
            const localVarPath = `/api/process-definition/key/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the process start form JSON description in FormIO format. Embedded forms are expanded in single form.
         * @summary Retrieve start form for the process
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStartForm: async (key: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError('key','Required parameter key was null or undefined when calling getStartForm.');
            }
            const localVarPath = `/api/process-definition/key/{key}/start-form`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of start form variables of a latest process definition if allowed to access.
         * @summary Retrieve start form variables
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStartFormVariables: async (key: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError('key','Required parameter key was null or undefined when calling getStartFormVariables.');
            }
            const localVarPath = `/api/process-definition/key/{key}/form-variables`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the process start form JSON description in FormIO format. Embedded forms are expanded in single form. Form variables are included into the response in FormIO structure format.
         * @summary Retrieve start form for the process with form variables included
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStartFormWithData: async (key: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError('key','Required parameter key was null or undefined when calling getStartFormWithData.');
            }
            const localVarPath = `/api/process-definition/key/{key}/start-form-with-data`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List process definitions allowed to start by the user performed the request
         * @summary List process definitions allowed to start
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStartableByUser: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/process-definition`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Starts a process instance of latest definition by form submission if allowed to access.
         * @summary Start a process instance by form submission
         * @param {string} key Process definition key
         * @param {{ [key: string]: object; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitStartFrom: async (key: string, requestBody: { [key: string]: object; }, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError('key','Required parameter key was null or undefined when calling submitStartFrom.');
            }
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError('requestBody','Required parameter requestBody was null or undefined when calling submitStartFrom.');
            }
            const localVarPath = `/api/process-definition/key/{key}/submit-form`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof requestBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(requestBody !== undefined ? requestBody : {}) : (requestBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessDefinitionManagerApi - functional programming interface
 * @export
 */
export const ProcessDefinitionManagerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Starts a process instance of latest definition and return reslut at first wait state. If allowed to access. The process definition has to have an extension: tag = calculator.
         * @summary Start a process instance with result in return
         * @param {string} key Process definition key
         * @param {{ [key: string]: object; }} variables Input variables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateGet(key: string, variables: { [key: string]: object; }, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await ProcessDefinitionManagerApiAxiosParamCreator(configuration).calculateGet(key, variables, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Starts a process instance of latest definition and return result at first wait state. If allowed to access. The process definition has to have an extension: tag = calculator.
         * @summary Start a process instance with result in return
         * @param {string} key Process definition key
         * @param {{ [key: string]: object; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculatePost(key: string, requestBody: { [key: string]: object; }, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await ProcessDefinitionManagerApiAxiosParamCreator(configuration).calculatePost(key, requestBody, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * List process definitions allowed to start by the user performed the request
         * @summary List process definitions allowed to start
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessDefinition(key: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessDefinitionRepresentation>> {
            const localVarAxiosArgs = await ProcessDefinitionManagerApiAxiosParamCreator(configuration).getProcessDefinition(key, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieves the process start form JSON description in FormIO format. Embedded forms are expanded in single form.
         * @summary Retrieve start form for the process
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStartForm(key: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await ProcessDefinitionManagerApiAxiosParamCreator(configuration).getStartForm(key, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * List of start form variables of a latest process definition if allowed to access.
         * @summary Retrieve start form variables
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStartFormVariables(key: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await ProcessDefinitionManagerApiAxiosParamCreator(configuration).getStartFormVariables(key, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieves the process start form JSON description in FormIO format. Embedded forms are expanded in single form. Form variables are included into the response in FormIO structure format.
         * @summary Retrieve start form for the process with form variables included
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStartFormWithData(key: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await ProcessDefinitionManagerApiAxiosParamCreator(configuration).getStartFormWithData(key, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * List process definitions allowed to start by the user performed the request
         * @summary List process definitions allowed to start
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStartableByUser(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProcessDefinitionRepresentation>>> {
            const localVarAxiosArgs = await ProcessDefinitionManagerApiAxiosParamCreator(configuration).listStartableByUser(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Starts a process instance of latest definition by form submission if allowed to access.
         * @summary Start a process instance by form submission
         * @param {string} key Process definition key
         * @param {{ [key: string]: object; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitStartFrom(key: string, requestBody: { [key: string]: object; }, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TaskRepresentation>>> {
            const localVarAxiosArgs = await ProcessDefinitionManagerApiAxiosParamCreator(configuration).submitStartFrom(key, requestBody, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProcessDefinitionManagerApi - factory interface
 * @export
 */
export const ProcessDefinitionManagerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Starts a process instance of latest definition and return reslut at first wait state. If allowed to access. The process definition has to have an extension: tag = calculator.
         * @summary Start a process instance with result in return
         * @param {string} key Process definition key
         * @param {{ [key: string]: object; }} variables Input variables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateGet(key: string, variables: { [key: string]: object; }, options?: any): AxiosPromise<{ [key: string]: object; }> {
            return ProcessDefinitionManagerApiFp(configuration).calculateGet(key, variables, options).then((request) => request(axios, basePath));
        },
        /**
         * Starts a process instance of latest definition and return result at first wait state. If allowed to access. The process definition has to have an extension: tag = calculator.
         * @summary Start a process instance with result in return
         * @param {string} key Process definition key
         * @param {{ [key: string]: object; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculatePost(key: string, requestBody: { [key: string]: object; }, options?: any): AxiosPromise<{ [key: string]: object; }> {
            return ProcessDefinitionManagerApiFp(configuration).calculatePost(key, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * List process definitions allowed to start by the user performed the request
         * @summary List process definitions allowed to start
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessDefinition(key: string, options?: any): AxiosPromise<ProcessDefinitionRepresentation> {
            return ProcessDefinitionManagerApiFp(configuration).getProcessDefinition(key, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the process start form JSON description in FormIO format. Embedded forms are expanded in single form.
         * @summary Retrieve start form for the process
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStartForm(key: string, options?: any): AxiosPromise<object> {
            return ProcessDefinitionManagerApiFp(configuration).getStartForm(key, options).then((request) => request(axios, basePath));
        },
        /**
         * List of start form variables of a latest process definition if allowed to access.
         * @summary Retrieve start form variables
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStartFormVariables(key: string, options?: any): AxiosPromise<{ [key: string]: object; }> {
            return ProcessDefinitionManagerApiFp(configuration).getStartFormVariables(key, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the process start form JSON description in FormIO format. Embedded forms are expanded in single form. Form variables are included into the response in FormIO structure format.
         * @summary Retrieve start form for the process with form variables included
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStartFormWithData(key: string, options?: any): AxiosPromise<object> {
            return ProcessDefinitionManagerApiFp(configuration).getStartFormWithData(key, options).then((request) => request(axios, basePath));
        },
        /**
         * List process definitions allowed to start by the user performed the request
         * @summary List process definitions allowed to start
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStartableByUser(options?: any): AxiosPromise<Array<ProcessDefinitionRepresentation>> {
            return ProcessDefinitionManagerApiFp(configuration).listStartableByUser(options).then((request) => request(axios, basePath));
        },
        /**
         * Starts a process instance of latest definition by form submission if allowed to access.
         * @summary Start a process instance by form submission
         * @param {string} key Process definition key
         * @param {{ [key: string]: object; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitStartFrom(key: string, requestBody: { [key: string]: object; }, options?: any): AxiosPromise<Array<TaskRepresentation>> {
            return ProcessDefinitionManagerApiFp(configuration).submitStartFrom(key, requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessDefinitionManagerApi - object-oriented interface
 * @export
 * @class ProcessDefinitionManagerApi
 * @extends {BaseAPI}
 */
export class ProcessDefinitionManagerApi extends BaseAPI {
    /**
     * Starts a process instance of latest definition and return reslut at first wait state. If allowed to access. The process definition has to have an extension: tag = calculator.
     * @summary Start a process instance with result in return
     * @param {string} key Process definition key
     * @param {{ [key: string]: object; }} variables Input variables
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessDefinitionManagerApi
     */
    public calculateGet(key: string, variables: { [key: string]: object; }, options?: any) {
        return ProcessDefinitionManagerApiFp(this.configuration).calculateGet(key, variables, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Starts a process instance of latest definition and return result at first wait state. If allowed to access. The process definition has to have an extension: tag = calculator.
     * @summary Start a process instance with result in return
     * @param {string} key Process definition key
     * @param {{ [key: string]: object; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessDefinitionManagerApi
     */
    public calculatePost(key: string, requestBody: { [key: string]: object; }, options?: any) {
        return ProcessDefinitionManagerApiFp(this.configuration).calculatePost(key, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List process definitions allowed to start by the user performed the request
     * @summary List process definitions allowed to start
     * @param {string} key Process definition key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessDefinitionManagerApi
     */
    public getProcessDefinition(key: string, options?: any) {
        return ProcessDefinitionManagerApiFp(this.configuration).getProcessDefinition(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the process start form JSON description in FormIO format. Embedded forms are expanded in single form.
     * @summary Retrieve start form for the process
     * @param {string} key Process definition key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessDefinitionManagerApi
     */
    public getStartForm(key: string, options?: any) {
        return ProcessDefinitionManagerApiFp(this.configuration).getStartForm(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of start form variables of a latest process definition if allowed to access.
     * @summary Retrieve start form variables
     * @param {string} key Process definition key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessDefinitionManagerApi
     */
    public getStartFormVariables(key: string, options?: any) {
        return ProcessDefinitionManagerApiFp(this.configuration).getStartFormVariables(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the process start form JSON description in FormIO format. Embedded forms are expanded in single form. Form variables are included into the response in FormIO structure format.
     * @summary Retrieve start form for the process with form variables included
     * @param {string} key Process definition key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessDefinitionManagerApi
     */
    public getStartFormWithData(key: string, options?: any) {
        return ProcessDefinitionManagerApiFp(this.configuration).getStartFormWithData(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List process definitions allowed to start by the user performed the request
     * @summary List process definitions allowed to start
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessDefinitionManagerApi
     */
    public listStartableByUser(options?: any) {
        return ProcessDefinitionManagerApiFp(this.configuration).listStartableByUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Starts a process instance of latest definition by form submission if allowed to access.
     * @summary Start a process instance by form submission
     * @param {string} key Process definition key
     * @param {{ [key: string]: object; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessDefinitionManagerApi
     */
    public submitStartFrom(key: string, requestBody: { [key: string]: object; }, options?: any) {
        return ProcessDefinitionManagerApiFp(this.configuration).submitStartFrom(key, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ScoringModelSettingsApi - axios parameter creator
 * @export
 */
export const ScoringModelSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add new version
         * @param {number} id 
         * @param {number} versionId 
         * @param {AddNewVersionRequest} addNewVersionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNewVersion: async (id: number, versionId: number, addNewVersionRequest: AddNewVersionRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling addNewVersion.');
            }
            // verify required parameter 'versionId' is not null or undefined
            if (versionId === null || versionId === undefined) {
                throw new RequiredError('versionId','Required parameter versionId was null or undefined when calling addNewVersion.');
            }
            // verify required parameter 'addNewVersionRequest' is not null or undefined
            if (addNewVersionRequest === null || addNewVersionRequest === undefined) {
                throw new RequiredError('addNewVersionRequest','Required parameter addNewVersionRequest was null or undefined when calling addNewVersion.');
            }
            const localVarPath = `/api/settings/scoring-models/{id}/versions/{versionId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof addNewVersionRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(addNewVersionRequest !== undefined ? addNewVersionRequest : {}) : (addNewVersionRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create scoring model version by modelId
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScoringModelVersion: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling createScoringModelVersion.');
            }
            const localVarPath = `/api/settings/scoring-models/{id}/create`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return internal scoring model by key
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInternalScoringModelByKey: async (key: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError('key','Required parameter key was null or undefined when calling getInternalScoringModelByKey.');
            }
            const localVarPath = `/api/settings/scoring-models/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return scoring model settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoringModelSettings: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/scoring-models`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return scoring model version content by modelId
         * @param {number} id 
         * @param {number} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoringModelVersionContent: async (id: number, versionId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getScoringModelVersionContent.');
            }
            // verify required parameter 'versionId' is not null or undefined
            if (versionId === null || versionId === undefined) {
                throw new RequiredError('versionId','Required parameter versionId was null or undefined when calling getScoringModelVersionContent.');
            }
            const localVarPath = `/api/settings/scoring-models/{id}/versions/{versionId}/content`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return scoring model version settings by modelId
         * @param {number} id 
         * @param {number} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoringModelVersionSettings: async (id: number, versionId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getScoringModelVersionSettings.');
            }
            // verify required parameter 'versionId' is not null or undefined
            if (versionId === null || versionId === undefined) {
                throw new RequiredError('versionId','Required parameter versionId was null or undefined when calling getScoringModelVersionSettings.');
            }
            const localVarPath = `/api/settings/scoring-models/{id}/versions/{versionId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return scoring model versions settings by modelId
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoringModelVersionsSettings: async (id: number, page?: number, size?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getScoringModelVersionsSettings.');
            }
            const localVarPath = `/api/settings/scoring-models/{id}/versions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return active scoring model version id
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoringModelVersionsSettingsId: async (key: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError('key','Required parameter key was null or undefined when calling getScoringModelVersionsSettingsId.');
            }
            const localVarPath = `/api/settings/scoring-models/{key}/versions/active/id`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update scoring model version content by modelId
         * @param {number} id 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScoringModelVersionContent: async (id: number, body: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateScoringModelVersionContent.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateScoringModelVersionContent.');
            }
            const localVarPath = `/api/settings/scoring-models/{id}/content`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScoringModelSettingsApi - functional programming interface
 * @export
 */
export const ScoringModelSettingsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add new version
         * @param {number} id 
         * @param {number} versionId 
         * @param {AddNewVersionRequest} addNewVersionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addNewVersion(id: number, versionId: number, addNewVersionRequest: AddNewVersionRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddNewVersionResponse>> {
            const localVarAxiosArgs = await ScoringModelSettingsApiAxiosParamCreator(configuration).addNewVersion(id, versionId, addNewVersionRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create scoring model version by modelId
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createScoringModelVersion(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScoringModelVersionSettingsDto>> {
            const localVarAxiosArgs = await ScoringModelSettingsApiAxiosParamCreator(configuration).createScoringModelVersion(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return internal scoring model by key
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInternalScoringModelByKey(key: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalScoringModelDto>> {
            const localVarAxiosArgs = await ScoringModelSettingsApiAxiosParamCreator(configuration).getInternalScoringModelByKey(key, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return scoring model settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScoringModelSettings(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScoringModelSettingsResponse>> {
            const localVarAxiosArgs = await ScoringModelSettingsApiAxiosParamCreator(configuration).getScoringModelSettings(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return scoring model version content by modelId
         * @param {number} id 
         * @param {number} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScoringModelVersionContent(id: number, versionId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScoringModelVersionContentResponse>> {
            const localVarAxiosArgs = await ScoringModelSettingsApiAxiosParamCreator(configuration).getScoringModelVersionContent(id, versionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return scoring model version settings by modelId
         * @param {number} id 
         * @param {number} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScoringModelVersionSettings(id: number, versionId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScoringModelVersionSettingsDto>> {
            const localVarAxiosArgs = await ScoringModelSettingsApiAxiosParamCreator(configuration).getScoringModelVersionSettings(id, versionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return scoring model versions settings by modelId
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScoringModelVersionsSettings(id: number, page?: number, size?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageScoringModelVersionSettingsDto>> {
            const localVarAxiosArgs = await ScoringModelSettingsApiAxiosParamCreator(configuration).getScoringModelVersionsSettings(id, page, size, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return active scoring model version id
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScoringModelVersionsSettingsId(key: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await ScoringModelSettingsApiAxiosParamCreator(configuration).getScoringModelVersionsSettingsId(key, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update scoring model version content by modelId
         * @param {number} id 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateScoringModelVersionContent(id: number, body: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ScoringModelSettingsApiAxiosParamCreator(configuration).updateScoringModelVersionContent(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ScoringModelSettingsApi - factory interface
 * @export
 */
export const ScoringModelSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Add new version
         * @param {number} id 
         * @param {number} versionId 
         * @param {AddNewVersionRequest} addNewVersionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNewVersion(id: number, versionId: number, addNewVersionRequest: AddNewVersionRequest, options?: any): AxiosPromise<AddNewVersionResponse> {
            return ScoringModelSettingsApiFp(configuration).addNewVersion(id, versionId, addNewVersionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create scoring model version by modelId
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScoringModelVersion(id: number, options?: any): AxiosPromise<ScoringModelVersionSettingsDto> {
            return ScoringModelSettingsApiFp(configuration).createScoringModelVersion(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return internal scoring model by key
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInternalScoringModelByKey(key: string, options?: any): AxiosPromise<InternalScoringModelDto> {
            return ScoringModelSettingsApiFp(configuration).getInternalScoringModelByKey(key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return scoring model settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoringModelSettings(options?: any): AxiosPromise<ScoringModelSettingsResponse> {
            return ScoringModelSettingsApiFp(configuration).getScoringModelSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return scoring model version content by modelId
         * @param {number} id 
         * @param {number} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoringModelVersionContent(id: number, versionId: number, options?: any): AxiosPromise<ScoringModelVersionContentResponse> {
            return ScoringModelSettingsApiFp(configuration).getScoringModelVersionContent(id, versionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return scoring model version settings by modelId
         * @param {number} id 
         * @param {number} versionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoringModelVersionSettings(id: number, versionId: number, options?: any): AxiosPromise<ScoringModelVersionSettingsDto> {
            return ScoringModelSettingsApiFp(configuration).getScoringModelVersionSettings(id, versionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return scoring model versions settings by modelId
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoringModelVersionsSettings(id: number, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PageScoringModelVersionSettingsDto> {
            return ScoringModelSettingsApiFp(configuration).getScoringModelVersionsSettings(id, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return active scoring model version id
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoringModelVersionsSettingsId(key: string, options?: any): AxiosPromise<number> {
            return ScoringModelSettingsApiFp(configuration).getScoringModelVersionsSettingsId(key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update scoring model version content by modelId
         * @param {number} id 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScoringModelVersionContent(id: number, body: string, options?: any): AxiosPromise<void> {
            return ScoringModelSettingsApiFp(configuration).updateScoringModelVersionContent(id, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScoringModelSettingsApi - object-oriented interface
 * @export
 * @class ScoringModelSettingsApi
 * @extends {BaseAPI}
 */
export class ScoringModelSettingsApi extends BaseAPI {
    /**
     * 
     * @summary Add new version
     * @param {number} id 
     * @param {number} versionId 
     * @param {AddNewVersionRequest} addNewVersionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoringModelSettingsApi
     */
    public addNewVersion(id: number, versionId: number, addNewVersionRequest: AddNewVersionRequest, options?: any) {
        return ScoringModelSettingsApiFp(this.configuration).addNewVersion(id, versionId, addNewVersionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create scoring model version by modelId
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoringModelSettingsApi
     */
    public createScoringModelVersion(id: number, options?: any) {
        return ScoringModelSettingsApiFp(this.configuration).createScoringModelVersion(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return internal scoring model by key
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoringModelSettingsApi
     */
    public getInternalScoringModelByKey(key: string, options?: any) {
        return ScoringModelSettingsApiFp(this.configuration).getInternalScoringModelByKey(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return scoring model settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoringModelSettingsApi
     */
    public getScoringModelSettings(options?: any) {
        return ScoringModelSettingsApiFp(this.configuration).getScoringModelSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return scoring model version content by modelId
     * @param {number} id 
     * @param {number} versionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoringModelSettingsApi
     */
    public getScoringModelVersionContent(id: number, versionId: number, options?: any) {
        return ScoringModelSettingsApiFp(this.configuration).getScoringModelVersionContent(id, versionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return scoring model version settings by modelId
     * @param {number} id 
     * @param {number} versionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoringModelSettingsApi
     */
    public getScoringModelVersionSettings(id: number, versionId: number, options?: any) {
        return ScoringModelSettingsApiFp(this.configuration).getScoringModelVersionSettings(id, versionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return scoring model versions settings by modelId
     * @param {number} id 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoringModelSettingsApi
     */
    public getScoringModelVersionsSettings(id: number, page?: number, size?: number, sort?: Array<string>, options?: any) {
        return ScoringModelSettingsApiFp(this.configuration).getScoringModelVersionsSettings(id, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return active scoring model version id
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoringModelSettingsApi
     */
    public getScoringModelVersionsSettingsId(key: string, options?: any) {
        return ScoringModelSettingsApiFp(this.configuration).getScoringModelVersionsSettingsId(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update scoring model version content by modelId
     * @param {number} id 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoringModelSettingsApi
     */
    public updateScoringModelVersionContent(id: number, body: string, options?: any) {
        return ScoringModelSettingsApiFp(this.configuration).updateScoringModelVersionContent(id, body, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * TaskManagerApi - axios parameter creator
 * @export
 */
export const TaskManagerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Assign the task to current user if available.
         * @summary Claim a task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claim: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling claim.');
            }
            const localVarPath = `/api/task/{id}/claim`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the task form JSON description in FormIO format. Embedded forms are expanded in single form.
         * @summary Retrieve form for the task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskForm: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getTaskForm.');
            }
            const localVarPath = `/api/task/{id}/form`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of task form variables of a latest process definition if allowed to access.
         * @summary Retrieve task form variables
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskFormVariables: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getTaskFormVariables.');
            }
            const localVarPath = `/api/task/{id}/form-variables`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the task form JSON description in FormIO format with form variales as submission/data. Embedded forms are expanded in single form. Form variables are included into the response in FormIO structure format.
         * @summary Retrieve form with data for the task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskFormWithData: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getTaskFormWithData.');
            }
            const localVarPath = `/api/task/{id}/form-with-data`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve brief info for a single task if available.
         * @summary Get task info
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskInfo: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getTaskInfo.');
            }
            const localVarPath = `/api/task/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List tasks assigned to a user performed the request
         * @summary List assigned tasks
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAssigned: async (page?: number, size?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/task/assigned`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List unassigned tasks where the user is a candidate for execution according to their keycloak roles. 
         * @summary List tasks available for claim
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAvailable: async (page?: number, size?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/task/available`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Complete the task by form submission if the user is assignee.
         * @summary Complete a task by form submission
         * @param {string} id Task id
         * @param {{ [key: string]: object; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitForm: async (id: string, requestBody: { [key: string]: object; }, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling submitForm.');
            }
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError('requestBody','Required parameter requestBody was null or undefined when calling submitForm.');
            }
            const localVarPath = `/api/task/{id}/submit-form`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof requestBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(requestBody !== undefined ? requestBody : {}) : (requestBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unassign the task from current user.
         * @summary Unclaim a task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unclaim: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling unclaim.');
            }
            const localVarPath = `/api/task/{id}/unclaim`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaskManagerApi - functional programming interface
 * @export
 */
export const TaskManagerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Assign the task to current user if available.
         * @summary Claim a task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async claim(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await TaskManagerApiAxiosParamCreator(configuration).claim(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieves the task form JSON description in FormIO format. Embedded forms are expanded in single form.
         * @summary Retrieve form for the task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaskForm(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await TaskManagerApiAxiosParamCreator(configuration).getTaskForm(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * List of task form variables of a latest process definition if allowed to access.
         * @summary Retrieve task form variables
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaskFormVariables(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await TaskManagerApiAxiosParamCreator(configuration).getTaskFormVariables(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieves the task form JSON description in FormIO format with form variales as submission/data. Embedded forms are expanded in single form. Form variables are included into the response in FormIO structure format.
         * @summary Retrieve form with data for the task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaskFormWithData(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await TaskManagerApiAxiosParamCreator(configuration).getTaskFormWithData(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Retrieve brief info for a single task if available.
         * @summary Get task info
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaskInfo(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskRepresentation>> {
            const localVarAxiosArgs = await TaskManagerApiAxiosParamCreator(configuration).getTaskInfo(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * List tasks assigned to a user performed the request
         * @summary List assigned tasks
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAssigned(page?: number, size?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageTaskRepresentation>> {
            const localVarAxiosArgs = await TaskManagerApiAxiosParamCreator(configuration).listAssigned(page, size, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * List unassigned tasks where the user is a candidate for execution according to their keycloak roles. 
         * @summary List tasks available for claim
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAvailable(page?: number, size?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageTaskRepresentation>> {
            const localVarAxiosArgs = await TaskManagerApiAxiosParamCreator(configuration).listAvailable(page, size, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Complete the task by form submission if the user is assignee.
         * @summary Complete a task by form submission
         * @param {string} id Task id
         * @param {{ [key: string]: object; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitForm(id: string, requestBody: { [key: string]: object; }, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TaskRepresentation>>> {
            const localVarAxiosArgs = await TaskManagerApiAxiosParamCreator(configuration).submitForm(id, requestBody, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Unassign the task from current user.
         * @summary Unclaim a task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unclaim(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await TaskManagerApiAxiosParamCreator(configuration).unclaim(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TaskManagerApi - factory interface
 * @export
 */
export const TaskManagerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Assign the task to current user if available.
         * @summary Claim a task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claim(id: string, options?: any): AxiosPromise<void> {
            return TaskManagerApiFp(configuration).claim(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the task form JSON description in FormIO format. Embedded forms are expanded in single form.
         * @summary Retrieve form for the task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskForm(id: string, options?: any): AxiosPromise<object> {
            return TaskManagerApiFp(configuration).getTaskForm(id, options).then((request) => request(axios, basePath));
        },
        /**
         * List of task form variables of a latest process definition if allowed to access.
         * @summary Retrieve task form variables
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskFormVariables(id: string, options?: any): AxiosPromise<{ [key: string]: object; }> {
            return TaskManagerApiFp(configuration).getTaskFormVariables(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the task form JSON description in FormIO format with form variales as submission/data. Embedded forms are expanded in single form. Form variables are included into the response in FormIO structure format.
         * @summary Retrieve form with data for the task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskFormWithData(id: string, options?: any): AxiosPromise<object> {
            return TaskManagerApiFp(configuration).getTaskFormWithData(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve brief info for a single task if available.
         * @summary Get task info
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskInfo(id: string, options?: any): AxiosPromise<TaskRepresentation> {
            return TaskManagerApiFp(configuration).getTaskInfo(id, options).then((request) => request(axios, basePath));
        },
        /**
         * List tasks assigned to a user performed the request
         * @summary List assigned tasks
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAssigned(page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PageTaskRepresentation> {
            return TaskManagerApiFp(configuration).listAssigned(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * List unassigned tasks where the user is a candidate for execution according to their keycloak roles. 
         * @summary List tasks available for claim
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAvailable(page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PageTaskRepresentation> {
            return TaskManagerApiFp(configuration).listAvailable(page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Complete the task by form submission if the user is assignee.
         * @summary Complete a task by form submission
         * @param {string} id Task id
         * @param {{ [key: string]: object; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitForm(id: string, requestBody: { [key: string]: object; }, options?: any): AxiosPromise<Array<TaskRepresentation>> {
            return TaskManagerApiFp(configuration).submitForm(id, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Unassign the task from current user.
         * @summary Unclaim a task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unclaim(id: string, options?: any): AxiosPromise<void> {
            return TaskManagerApiFp(configuration).unclaim(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TaskManagerApi - object-oriented interface
 * @export
 * @class TaskManagerApi
 * @extends {BaseAPI}
 */
export class TaskManagerApi extends BaseAPI {
    /**
     * Assign the task to current user if available.
     * @summary Claim a task
     * @param {string} id Task id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskManagerApi
     */
    public claim(id: string, options?: any) {
        return TaskManagerApiFp(this.configuration).claim(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the task form JSON description in FormIO format. Embedded forms are expanded in single form.
     * @summary Retrieve form for the task
     * @param {string} id Task id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskManagerApi
     */
    public getTaskForm(id: string, options?: any) {
        return TaskManagerApiFp(this.configuration).getTaskForm(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of task form variables of a latest process definition if allowed to access.
     * @summary Retrieve task form variables
     * @param {string} id Task id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskManagerApi
     */
    public getTaskFormVariables(id: string, options?: any) {
        return TaskManagerApiFp(this.configuration).getTaskFormVariables(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the task form JSON description in FormIO format with form variales as submission/data. Embedded forms are expanded in single form. Form variables are included into the response in FormIO structure format.
     * @summary Retrieve form with data for the task
     * @param {string} id Task id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskManagerApi
     */
    public getTaskFormWithData(id: string, options?: any) {
        return TaskManagerApiFp(this.configuration).getTaskFormWithData(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve brief info for a single task if available.
     * @summary Get task info
     * @param {string} id Task id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskManagerApi
     */
    public getTaskInfo(id: string, options?: any) {
        return TaskManagerApiFp(this.configuration).getTaskInfo(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List tasks assigned to a user performed the request
     * @summary List assigned tasks
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskManagerApi
     */
    public listAssigned(page?: number, size?: number, sort?: Array<string>, options?: any) {
        return TaskManagerApiFp(this.configuration).listAssigned(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List unassigned tasks where the user is a candidate for execution according to their keycloak roles. 
     * @summary List tasks available for claim
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskManagerApi
     */
    public listAvailable(page?: number, size?: number, sort?: Array<string>, options?: any) {
        return TaskManagerApiFp(this.configuration).listAvailable(page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Complete the task by form submission if the user is assignee.
     * @summary Complete a task by form submission
     * @param {string} id Task id
     * @param {{ [key: string]: object; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskManagerApi
     */
    public submitForm(id: string, requestBody: { [key: string]: object; }, options?: any) {
        return TaskManagerApiFp(this.configuration).submitForm(id, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unassign the task from current user.
     * @summary Unclaim a task
     * @param {string} id Task id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskManagerApi
     */
    public unclaim(id: string, options?: any) {
        return TaskManagerApiFp(this.configuration).unclaim(id, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * TransactionApi - axios parameter creator
 * @export
 */
export const TransactionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of loan\'s transactions
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByLoanId: async (id: number, page?: number, size?: number, sort?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling findAllByLoanId.');
            }
            const localVarPath = `/api/transactions/loan/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns list of transactions
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterTypes] Search by transaction types
         * @param {Array<string>} [filterStatuses] Search by transaction statuses
         * @param {string} [filterCreatedAtFrom] Search by transaction created at from
         * @param {string} [filterCreatedAtTo] Search by transaction created at to
         * @param {string} [filterProcessedAtFrom] Search by transaction processed at from
         * @param {string} [filterProcessedAtTo] Search by transaction processed at to
         * @param {string} [filterSearch] Search by transaction id, external transaction id; loan number; borrower\&#39;s full name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllTransactions: async (page?: number, size?: number, sort?: Array<string>, filterTypes?: Array<string>, filterStatuses?: Array<string>, filterCreatedAtFrom?: string, filterCreatedAtTo?: string, filterProcessedAtFrom?: string, filterProcessedAtTo?: string, filterSearch?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/transactions`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterTypes) {
                localVarQueryParameter['filter.types'] = filterTypes;
            }

            if (filterStatuses) {
                localVarQueryParameter['filter.statuses'] = filterStatuses;
            }

            if (filterCreatedAtFrom !== undefined) {
                localVarQueryParameter['filter.createdAtFrom'] = filterCreatedAtFrom;
            }

            if (filterCreatedAtTo !== undefined) {
                localVarQueryParameter['filter.createdAtTo'] = filterCreatedAtTo;
            }

            if (filterProcessedAtFrom !== undefined) {
                localVarQueryParameter['filter.processedAtFrom'] = filterProcessedAtFrom;
            }

            if (filterProcessedAtTo !== undefined) {
                localVarQueryParameter['filter.processedAtTo'] = filterProcessedAtTo;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return single transaction
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransaction: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getTransaction.');
            }
            const localVarPath = `/api/transactions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransactionApi - functional programming interface
 * @export
 */
export const TransactionApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of loan\'s transactions
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllByLoanId(id: number, page?: number, size?: number, sort?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageTransactionDtoBrief>> {
            const localVarAxiosArgs = await TransactionApiAxiosParamCreator(configuration).findAllByLoanId(id, page, size, sort, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns list of transactions
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterTypes] Search by transaction types
         * @param {Array<string>} [filterStatuses] Search by transaction statuses
         * @param {string} [filterCreatedAtFrom] Search by transaction created at from
         * @param {string} [filterCreatedAtTo] Search by transaction created at to
         * @param {string} [filterProcessedAtFrom] Search by transaction processed at from
         * @param {string} [filterProcessedAtTo] Search by transaction processed at to
         * @param {string} [filterSearch] Search by transaction id, external transaction id; loan number; borrower\&#39;s full name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllTransactions(page?: number, size?: number, sort?: Array<string>, filterTypes?: Array<string>, filterStatuses?: Array<string>, filterCreatedAtFrom?: string, filterCreatedAtTo?: string, filterProcessedAtFrom?: string, filterProcessedAtTo?: string, filterSearch?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageTransactionDtoBrief>> {
            const localVarAxiosArgs = await TransactionApiAxiosParamCreator(configuration).findAllTransactions(page, size, sort, filterTypes, filterStatuses, filterCreatedAtFrom, filterCreatedAtTo, filterProcessedAtFrom, filterProcessedAtTo, filterSearch, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return single transaction
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransaction(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransactionDto>> {
            const localVarAxiosArgs = await TransactionApiAxiosParamCreator(configuration).getTransaction(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TransactionApi - factory interface
 * @export
 */
export const TransactionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Return list of loan\'s transactions
         * @param {number} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByLoanId(id: number, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PageTransactionDtoBrief> {
            return TransactionApiFp(configuration).findAllByLoanId(id, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns list of transactions
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterTypes] Search by transaction types
         * @param {Array<string>} [filterStatuses] Search by transaction statuses
         * @param {string} [filterCreatedAtFrom] Search by transaction created at from
         * @param {string} [filterCreatedAtTo] Search by transaction created at to
         * @param {string} [filterProcessedAtFrom] Search by transaction processed at from
         * @param {string} [filterProcessedAtTo] Search by transaction processed at to
         * @param {string} [filterSearch] Search by transaction id, external transaction id; loan number; borrower\&#39;s full name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllTransactions(page?: number, size?: number, sort?: Array<string>, filterTypes?: Array<string>, filterStatuses?: Array<string>, filterCreatedAtFrom?: string, filterCreatedAtTo?: string, filterProcessedAtFrom?: string, filterProcessedAtTo?: string, filterSearch?: string, options?: any): AxiosPromise<PageTransactionDtoBrief> {
            return TransactionApiFp(configuration).findAllTransactions(page, size, sort, filterTypes, filterStatuses, filterCreatedAtFrom, filterCreatedAtTo, filterProcessedAtFrom, filterProcessedAtTo, filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return single transaction
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransaction(id: number, options?: any): AxiosPromise<TransactionDto> {
            return TransactionApiFp(configuration).getTransaction(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TransactionApi - object-oriented interface
 * @export
 * @class TransactionApi
 * @extends {BaseAPI}
 */
export class TransactionApi extends BaseAPI {
    /**
     * 
     * @summary Return list of loan\'s transactions
     * @param {number} id 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public findAllByLoanId(id: number, page?: number, size?: number, sort?: Array<string>, options?: any) {
        return TransactionApiFp(this.configuration).findAllByLoanId(id, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns list of transactions
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {Array<string>} [filterTypes] Search by transaction types
     * @param {Array<string>} [filterStatuses] Search by transaction statuses
     * @param {string} [filterCreatedAtFrom] Search by transaction created at from
     * @param {string} [filterCreatedAtTo] Search by transaction created at to
     * @param {string} [filterProcessedAtFrom] Search by transaction processed at from
     * @param {string} [filterProcessedAtTo] Search by transaction processed at to
     * @param {string} [filterSearch] Search by transaction id, external transaction id; loan number; borrower\&#39;s full name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public findAllTransactions(page?: number, size?: number, sort?: Array<string>, filterTypes?: Array<string>, filterStatuses?: Array<string>, filterCreatedAtFrom?: string, filterCreatedAtTo?: string, filterProcessedAtFrom?: string, filterProcessedAtTo?: string, filterSearch?: string, options?: any) {
        return TransactionApiFp(this.configuration).findAllTransactions(page, size, sort, filterTypes, filterStatuses, filterCreatedAtFrom, filterCreatedAtTo, filterProcessedAtFrom, filterProcessedAtTo, filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return single transaction
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public getTransaction(id: number, options?: any) {
        return TransactionApiFp(this.configuration).getTransaction(id, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * UISettingsApi - axios parameter creator
 * @export
 */
export const UISettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ui-settings`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication agent-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("agent-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication bo-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("bo-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication borrower-portal required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("borrower-portal", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication integration-client required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("integration-client", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication jumio required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("jumio", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication ondato required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("ondato", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UISettingsApi - functional programming interface
 * @export
 */
export const UISettingsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSettings(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UiConfigurations>>> {
            const localVarAxiosArgs = await UISettingsApiAxiosParamCreator(configuration).getSettings(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UISettingsApi - factory interface
 * @export
 */
export const UISettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings(options?: any): AxiosPromise<Array<UiConfigurations>> {
            return UISettingsApiFp(configuration).getSettings(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UISettingsApi - object-oriented interface
 * @export
 * @class UISettingsApi
 * @extends {BaseAPI}
 */
export class UISettingsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UISettingsApi
     */
    public getSettings(options?: any) {
        return UISettingsApiFp(this.configuration).getSettings(options).then((request) => request(this.axios, this.basePath));
    }

}


